(function() {
    'use strict';

    angular
        .module('cloudApp', [
            'ngStorage',
            'ngResource',
            'ngCookies',
            'ngAnimate',
            'ngAria',
            'ngTable',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'mgo-angular-wizard',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ngSanitize',
            'ui.select',
            'vcRecaptcha',
			'toaster',
			'duScroll',
            'angular-svg-round-progressbar'
        ])
        .run(run);

    run.$inject = ['stateHandler'];

    function run(stateHandler) {
        stateHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('cloudApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource(SERVER_API_URL+'api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get(SERVER_API_URL+'api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope'];

    function pageRibbon(ProfileService, $rootScope) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource(SERVER_API_URL+'api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('ResendActivation', ResendActivation);

    ResendActivation.$inject = ['$resource'];

    function ResendActivation($resource) {
        var service = $resource(SERVER_API_URL+'api/resend', {}, {});

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('cloudApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource(SERVER_API_URL+'api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            getUserEmail: getUserEmail
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }

        function getUserEmail() {
            return _authenticated ? _identity.email : null;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource(SERVER_API_URL+'api/account/reset-password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource(SERVER_API_URL+'api/account/reset-password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource(SERVER_API_URL+'api/account/change-password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .service('InviteSendService', InviteSendService);

    InviteSendService.$inject = ['$http'];

    function InviteSendService($http) {
        this.sendInvite = function sendInvite(account, company, instance){
            return $http.post(SERVER_API_URL+'api/invitedbhawk/'+company+'/'+instance, account);
        }

        this.sendInviteAdmin = function sendInvite(account, company, instance){
            return $http.post(SERVER_API_URL+'api/registerdbhawkadmin/'+company+'/'+instance, account);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('ContactUs', ContactUs);

    ContactUs.$inject = ['$resource'];

    function ContactUs($resource) {
        var service = $resource(SERVER_API_URL+'api/account/send-contact-us-form', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('CompanyRegister', CompanyRegister);

    CompanyRegister.$inject = ['$resource'];

    function CompanyRegister($resource) {
        var service = $resource(SERVER_API_URL+'api/registerdbhawk/:company/:invite',  {company: '@company', invite: '@invite'}, {
            dbhawk :{method: 'POST'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage' ];

    function AuthServerProvider ($http, $localStorage ) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post(SERVER_API_URL+'api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                return response;
            });
        }

        function logout () {

            
            // logout from the server
            $http.post(SERVER_API_URL+'api/logout').success(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get(SERVER_API_URL+'api/account');
                return response;
            });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', '$http', 'ResendActivation', 'CompanyRegister', 'ContactUs', 'AccountDeleteService'];

    function Auth ($rootScope, $state, $sessionStorage, $q, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, $http, ResendActivation, CompanyRegister, ContactUs, AccountDeleteService) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            deleteAccount: deleteAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount,
            resendActivation: resendActivation,
            registerDbhawk: registerDbhawk,
            contactUs: contactUs
        };

        return service;

        function activateAccount (verificationData, callback) {

            var cb = callback || angular.noop;

            return Activate.save(verificationData,
                function (response) {
                    authorize();
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {

            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.name === 'signin' || isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' ||
                    $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('signin').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (oldPassword, newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(
                {'oldPassword':oldPassword,
                 'newPassword': newPassword
                }, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function deleteAccount (account, callback) {
            var cb = callback || angular.noop;

            return AccountDeleteService.save(account.login,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function resendActivation (account, callback) {
            var cb = callback || angular.noop;

            return ResendActivation.save(account, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;

           /* return $http.post('/api/resend', null, null)
                .success(function (data, status, headers, config) {
                    return cb();
                })
                .error(function (data, status, header, config) {
                    return cb(err);
                }).$promise;*/

        }

        function registerDbhawk(account, company, invite, callback) {
            var cb = callback || angular.noop;

            return CompanyRegister.dbhawk({ company:company, invite: invite}, account,  function() {

                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;

        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }

        function contactUs (contactParam, callback) {
            var cb = callback || angular.noop;

            return ContactUs.save(contactParam, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate($resource) {
        var service = $resource(SERVER_API_URL+'api/activate', {}, {});

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('AccountDeleteService', AccountDeleteService);

    AccountDeleteService.$inject = ['$resource'];

    function AccountDeleteService ($resource) {
        var service = $resource(SERVER_API_URL+'api/account/disable', {}, {});

        return service;
    }


})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource(SERVER_API_URL+'api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            },
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', '$scope', 'Auth', 'Principal', 'ProfileService', 'LoginService', 'Instance', '$window', 'ConfirmBoxService', '$uibModal', 'DbhawkUserService', 'AlertService'];

    function NavbarController ($state, $scope, Auth, Principal, ProfileService, LoginService, Instance, $window, ConfirmBoxService, $uibModal, DbhawkUserService, AlertService) {
        var vm = this;


        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.userEmail = 'Account';
        if (vm.isAuthenticated) {
            vm.userEmail = Principal.getUserEmail();
        }

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
		vm.companyName = '';
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

		 /*DbhawkUserService.getCompanyDetails().then(
            function (response) {
				vm.companyName = response.data.companyName;

            }).catch(function (response) {
            AlertService.error(response);
        });*/

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

	var $win = $($window);
	// Function that find the exact height and width of the viewport in a cross-browser way
    var viewport = function () {
        var e = window, a = 'inner';
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return {
            width: e[a + 'Width'],
            height: e[a + 'Height']
        };
    };
    // function that adds information in a scope of the height and width of the page
    $scope.getWindowDimensions = function () {
        return {
            'h': viewport().height,
            'w': viewport().width
        };
    };
    // Detect when window is resized and set some variables
    $scope.$watch($scope.getWindowDimensions, function (newValue, oldValue) {
        $scope.windowHeight = newValue.h;
        $scope.windowWidth = newValue.w;
        if (newValue.w >= 992) {
            $scope.isLargeDevice = true;
        } else {
            $scope.isLargeDevice = false;
        }
        if (newValue.w < 992) {
            $scope.isSmallDevice = true;
        } else {
            $scope.isSmallDevice = false;
        }
        if (newValue.w <= 768) {
            $scope.isMobileDevice = true;
        } else {
            $scope.isMobileDevice = false;
        }
    }, true);
    // Apply on resize
    $win.on('resize', function () {
        $scope.$apply();
    });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'Error page!'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                }
            });
    }
})();


(function() {
  'use strict';
angular.module('cloudApp')
  .provider('ngIntlTelInput', function () {
    var me = this;
    var props = {};
    var setFn = function (obj) {
      if (typeof obj === 'object') {
        for (var key in obj) {
          props[key] = obj[key];
        }
      }
    };
    me.set = setFn;

    me.$get = ['$log', function ($log) {
      return Object.create(me, {
        init: {
          value: function (elm) {
            if (!window.intlTelInputUtils) {
              $log.warn('intlTelInputUtils is not defined. Formatting and validation will not work.');
            }
            elm.intlTelInput(props);
          }
        },
      });
    }];
  });
})();


(function() {
  'use strict';
angular.module('cloudApp')
  .directive('ngIntlTelInput', ['ngIntlTelInput', '$log',
    function (ngIntlTelInput, $log) {
      return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elm, attr, ctrl) {
          // Warning for bad directive usage.
          if (attr.type !== 'text' || elm[0].tagName !== 'INPUT') {
            $log.warn('ng-intl-tel-input can only be applied to a *text* input');
            return;
          }
          // Override default country.
          if (attr.defaultCountry) {
            ngIntlTelInput.set({defaultCountry: attr.defaultCountry});
          }
          // Initialize.
          ngIntlTelInput.init(elm);
          // Validation.
          // ctrl.$validators.ngIntlTelInput = function (value) {
          //   return elm.intlTelInput("isValidNumber");
          // };
          // Set model value to valid, formatted version.
          ctrl.$parsers.push(function (value) {
              var countryData = elm.intlTelInput('getSelectedCountryData');
              var formatedValue = elm.intlTelInput('getNumber');
              if (countryData && countryData.dialCode) {
                  formatedValue = elm.intlTelInput('getNumber').replace(countryData.dialCode, '(' + countryData.dialCode+ ')' );
              }
              return formatedValue
          });
          // Set input value to model value and trigger evaluation.
          ctrl.$formatters.push(function (value) {
            if (value) {
              value = value.charAt(0) === '+' || '+' + value;
              elm.intlTelInput('setNumber', value);
            }
            return value;
          });
        }
      };
    }]);
  })();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('cloudApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$http', 'Company', '$location', '$rootScope'];

    function HomeController($scope, Principal, LoginService, $state, $http, Company, $location, $rootScope) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;

        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });

        $scope.$on('activationSuccess', function (event, data) {
            getAccount();
        });


        getAccount();

        function getAccount() {
            Principal.identity().then(function (account) {

                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;

                if (account != null && vm.isAuthenticated() === true) {
                    if (Principal.hasAnyAuthority(['ROLE_USER'])) {
                        if (account.activated === true || $rootScope.activated === true) {
                            $state.go('instances');
                        } else {
                           // $state.go('instance-dbh');
                            $state.go('verify');
                        }
                    } else if (Principal.hasAnyAuthority(['ROLE_ADMIN'])) {
                        $state.go('instance-management');
                    }
                }
                else {
                    var obj = $location.search();

                    if (obj.company && obj.instance) {


                        $state.go('company');
                    }
                    else {
                        $state.go('signin');
                    }

                }
            });
        }

        function register() {
            $state.go('register');
        }

        $scope.completeCompany = function (company) {
            company.completed = true;
            Company.update(company);
            $location.path('/instance-dbh');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('SubscriptionDbhDialogController', SubscriptionDbhDialogController);

    SubscriptionDbhDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SubscriptionDbh'];

    function SubscriptionDbhDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SubscriptionDbh) {
        var vm = this;

        vm.subscriptionDbh = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.subscriptionDbh.id !== null) {
                SubscriptionDbh.update(vm.subscriptionDbh, onSaveSuccess, onSaveError);
            } else {
                SubscriptionDbh.save(vm.subscriptionDbh, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('cloudApp:subscriptionDbhUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.created = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('SubscriptionDbhDetailController', SubscriptionDbhDetailController);

    SubscriptionDbhDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SubscriptionDbh'];

    function SubscriptionDbhDetailController($scope, $rootScope, $stateParams, previousState, entity, SubscriptionDbh) {
        var vm = this;

        vm.subscriptionDbh = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('cloudApp:subscriptionDbhUpdate', function(event, result) {
            vm.subscriptionDbh = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('SubscriptionDbhDeleteController',SubscriptionDbhDeleteController);

    SubscriptionDbhDeleteController.$inject = ['$uibModalInstance', 'entity', 'SubscriptionDbh'];

    function SubscriptionDbhDeleteController($uibModalInstance, entity, SubscriptionDbh) {
        var vm = this;

        vm.subscriptionDbh = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SubscriptionDbh.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('subscription-dbh', {
            parent: 'entity',
            url: '/subscription-dbh',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'DBHawk: Subscriptions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/subscription-dbh/subscription-dbhs.html',
                    controller: 'SubscriptionDbhController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('subscription-dbh-detail', {
            parent: 'subscription-dbh',
            url: '/subscription-dbh/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'SubscriptionDbh'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/subscription-dbh/subscription-dbh-detail.html',
                    controller: 'SubscriptionDbhDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SubscriptionDbh', function($stateParams, SubscriptionDbh) {
                    return SubscriptionDbh.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'subscription-dbh',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('subscription-dbh-detail.edit', {
            parent: 'subscription-dbh-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/subscription-dbh/subscription-dbh-dialog.html',
                    controller: 'SubscriptionDbhDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SubscriptionDbh', function(SubscriptionDbh) {
                            return SubscriptionDbh.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('subscription-dbh.new', {
            parent: 'subscription-dbh',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/subscription-dbh/subscription-dbh-dialog.html',
                    controller: 'SubscriptionDbhDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                uuid: null,
                                instanceId: null,
                                amount: null,
                                userId: null,
                                created: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('subscription-dbh', null, { reload: 'subscription-dbh' });
                }, function() {
                    $state.go('subscription-dbh');
                });
            }]
        })
        .state('subscription-dbh.edit', {
            parent: 'subscription-dbh',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/subscription-dbh/subscription-dbh-dialog.html',
                    controller: 'SubscriptionDbhDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SubscriptionDbh', function(SubscriptionDbh) {
                            return SubscriptionDbh.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('subscription-dbh', null, { reload: 'subscription-dbh' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('subscription-dbh.delete', {
            parent: 'subscription-dbh',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/subscription-dbh/subscription-dbh-delete-dialog.html',
                    controller: 'SubscriptionDbhDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SubscriptionDbh', function(SubscriptionDbh) {
                            /*return {
                                id: $stateParams.id
                            };*/
                            return SubscriptionDbh.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('subscription-dbh', null, { reload: 'subscription-dbh' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('cloudApp')
        .factory('SubscriptionDbh', SubscriptionDbh);

    SubscriptionDbh.$inject = ['$resource', 'DateUtils'];

    function SubscriptionDbh ($resource, DateUtils) {
        var resourceUrl =  SERVER_API_URL+'api/subscription-dbhs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.created = DateUtils.convertDateTimeFromServer(data.created);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'delete': { method:'DELETE' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('SubscriptionDbhController', SubscriptionDbhController);

    SubscriptionDbhController.$inject = ['SubscriptionDbh','$window'];

    function SubscriptionDbhController(SubscriptionDbh, $window) {

        var vm = this;

        vm.subscriptionDbhs = [];

        vm.toggleRow = function (subs) {
            subs.selected = !subs.selected;


        };

        vm.isSelected = function (subs) {
            return subs.selected;
        };

        vm.redirectToApp = function (url) {
            $window.open(url, '_blank');
        };

        loadAll();

        function loadAll() {
            SubscriptionDbh.query(function(result) {
                vm.subscriptionDbhs = result;
                vm.searchQuery = null;
                vm.subscriptionDbhs[0].selected=true;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('RegionDialogController', RegionDialogController);

    RegionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Region'];

    function RegionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Region) {
        var vm = this;

        vm.region = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.region.id !== null) {
                Region.update(vm.region, onSaveSuccess, onSaveError);
            } else {
                Region.save(vm.region, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('cloudApp:regionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('RegionDetailController', RegionDetailController);

    RegionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Region'];

    function RegionDetailController($scope, $rootScope, $stateParams, previousState, entity, Region) {
        var vm = this;

        vm.region = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('cloudApp:regionUpdate', function(event, result) {
            vm.region = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('RegionDeleteController',RegionDeleteController);

    RegionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Region'];

    function RegionDeleteController($uibModalInstance, entity, Region) {
        var vm = this;

        vm.region = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Region.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('region', {
            parent: 'entity',
            url: '/region',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Regions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/region/regions.html',
                    controller: 'RegionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('region-detail', {
            parent: 'region',
            url: '/region/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Region'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/region/region-detail.html',
                    controller: 'RegionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Region', function($stateParams, Region) {
                    return Region.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'region',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('region-detail.edit', {
            parent: 'region-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/region/region-dialog.html',
                    controller: 'RegionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Region', function(Region) {
                            return Region.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('region.new', {
            parent: 'region',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/region/region-dialog.html',
                    controller: 'RegionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                label: null,
                                ami: null,
                                orderPos: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('region', null, { reload: 'region' });
                }, function() {
                    $state.go('region');
                });
            }]
        })
        .state('region.edit', {
            parent: 'region',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/region/region-dialog.html',
                    controller: 'RegionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Region', function(Region) {
                            return Region.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('region', null, { reload: 'region' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('region.delete', {
            parent: 'region',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/region/region-delete-dialog.html',
                    controller: 'RegionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Region', function(Region) {
                            return Region.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('region', null, { reload: 'region' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('cloudApp')
        .factory('Region', Region);

    Region.$inject = ['$resource'];

    function Region ($resource) {
        var resourceUrl =  SERVER_API_URL+'api/regions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('RegionController', RegionController);

    RegionController.$inject = ['Region'];

    function RegionController(Region) {

        var vm = this;

        vm.regions = [];

        loadAll();

        function loadAll() {
            Region.query(function(result) {
                vm.regions = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('PeeringDialogController', PeeringDialogController);

    PeeringDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Peering', 'DbhawkPeeringService', 'Region'];

    function PeeringDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Peering, DbhawkPeeringService, Region) {
        var vm = this;

        vm.peering = entity;

        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        Region.query(function(result) {
            vm.regions = result;
            vm.peering.region = vm.regions[0];
        });

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            DbhawkPeeringService.createPeering(vm.peering, vm.peering.instanceId).then(function(response) {
                vm.success = 'OK';
                $uibModalInstance.close(true);
            })
                .catch(function(response) {
                    vm.isSaving = false;
                    vm.error = 'ERROR';
            });

        }

        function onSaveSuccess (result) {
            $scope.$emit('cloudApp:peeringUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.created = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('PeeringDetailController', PeeringDetailController);

    PeeringDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Peering', 'Vpc'];

    function PeeringDetailController($scope, $rootScope, $stateParams, previousState, entity, Peering, Vpc) {
        var vm = this;

        vm.peering = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('cloudApp:peeringUpdate', function(event, result) {
            vm.peering = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('PeeringDeleteController',PeeringDeleteController);

    PeeringDeleteController.$inject = ['$uibModalInstance', 'entity', 'Peering'];

    function PeeringDeleteController($uibModalInstance, entity, Peering) {
        var vm = this;

        vm.peering = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (peeringId) {
            Peering.delete({id: peeringId},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .service('DbhawkPeeringService', DbhawkPeeringService);

    DbhawkPeeringService.$inject = ['$http'];

    function DbhawkPeeringService($http) {

        this.createPeering = function createPeering(peering, instance){
            return $http.post(SERVER_API_URL+'api/peerings/'+instance, peering);
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('cloudApp')
        .factory('Peering', Peering);

    Peering.$inject = ['$resource', 'DateUtils'];

    function Peering ($resource, DateUtils) {
        var resourceUrl =  SERVER_API_URL+'api/peerings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.created = DateUtils.convertDateTimeFromServer(data.created);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('PeeringController', PeeringController);

    PeeringController.$inject = ['Peering', 'DbhawkPeeringService'];

    function PeeringController(Peering, DbhawkPeeringService) {

        var vm = this;

        vm.peerings = [];

        loadAll();

        function loadAll() {
            Peering.query(function(result) {
                vm.peerings = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('cloudApp')
        .controller('IpAddressDialogController', IpAddressDialogController);

    IpAddressDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Peering', 'DbhawkIpAddressService', '$http'];

    function IpAddressDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Peering, DbhawkIpAddressService, $http) {
        var vm = this;

        vm.clear = clear;
        vm.save = save;
        vm.change = change;
        vm.ipAddressOptions = ["Custom", "Anywhere", "My IP"];
        vm.ipAddressOption = vm.ipAddressOptions[0];
        vm.ipAddress = "0.0.0.0/0";

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function change() {
            if (vm.ipAddressOption === vm.ipAddressOptions[1]) {
                vm.ipAddress = "0.0.0.0/0";
            } else if (vm.ipAddressOption === vm.ipAddressOptions[2]) {
                $http.get("https://api.ipify.org/?format=json").then(function (response) {
                    vm.ipAddress = response.data.ip + "/32";
                });
            }
        }

        function save() {
            vm.isSaving = true;
            vm.error = null;

            DbhawkIpAddressService.addIpAddress(vm.ipAddress, $stateParams.instanceId).then(function (response) {
                vm.success = 'OK';
                $uibModalInstance.close(true);
            }).catch(function (response) {
                vm.isSaving = false;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('IpAddressDeleteController', IpAddressDeleteController);

    IpAddressDeleteController.$inject = ['$uibModalInstance', 'entity', 'DbhawkIpAddressService'];

    function IpAddressDeleteController($uibModalInstance, entity, DbhawkIpAddressService) {
        var vm = this;

        vm.entity = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (instanceId, ipAddress) {
            DbhawkIpAddressService.deleteIpAddress(instanceId, ipAddress).then(function (response) {
                $uibModalInstance.close(true);
            }).catch(function (response) {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('cloudApp')
        .service('DbhawkIpAddressService', DbhawkIpAddressService);

    DbhawkIpAddressService.$inject = ['$http'];

    function DbhawkIpAddressService($http) {

        this.addIpAddress = function addIpAddress(ipAddress, instanceId) {
            return $http.post(SERVER_API_URL+'api/ipaddress/' + instanceId, ipAddress);
        };

        this.deleteIpAddress = function deleteIpAddress(instanceId, ipAddress) {
            return $http.post(SERVER_API_URL+'api/ipaddress/delete/' + instanceId, ipAddress);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('payment', {
                parent: 'entity',
                url: '/payment/new/{instance}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'DBHawk: Payment'
                },

                views: {
                    'content@': {
                        templateUrl: 'app/entities/instance-dbh/payment/card-form.html',
                        controller: 'CardFormController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', function($stateParams) {
                        return {
                            instance: $stateParams.instance
                        }
                    }]
                }

            })
            ;
    }

})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .service('PaymentService', PaymentService);

    PaymentService.$inject = ['$http'];

    function PaymentService($http) {

        this.sendPayment = function sendInvite(token){
            return $http.post(SERVER_API_URL+'api/payments', token);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('CardFormController', CardFormController);

    CardFormController.$inject = ['$scope', '$state', '$rootScope',  '$stateParams', 'entity',  'PaymentService', 'Account'];

    function CardFormController($scope, $state, $rootScope,  $stateParams, entity,  PaymentService, Account ) {
        var vm = this;


        vm.userPrice = 30;
        vm.userPriceOne = 50;
        vm.payment = {amount:3};

        vm.payment.instance = entity.instance;

        var elements = stripe.elements();

        vm.totalCost = 0;//?():vm.userPriceOne;

        if(vm.payment.amount == 1){
            vm.totalCost = vm.userPrice*vm.payment.amount;
        }
        else{
            vm.totalCost = vm.userPriceOne;
        }


        function getAccountThen (account) {
            vm.account = account.data;
            vm.payment.email = vm.account.email;
        }

        Account.get().$promise.then(getAccountThen);


        $scope.loadForm = function loadForm() {





            var style = {
                base: {
                    iconColor: '#666EE8',
                    color: '#31325F',
                    fontWeight: 300,
                    fontFamily: 'Ubuntu, sans-serif',
                    fontSize: '14px',
                    '::placeholder': {
                        color: '#CFD7E0',
                    },
                },
            };

            vm.cardNumberElement = elements.create('cardNumber', {
                style: style
            });
            vm.cardNumberElement.mount('#card-number-element');

            vm.cardExpiryElement = elements.create('cardExpiry', {
                style: style
            });
            vm.cardExpiryElement.mount('#card-expiry-element');

            vm.cardCvcElement = elements.create('cardCvc', {
                style: style
            });
            vm.cardCvcElement.mount('#card-cvc-element');

            vm.cardNumberElement.on('change', function(event) {
                // setOutcome(event);
            });

// Handle form submission.
            var form = document.getElementById('payment-form');
            form.addEventListener('submit', function (event) {
                event.preventDefault();

                var options = {
                    address_zip: document.getElementById('postal-code').value
                };

                stripe.createToken(vm.cardNumberElement, options).then(function (result) {
                    if (result.error) {
                        // Inform the user if there was an error.
                        //var errorElement = document.getElementById('card-errors');
                        //errorElement.textContent = result.error.message;
                        $scope.cardError = result.error.message;
                        vm.error = 'error';
                        vm.cardNumberElement.clear();
                        vm.cardExpiryElement.clear();
                        vm.cardCvcElement.clear();

                    } else {
                        // Send the token to your server.
                        stripeTokenHandler(result.token);
                    }
                });
            });




        }


        function setOutcome(result) {
            if (result.error) {
                $scope.cardError = result.error.message;
                }
            else{
                $scope.cardError = null;
            }

        }

        function stripeTokenHandler(token) {
            // Submit the form
            //form.submit();
            vm.error = null;
            $scope.cardError = null;
            vm.errorUsers = null;
            vm.isSaving = true;
            vm.payment.token = token.id;
            PaymentService.sendPayment(vm.payment).then(function (response) {
                vm.success = 'OK';
                vm.isSaving = false;
                $state.go('subscription-dbh');

            }).catch(function (response) {

                if (response.status === 500 && angular.fromJson(response.data).detail === "users") {
                    vm.errorUsers = 'ERROR';
                }
                else{
                    vm.error = 'ERROR';
                }
                vm.isSaving = false;

                vm.cardNumberElement.clear();
                vm.cardExpiryElement.clear();
                vm.cardCvcElement.clear();
            });
        }


        $scope.loadForm();

    }
})();

(function () {
    'use strict';

    angular
        .module('cloudApp')
        .controller('InviteController', InviteController);

    InviteController.$inject = ['$scope', '$rootScope', '$uibModalInstance', '$stateParams', 'entity', 'InviteSendService', '$window', 'AlertService', 'Account'];

    function InviteController($scope, $rootScope, $uibModalInstance, $stateParams, entity, InviteSendService, $window, AlertService, Account) {
        var vm = this;

        vm.params = entity;

        vm.account = {};

        vm.clear = function clear() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.invite = function () {
            vm.isSaving = true;
            InviteSendService.sendInvite(vm.account, vm.params.company, vm.params.instance).then(function (response) {
                vm.success = 'OK';
                $uibModalInstance.close(true);
                AlertService.success('Invitation sent');
            }).catch(function (response) {
                    vm.error = 'ERROR';
                    AlertService.error(response);
                });
        };

        function getAccountThen (account) {
            vm.account = account.data;
            vm.account.email = '';
        }

        Account.get().$promise
            .then(getAccountThen);

        vm.inviteAdmin = function () {
            vm.isSaving = true;
            InviteSendService.sendInviteAdmin(vm.account, vm.params.company, vm.params.instance).then(function (response) {
                vm.success = 'OK';
                $window.open($stateParams.dbhawkUrl+"/?cuser="+vm.account.login, '_blank');
                $uibModalInstance.close(true);

            }).catch(function (response) {
                vm.error = 'ERROR';
                vm.isSaving = false;
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('InstanceDbhDialogController', InstanceDbhDialogController);

    InstanceDbhDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Instance', 'Vpc'];

    function InstanceDbhDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Instance, Vpc) {
        var vm = this;

        vm.instance = entity;
        vm.instance.region = "us-east-1";
        vm.instance.cidrBlock = "172.10.0.0/16";
        vm.clear = clear;
        vm.save = save;
        vm.vpcs = Vpc.query({filter: 'instance-is-null'});
        $q.all([vm.instance.$promise, vm.vpcs.$promise]).then(function() {
            if (!vm.instance.vpcId) {
                return $q.reject();
            }
            return Vpc.get({id : vm.instance.vpcId}).$promise;
        }).then(function(vpc) {
            vm.vpcs.push(vpc);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.instance.id !== null) {
                Instance.update(vm.instance, onSaveSuccess, onSaveError);
            } else {
                Instance.save(vm.instance, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('cloudApp:instanceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('InstanceDbhDetailController', InstanceDbhDetailController);

    InstanceDbhDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Instance', 'Vpc'];

    function InstanceDbhDetailController($scope, $rootScope, $stateParams, previousState, entity, Instance, Vpc) {
        var vm = this;

        vm.instance = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('cloudApp:instanceUpdate', function(event, result) {
            vm.instance = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('InstanceDbhDeleteController',InstanceDbhDeleteController);

    InstanceDbhDeleteController.$inject = ['$uibModalInstance', 'entity', 'Instance'];

    function InstanceDbhDeleteController($uibModalInstance, entity, Instance) {
        var vm = this;

        vm.instance = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Instance.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('verify', {
                parent: 'entity',
                url: '/verify',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'DBHawk Cloud Application'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/instance-dbh/verify.html',
                        controller: 'InstanceDbhController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                }
            })
        .state('instance-dbh', {
            parent: 'entity',
            url: '/instance-dbh?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'DBHawk Cloud Application'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/instance-dbh/instancesdbh.html',
                    controller: 'InstanceDbhController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        }).state('instances', {
                parent: 'entity',
                url: '/instances?page&sort&search&tab',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'DBHawk: Instances'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/instance-dbh/instancesdbh-list.html',
                        controller: 'InstanceListDbhController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                }
            }).state('instances.full_access', {
                parent: 'instances',
                url: '/full-access',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'DBHawk: Full Access'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/instance-dbh/full-access-form.html',
                        controller: 'InstanceListDbhController',
                        controllerAs: 'vm'
                    }
                }
            })
        .state('instance-dbh-detail', {
            parent: 'instance-dbh',
            url: '/instance-dbh/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Instance'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/instance-dbh/instance-dbh-detail.html',
                    controller: 'InstanceDbhDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Instance', function($stateParams, Instance) {
                    return Instance.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'instance-dbh',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('instance-dbh-detail.edit', {
            parent: 'instance-dbh-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instance-dbh/instance-dbh-dialog.html',
                    controller: 'InstanceDbhDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Instance', function(Instance) {
                            return Instance.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('instance-dbh.new', {
            parent: 'instance-dbh',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instance-dbh/instance-dbh-dialog.html',
                    controller: 'InstanceDbhDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                instanceId: null,
                                name: null,
                                active: null,
                                cidrBlock: null,
                                dbhawkUrl: null,
                                publicDns: null,
                                region: null,
                                securityGrp: null,
                                status: null,
                                subnetId: null,
                                tag: null,
                                userId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('instance-dbh', null, { reload: 'instance-dbh' });
                }, function() {
                    $state.go('instance-dbh');
                });
            }]
        })
        .state('instance-dbh.edit', {
            parent: 'instance-dbh',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instance-dbh/instance-dbh-dialog.html',
                    controller: 'InstanceDbhDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Instance', function(Instance) {
                            return Instance.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('instance-dbh', null, { reload: 'instance-dbh' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('instance-dbh.delete', {
            parent: 'instance-dbh',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instance-dbh/instance-dbh-delete-dialog.html',
                    controller: 'InstanceDbhDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Instance', function(Instance) {
                            return Instance.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('instance-dbh', null, { reload: 'instance-dbh' });
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('instances.invite', {
            parent: 'instances',
            url: '/{company}/{instance}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/instance-dbh/invite.html',
                    controller: 'InviteController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['Instance', function(Instance) {
                             return {
                                instance: $stateParams.instance,
                                company: $stateParams.company
                            };//Instance.get({id : $stateParams.id, company:$stateParams.company}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('instances', null, { reload: 'instances' });
                }, function() {
                    $state.go('instances');
                });
            }]
        }).state('instances.admin', {
                parent: 'instances',
                url: '/admin/{company}/{instance}/{dbhawkUrl}',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/instance-dbh/inviteAdmin.html',
                        controller: 'InviteController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            entity: ['Instance', function(Instance) {
                                return {
                                    instance: $stateParams.instance,
                                    company: $stateParams.company
                                };
                            }]
                        }
                    }).result.then(function() {
                        $state.go('instances', null, { reload: 'instances' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            }).state('instances.peering1', {
            parent: 'instances',
            url: '/peering/new/{instanceId}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/peering/peering-dialog.html',
                    controller: 'PeeringDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        /*entity: ['Peering', function(Peering) {
                            return {
                                instanceId: $stateParams.instanceId
                            };
                        }]*/
                        entity: function () {
                            return {
                                instanceId: $stateParams.instanceId
                            };
                        }


                    }
                }).result.then(function() {
                    $state.go('instances', {tab: 'peering'}, { reload: 'instances' });
                }, function() {
                    $state.go('instances');
                });
            }]
        }).state('instances.peeringdelete', {
                parent: 'instances',
                url: '/peering/delete/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/peering/peering-delete-dialog.html',
                        controller: 'PeeringDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Peering', function(Peering) {
                                return Peering.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('instances', null, { reload: 'instances' });
                    }, function() {
                        $state.go('^');
                    });
                }]
        }).state('instances.ipaddress', {
            parent: 'instances',
            url: '/ipaddress/add/{instanceId}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ipaddress/ipaddress-dialog.html',
                    controller: 'IpAddressDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                instanceId: $stateParams.instanceId
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('instances', {tab: 'addresses'}, { reload: 'instances' });
                }, function() {
                    $state.go('instances');
                });
            }]
        }).state('instances.ipaddressdelete', {
            parent: 'instances',
            url: '/ipaddress/delete/{instanceId}/{ipAddress}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ipaddress/ipaddress-delete-dialog.html',
                    controller: 'IpAddressDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                instanceId: $stateParams.instanceId,
                                ipAddress: $stateParams.ipAddress
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('instances', null, { reload: 'instances' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('cloudApp')
        .factory('Instance', Instance);

    Instance.$inject = ['$resource'];

    function Instance ($resource) {
        var resourceUrl =  SERVER_API_URL+'api/instances/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('cloudApp')
        .controller('InstanceListDbhController', InstanceListDbhController);

    InstanceListDbhController.$inject = ['$state', 'Instance', 'ParseLinks', 'AlertService',
        'paginationConstants', 'pagingParams', '$interval', '$scope', 'Principal', 'Account',
        '$window', '$location', 'InviteSendService', 'DbhawkUserService', '$timeout', '$filter',
        'ngTableParams', '$http', 'InstanceActionService', 'Auth', 'toaster', 'errorConstants' ];

    function InstanceListDbhController($state, Instance, ParseLinks, AlertService,
                                       paginationConstants, pagingParams, $interval, $scope, Principal, Account,
                                       $window, $location, InviteSendService, DbhawkUserService, $timeout, $filter,
                                       ngTableParams, $http, InstanceActionService, Auth, toaster, errorConstants) {

        var vm = this;


        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.startInstance = startInstance;
        vm.contact = contact;
        vm.launchPersInstance = launchPersInstance;
		vm.showfullAccess = showfullAccess;
        vm.demoOnly = true;
        vm.sentRequest = false;
		vm.showAccess = false;
		vm.showButton = false;
        vm.allowDemoOnly = true;

        vm.instanceStartWait = false;
        vm.showInstancePanel = false;
        vm.showAccessDBHawkBtn = false;
        vm.showInviteUsersBtn = false;
        vm.maxLicenseDays = trialDays;
        vm.dynamicValue = 0;

	    vm.job = {};
        vm.jobs = [
            {name: 'IT Executive (CIO, CTO, VP Engineering, etc.)', code: 'IT_EXECUTIVE'},
            {name: 'Business Executive (CEO, COO, CMO, etc.)', code: 'BUSINESS_EXECUTIVE'},
            {name: 'Architect', code: 'ARCHITECT'},
            {name: 'Business Development / Alliance Manager', code: 'BUSINESS_DEVELOPMENT'},
            {name: 'DBA', code: 'DBA'},
            {name: 'Director / Development Manager', code: 'DIRECTOR'},
            {name: 'Product / Project Manager', code: 'PM'},
            {name: 'Software Developer / Engineer', code: 'DEVELOPER'},
            {name: 'Business Analyst', code: 'BA'},
            {name: 'Data Scientist', code: 'DATA_SCIENTIST'},
            {name: 'Student', code: 'STUDENT'},
            {name: 'Other', code: 'OTHER'}
        ];

		vm.database = [
            {name: 'Oracle', code: 'ORACLE', ticked: false},
            {name: 'SQL Server', code: 'SQL_SERVER', ticked: false},
            {name: 'MySQL', code: 'MYSQL', ticked: false},
            {name: 'PostgreSQL', code: 'POSTGRESQL', ticked: false},
			{name: 'MongoDB', code: 'MONGODB', ticked: false},
            {name: 'IBM DB2', code: 'DB2', ticked: false},
            {name: 'Greenplum', code: 'GREENPLUM', ticked: false},
            {name: 'Apache Spark', code: 'Apache_Spark', ticked: false},
            {name: 'Teradata', code: 'TERADATA', ticked: false},
            {name: 'SAP Hana', code: 'SAP_HANA', ticked: false},
            {name: 'AWS RDS', code: 'AWS_RDS', ticked: false},
            {name: 'Azure MS SQL', code: 'AZURE_MS_SQL', ticked: false},
            {name: 'Amazon Athena', code: 'Athena', ticked: false},
            {name: 'AWS DynamoDB', code: 'DynamoDB', ticked: false},
            {name: 'Cassandra', code: 'Cassandra', ticked: false},
            {name: 'Presto', code: 'Presto', ticked: false},
            {name: 'Snowflake', code: 'Snowflake', ticked: false},
            {name: 'Vertica', code: 'Vertica', ticked: false},
            {name: 'Redshift', code: 'REDSHIFT', ticked: false},
            {name: 'Hadoop Hive', code: 'HADOOP_HIVE', ticked: false},
            {name: 'Other', code: 'OTHER', ticked: false}
        ];

        vm.contactParam = {};

        /*Principal.identity().then(function(account) {
            vm.account = account;
            var id = account.id;

        });*/

        DbhawkUserService.getCompanyDetails().then(
            function (response) {
                var data = response.data;
                vm.allowDemoOnly = data.demoOnly;

            }).catch(function (response) {
            AlertService.error(response);
        });



        var tab = $location.search().tab;

        $scope.mValue = tab == null ? 'details' : tab;




        $scope.toggleRow = function (instance) {
            instance.selected = !instance.selected;
        };



        $scope.isSelected = function (instance) {
            return instance.selected;
        };

        $scope.redirectToApp = function () {
            DbhawkUserService.getRedirectToAppUrl().then(
                function (response) {
                    var data = response.data;
                    $window.open(data.urlOpen, '_blank');
                }).catch(function (response) {
                AlertService.error(response);
            });
        };

        function getAccountThen(account) {
            vm.account = account.data;
        }

        vm.contactParam.email = Principal.getUserEmail();

        vm.contactParam.installInstanceAgreement = true;

        Account.get().$promise.then(getAccountThen);

        loadAll();

        function loadAll() {

            Instance.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.instancesPeering = data;

                if (vm.totalItems == 0) {
                    $state.go('verify');
                }


                var host = $location.host;
                var protocol = $location.protocol();


                vm.instances = [];

                angular.forEach(vm.instancesPeering, function (value, key) {
                    value.instance.peering = value.peeringList;
                    value.instance.ipAddresses = value.ipAddresses;
                    vm.instances.push(value.instance);
                });


                vm.errorInstanceDetails = null;
                angular.forEach(vm.instances, function (value, key) {
                    value.signup = protocol + "://" + location.host + "/#/company?company=" + vm.account.lastName + "&instance=" + value.instanceId;
                    vm.onlyDemo = value.demoInstance;
					//vm.contactParam.company_name = value.tag;
                    vm.sentRequest = value.sentPersReq;

                    vm.instanceStatus = 'n/a';
                    vm.showInstancePanel = false;

                    if(value.status == 'stopped'){
                        vm.instanceStatus = 'stopped';
                    }else
                    /*if(value.status == 'running initializing'){
                        vm.instanceStatus = 'initializing';
                    }
                    else*/
                    if (value.status != 'N/A') {
                        vm.instanceStatus = null;
                        vm.showInstancePanel = value.status === 'running ok';
                        vm.showAccessDBHawkBtn = value.dbhawkUrl !== 'N/A';
                        vm.showInviteUsersBtn = value.dbhawkUrl !== 'N/A' && value.adminRegister === true;

                        if (value.starting === true) {
                            vm.instanceStartWait = true;
                            checkInstanceStatus(value.instanceId);
                            return;
                        }

                        DbhawkUserService.getUsersForInstance(value.instanceId).then(function (response) {
                            var data = response.data;
                            value.users = data.users;
                            value.license = data.license;
                            $scope.allUsers = data.users;
                            $scope.peerings = value.peering;
                            $scope.ipAddresses = value.ipAddresses;
                            value.selected = vm.showInstancePanel;

                            vm.dynamicValue = value.trialDays - value.license.daysRemain;

                            if(value.license.daysRemain<0){
                                value.license.daysRemain =0;
                            }



                           // $('#indicatorContainerTrial').radialIndicator();



                            DbhawkUserService.getRedirectToAppUrl().then(
                                function (response) {
                                    var data = response.data;
                                    // $window.open(data.urlOpen, '_blank');
                                    value.urlOpen = data.urlOpen;

                                }).catch(function (response) {
                                AlertService.error(response);
                            });
                        }).catch(function (response) {
                            vm.errorInstanceDetails = 'ERROR';
                        });
                    } else {
                        vm.instanceStatus = 'n/a';
                        vm.showInstancePanel = false;
                        if (value.starting === true) {
                            vm.instanceStartWait = true;
                            vm.showInstancePanel = false;
                            vm.showAccessDBHawkBtn = true;
                            vm.showInviteUsersBtn = true;
                            checkInstanceStatus(value.instanceId);
                        }
                    }
                });

                vm.page = pagingParams.page;
                vm.lastRefreshed = new Date();
            }

            function onError(error) {
                vm.errorInstance = 'ERROR';
                AlertService.error(error.data.message);
            }
        }

        $scope.getInstances = function () {
            loadAll();
        };

        /*var promise = $interval($scope.getInstances, 60*1000);

        $scope.$on('$destroy',function(){
            if(promise)
                $interval.cancel(promise);
        });*/

        vm.showAllStatuses = false;

        $scope.usersFilter = function (item) {
            if (vm.showAllStatuses) {
                return true;
            }
            else {
                return item.status == 'active';
            }
        };

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function startInstance(instance) {
            InstanceActionService.startInstance(instance.instanceId).then(function (response) {
                instance.stoppedByInactive = false;
                vm.instanceStartWait = true;
                vm.showAccessDBHawkBtn = true;
                vm.showInviteUsersBtn = true;
                checkInstanceStatus(instance.instanceId);
            }).catch(function (response) {
                vm.errorInstanceDetails = 'ERROR';
            });
        }

        function checkInstanceStatus(instanceId) {
            setTimeout(function () {
                Instance.get({id: instanceId}, function (data) {
                    if (data.status === 'running ok') {
                        $state.reload();
                    } else {
                        checkInstanceStatus(instanceId);
                    }
                });
            }, 20000);
        }

        $scope.tableParams = new ngTableParams({
            page: 1, // show first page
            count: 1, // count per page
            sorting: {
                id: 'asc' // initial sorting
            }
        }, {
            getData: function ($defer, params) {
//
                $scope.allUsers = $filter('orderBy')($scope.allUsers, params.orderBy());
                $defer.resolve($scope.allUsers.slice((params.page() - 1) * params.count(), params.page() * params.count()));

            }
        });

        $scope.tablePeeringParams = new ngTableParams({
            page: 1, // show first page
            count: 1, // count per page
            sorting: {
                peeringId: 'asc' // initial sorting
            }
        }, {
            getData: function ($defer, params) {
//
                $scope.peerings = $filter('orderBy')($scope.peerings, params.orderBy());
                $defer.resolve($scope.peerings.slice((params.page() - 1) * params.count(), params.page() * params.count()));

            }
        });

        vm.processDomain = function () {
            vm.contactParam.domain = vm.contactParam.company_name.replace(/[^a-z0-9]/gi, '').toLowerCase();
        }

        function contact (instanceId) {
            vm.errorCompanyExists = null;
            vm.error = null;
            vm.contactParam.message = "Request to install personalized instance";
			vm.contactParam.job = vm.job.selected.code;
		    vm.contactParam.dbs = [];
            /*if (vm.multipledb.databases) {
                vm.contactParam.selectedDbs = vm.multipledb.databases.map(function(a) {return a.code;}) ;
            }*/


            angular.forEach(vm.database, function (value, key) {
               if(value.checked==true){
                   vm.contactParam.dbs.push(value.code);
               }

            });



            //InstanceActionService.markSentReq(instanceId).then(function (response) {

                vm.contactParam.instanceId = instanceId;

                Auth.contactUs(vm.contactParam).then(function () {
                    vm.contactParam = {};
					vm.job.selected = '';
                    vm.error = null;
                    vm.success = 'OK';
                    vm.collapse = false;
                    vm.submitedPersReq = true;
                    vm.sentRequest = true;

					 $state.go('thank-you');

                }).catch(function (response) {
                    vm.success = null;

                    if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.COMPANY_ALREADY_USED_TYPE) {
                        vm.errorCompanyExists = 'ERROR';
                    }
                    else
                    vm.error = 'ERROR';

                    $window.scrollTo(0, 0);
                });

            /*}).catch(function (response) {
                vm.errorInstanceDetails = 'ERROR';
            });*/


        }

        function launchPersInstance() {
            $location.path('/instance-dbh');
        }

		function showfullAccess(){
			vm.showButton = true;
			vm.showAccess = true;
		}

        $scope.getStyle = function(){
            var transform = ( 'translateY(-50%) ') + 'translateX(-50%)';

            return {
                'top' : '50%',
                'bottom' : 'auto',
                'left': '50%',
                'transform': transform,
                '-moz-transform': transform,
                '-webkit-transform': transform,
                'font-size': 16 + 'px'
            };
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('InstanceDbhController', InstanceDbhController);

    InstanceDbhController.$inject = ['$state', 'Instance', 'ParseLinks', 'AlertService',
        'paginationConstants', 'pagingParams', '$interval', '$scope', 'Principal', 'Account', '$window', '$location',
        'InviteSendService', 'DbhawkUserService', 'Region', 'WizardHandler', 'Auth', '$uibModal', '$rootScope', '$http'];

    function InstanceDbhController($state, Instance, ParseLinks, AlertService, paginationConstants,
                                   pagingParams, $interval, $scope, Principal, Account, $window,
                                   $location, InviteSendService, DbhawkUserService, Region, WizardHandler,
                                   Auth, $uibModal, $rootScope, $http) {

        var vm = this;


        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.disabledConfig = false;
        vm.disabledKey = false;
        vm.verificationData = {};

        vm.instance = {};
        vm.region = {name:"us-east-1"};
        vm.instance.cidrBlock = "172.10.0.0/16";
        vm.instance.userIp = null;
        vm.instance.accessOnlyToUserIp = true;


        vm.job = {};
        vm.jobs = [
            {name: 'IT Executive (CIO, CTO, VP Engineering, etc.)', code: 'IT_EXECUTIVE'},
            {name: 'Business Executive (CEO, COO, CMO, etc.)', code: 'BUSINESS_EXECUTIVE'},
            {name: 'Architect', code: 'ARCHITECT'},
            {name: 'Business Development / Alliance Manager', code: 'BUSINESS_DEVELOPMENT'},
            {name: 'DBA', code: 'DBA'},
            {name: 'Director / Development Manager', code: 'DIRECTOR'},
            {name: 'Product / Project Manager', code: 'PM'},
            {name: 'Software Developer / Engineer', code: 'DEVELOPER'},
            {name: 'Business Analyst', code: 'BA'},
            {name: 'Data Scientist', code: 'DATA_SCIENTIST'},
            {name: 'Student', code: 'STUDENT'},
            {name: 'Other', code: 'OTHER'}
        ];

        vm.db = {};
        vm.multipledb = {};
        vm.multipledb.selectedDbs = [];
        vm.dbs = [
            {name: 'Oracle', code: 'ORACLE', ticked: false},
            {name: 'SQL Server', code: 'SQL_SERVER', ticked: false},
            {name: 'MySQL', code: 'MYSQL', ticked: false},
            {name: 'PostgreSQL', code: 'POSTGRESQL', ticked: false},
            {name: 'DB2', code: 'DB2', ticked: false},
            {name: 'Greenplum', code: 'GREENPLUM', ticked: false},
            {name: 'Netezza', code: 'NETEZZA', ticked: false},
            {name: 'Teradata', code: 'TERADATA', ticked: false},
            {name: 'SAP Hana', code: 'SAP_HANA', ticked: false},
            {name: 'AWS RDS', code: 'AWS_RDS', ticked: false},
            {name: 'Azure MS SQL', code: 'AZURE_MS_SQL', ticked: false},
            {name: 'Redshift', code: 'REDSHIFT', ticked: false},
            {name: 'MongoDB', code: 'MONGODB', ticked: false},
            {name: 'Hadoop Hive', code: 'HADOOP_HIVE', ticked: false},
            {name: 'Other', code: 'OTHER', ticked: false}
        ];

        Region.query(function(result) {
            vm.regions = result;
        });


        vm.confirmKey = function () {
            vm.invalidCodeActivationError = null;
            vm.expiredCodeActivationError = null;
            vm.verificationData.activationKey = vm.activationKey;
            vm.verificationData.job = vm.job.selected.code;
            vm.verificationData.selectedDbs = [];
            if (vm.multipledb.selectedDbs) {
                vm.verificationData.selectedDbs = vm.multipledb.selectedDbs.map(function(a) {return a.code;}) ;
            }


            Auth.activateAccount(vm.verificationData).then(function () {
                vm.invalidCodeActivationError = null;
                vm.expiredCodeActivationError = null;
                vm.success = 'OK';
                vm.disabledKey = true;
                $rootScope.activated = true;
                WizardHandler.wizard().next();
                setTimeout(function () {
                    nextStep();
                }, 100);

            }).catch(function (err) {
                vm.success = null;
                if (err.data && err.data.detail &&  err.data.detail === 'ActivationKey.Expired') {
                    vm.expiredCodeActivationError = 'ERROR';
                } else {
                    vm.invalidCodeActivationError = 'ERROR';
                }
            });


        };


        vm.confirmKeyDemo = function () {
            vm.invalidCodeActivationError = null;
            vm.expiredCodeActivationError = null;
            vm.verificationData.activationKey = vm.activationKey;
			vm.verificationData.job = '';//vm.job.selected.code;
            vm.verificationData.selectedDbs = [];
            /*if (vm.multipledb.selectedDbs) {
                vm.verificationData.selectedDbs = vm.multipledb.selectedDbs.map(function(a) {return a.code;}) ;
            }*/

            Auth.activateAccount(vm.verificationData).then(function () {
                vm.invalidCodeActivationError = null;
                vm.expiredCodeActivationError = null;
                vm.success = 'OK';
                vm.disabledKey = true;
                $rootScope.activated = true;

                setTimeout(function () {
                    createDemoInstance();
                }, 100);

            }).catch(function (err) {
                vm.success = null;
                if (err.data && err.data.detail &&  err.data.detail === 'ActivationKey.Expired') {
                    vm.expiredCodeActivationError = 'ERROR';
                } else {
                    vm.invalidCodeActivationError = 'ERROR';
                }
            });


        };

        function createDemoInstance(){
            vm.instance.demoInstance = true;
            Instance.save(vm.instance, onSaveSuccessDemo, onSaveError);
        }





        $http.get("https://api.ipify.org/?format=json").then(function (response) {
            vm.instance.userIp = response.data.ip;
        });

        vm.save = function save () {
            vm.isSaving = true;
            vm.instance.region = vm.region.name;
            Instance.save(vm.instance, onSaveSuccess, onSaveError);
        };

        vm.finishedWizard = function finishedWizard() {
            $state.go('instances');
        };

        function onSaveSuccessDemo (result) {
            vm.isSaving = false;

            vm.disabledConfig = true;
            $state.go('instances');

        }


        function onSaveSuccess (result) {
            vm.isSaving = false;

            vm.disabledConfig = true;
            WizardHandler.wizard().next();

            setTimeout(function () {
                nextStep();
            }, 100);


            vm.promise = $interval($scope.getInstances, 50*1000);


            $scope.timer = 5;
            $scope.max = 77;

            var countDown = $interval(function () {
                $scope.timer++;
                if ($scope.timer === 35) {
                    nextStep();
                    WizardHandler.wizard().next();
                    //$interval.cancel(countDown);
                }
            }, 5000);

            $scope.$on('$destroy',function(){
                if(vm.promise){
                    $interval.cancel(vm.promise);
                    $interval.cancel(countDown);
                }
            });

        }

        function onSaveError () {
            vm.isSaving = false;
            vm.errorLaunch ='ERROR';
            AlertService.error("Error Launch Instance. Please, contact support");
        }

        Account.get().$promise.then(getAccountThen);

        function getAccountThen (account) {
            vm.account = account.data;

            if(vm.account.activated ==true){
                Instance.query({
                    page: 0,
                    size: 10
                }, onSuccess1, onError1);
            }

        }





        function onSuccess1(data, headers) {

            var totalItems = headers('X-Total-Count');


            if(   totalItems<2){
                vm.disabledKey = true;
               // WizardHandler.wizard().next();
            }
            else{
                WizardHandler.wizard().next();
                $state.go('instances');
            }


        }
        function onError1(error) {
            $state.go('instances');
        }



        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }


        vm.loadingMessage = "Creating a brand new DBHawk cloud application for you";

        vm.quotes = [
            {
                value: "Creating an AWS EC2 machine, creating your  VPC, and provisioning your DBHawk domain name..."
            },
            {
                value: "It will take around 6 to 8 minutes to install and configure everything."
            },
            {
                value: "Now deploying DBHawk web application."
            },
			{
                value: "Installing SSL Certificate."
            },
            {
                value: "We are almost there... "
            },
            {
                value: "Once the deployment is complete, you can launch and access DBHawk."
            },
            {
                value: "You can invite more users, click on Invite more users button after DBHawk installation."
            },
            {
                value: "Still installing and deploying... "
            }

        ];


        vm.i=0;

        $scope.getInstances = function () {
             loadAll();

            vm.loadingMessage = vm.quotes[vm.i].value;

            if(vm.i<6){
                vm.i = vm.i+1;
            }
        };

        function loadAll () {



            Instance.query({
                page: 0,
                size: 10,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.instances = data;

                angular.forEach(vm.instances, function(value, key) {
                    if(value.instance.status === 'running ok' && value.instance.dbhawkUrl!=null){

                        $scope.timer = $scope.max;

                        DbhawkUserService.getUsersForInstance(value.instance.instanceId).then(function(response) {

                        }).catch(function(response) {

                        });

                        setTimeout(function(){
                            WizardHandler.wizard().next();
                            $interval.cancel(vm.promise);
                         }, 1 * 10 * 1000 );





                    }
                });
                vm.page = pagingParams.page;

            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function nextStep() {
            var next_step = true;
            if ($('.steps-indicator li:first').hasClass('current')) {
                next_step = false;
            }

            if (next_step) {

                var current_active_step = $('.f1-steps').find('.f1-step.active');
                var progress_line = $('.f1-steps').find('.f1-progress-line');

                current_active_step.removeClass('active').addClass('activated').next().addClass('active');
                // progress bar
                bar_progress(progress_line, 'right');
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('cloudApp')
        .service('InstanceActionService', InstanceActionService);

    InstanceActionService.$inject = ['$http'];

    function InstanceActionService($http) {

        this.startInstance = function startInstance(instanceId) {
            return $http.post(SERVER_API_URL+'api/instances/' + instanceId + '/start')
        };

        this.markSentReq = function startInstance(instanceId) {
            return $http.post(SERVER_API_URL+'api/instances/' + instanceId + '/req')
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .service('DbhawkUserService', DbhawkUserService);

    DbhawkUserService.$inject = ['$http'];

    function DbhawkUserService($http) {

        this.getUsersForInstance = function getUsersForInstance(instance){
            return $http.get(SERVER_API_URL+'api/dbhawk/users/'+instance)
        }

        this.getRedirectToAppUrl = function getRedirectToAppUrl(){
            return $http.post(SERVER_API_URL+'api/dbhawk/users/instance/url')
        }

        this.getCompanyDetails = function getRedirectToAppUrl(){
            return $http.get(SERVER_API_URL+'api/companies/user')
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('ContactUsDialogController', ContactUsDialogController);

    ContactUsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ContactUs'];

    function ContactUsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ContactUs) {
        var vm = this;

        vm.contactUs = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.contactUs.id !== null) {
                ContactUs.update(vm.contactUs, onSaveSuccess, onSaveError);
            } else {
                ContactUs.save(vm.contactUs, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('cloudApp:contactUsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('ContactUsDetailController', ContactUsDetailController);

    ContactUsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ContactUs'];

    function ContactUsDetailController($scope, $rootScope, $stateParams, previousState, entity, ContactUs) {
        var vm = this;

        vm.contactUs = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('cloudApp:contactUsUpdate', function(event, result) {
            vm.contactUs = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('ContactUsDeleteController',ContactUsDeleteController);

    ContactUsDeleteController.$inject = ['$uibModalInstance', 'entity', 'ContactUs'];

    function ContactUsDeleteController($uibModalInstance, entity, ContactUs) {
        var vm = this;

        vm.contactUs = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ContactUs.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('contact-us', {
            parent: 'entity',
            url: '/contact-us',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Contactuses'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/contact-us/contactuses.html',
                    controller: 'ContactUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('contact-us-detail', {
            parent: 'contact-us',
            url: '/contact-us/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ContactUs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/contact-us/contact-us-detail.html',
                    controller: 'ContactUsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ContactUs', function($stateParams, ContactUs) {
                    return ContactUs.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'contact-us',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('contact-us-detail.edit', {
            parent: 'contact-us-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contact-us/contact-us-dialog.html',
                    controller: 'ContactUsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ContactUs', function(ContactUs) {
                            return ContactUs.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('contact-us.new', {
            parent: 'contact-us',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contact-us/contact-us-dialog.html',
                    controller: 'ContactUsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                contactName: null,
                                contactEmail: null,
                                phone: null,
                                dbs: null,
                                companyName: null,
                                jobPos: null,
                                instanceId: null,
                                subject: null,
                                messages: null,
                                userId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('contact-us', null, { reload: 'contact-us' });
                }, function() {
                    $state.go('contact-us');
                });
            }]
        })
        .state('contact-us.edit', {
            parent: 'contact-us',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contact-us/contact-us-dialog.html',
                    controller: 'ContactUsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ContactUs', function(ContactUs) {
                            return ContactUs.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('contact-us', null, { reload: 'contact-us' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('contact-us.delete', {
            parent: 'contact-us',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contact-us/contact-us-delete-dialog.html',
                    controller: 'ContactUsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ContactUs', function(ContactUs) {
                            return ContactUs.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('contact-us', null, { reload: 'contact-us' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('cloudApp')
        .factory('ContactFormUs', ContactFormUs);

    ContactFormUs.$inject = ['$resource'];

    function ContactFormUs ($resource) {
        var resourceUrl =  'api/contactuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('ContactUsController', ContactUsController);

    ContactUsController.$inject = ['ContactUs'];

    function ContactUsController(ContactUs) {

        var vm = this;

        vm.contactuses = [];

        loadAll();

        function loadAll() {
            ContactUs.query(function(result) {
                vm.contactuses = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('CompanyDbhDialogController', CompanyDbhDialogController);

    CompanyDbhDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Company'];

    function CompanyDbhDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Company) {
        var vm = this;

        vm.company = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.company.id !== null) {
                Company.update(vm.company, onSaveSuccess, onSaveError);
            } else {
                Company.save(vm.company, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('cloudApp:companyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('CompanyDbhDetailController', CompanyDbhDetailController);

    CompanyDbhDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Company'];

    function CompanyDbhDetailController($scope, $rootScope, $stateParams, previousState, entity, Company) {
        var vm = this;

        vm.company = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('cloudApp:companyUpdate', function(event, result) {
            vm.company = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('CompanyDbhDeleteController',CompanyDbhDeleteController);

    CompanyDbhDeleteController.$inject = ['$uibModalInstance', 'entity', 'Company'];

    function CompanyDbhDeleteController($uibModalInstance, entity, Company) {
        var vm = this;

        vm.company = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Company.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('company-dbh', {
            parent: 'entity',
            url: '/company-dbh',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Companies'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/company-dbh/companiesdbh.html',
                    controller: 'CompanyDbhController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('company-dbh-detail', {
            parent: 'company-dbh',
            url: '/company-dbh/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Company'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/company-dbh/company-dbh-detail.html',
                    controller: 'CompanyDbhDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Company', function($stateParams, Company) {
                    return Company.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'company-dbh',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('company-dbh-detail.edit', {
            parent: 'company-dbh-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company-dbh/company-dbh-dialog.html',
                    controller: 'CompanyDbhDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Company', function(Company) {
                            return Company.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('company-dbh.new', {
            parent: 'company-dbh',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company-dbh/company-dbh-dialog.html',
                    controller: 'CompanyDbhDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                companyName: null,
                                companyEmail: null,
                                createdIp: null,
                                lastIp: null,
                                databaseName: null,
                                firstName: null,
                                lastName: null,
                                jobFunction: null,
                                locale: null,
                                phone: null,
                                message: null,
                                completed: null,
                                userId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('company-dbh', null, { reload: 'company-dbh' });
                }, function() {
                    $state.go('company-dbh');
                });
            }]
        })
        .state('company-dbh.edit', {
            parent: 'company-dbh',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company-dbh/company-dbh-dialog.html',
                    controller: 'CompanyDbhDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Company', function(Company) {
                            return Company.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('company-dbh', null, { reload: 'company-dbh' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('company-dbh.delete', {
            parent: 'company-dbh',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company-dbh/company-dbh-delete-dialog.html',
                    controller: 'CompanyDbhDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Company', function(Company) {
                            return Company.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('company-dbh', null, { reload: 'company-dbh' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('cloudApp')
        .factory('Company', Company);

    Company.$inject = ['$resource'];

    function Company ($resource) {
        var resourceUrl =  SERVER_API_URL+'api/companies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('CompanyDbhController', CompanyDbhController);

    CompanyDbhController.$inject = ['Company'];

    function CompanyDbhController(Company) {

        var vm = this;

        vm.companies = [];

        loadAll();

        function loadAll() {
            Company.query(function(result) {
                vm.companies = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('documentation', {
            parent: 'account',
            url: '/documentation',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Documentation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/documentation/documentation.html',
                    controller: 'DocumentationController',
                    controllerAs: 'vm'
                }
            }
        }).state('documentation.id', {
                parent: 'account',
                url: '/documentation/:id',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Documentation'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/documentation/documentation.html',
                        controller: 'DocumentationController',
                        controllerAs: 'vm'
                    }
                },
                onEnter:  ['$stateParams', '$timeout', '$location', '$anchorScroll', '$document', function($stateParams, $timeout, $location, $anchorScroll, $document)  {
                        $timeout(function() {
                            //$location.hash($stateParams.id);
                            //$anchorScroll();
                            //alert('scroll');
                            var sectionElement = angular.element(document.getElementById($stateParams.id));
                            $document.scrollToElement(sectionElement, 100, 800);
                        }, 500)
                    }]
            });


    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('DocumentationController', DocumentationController).value('duScrollOffset', 130);


        DocumentationController.$inject = [ '$timeout', '$state', '$rootScope', '$scope', '$window', '$document'];

    function DocumentationController ($timeout, $state, $rootScope, $scope, $window, $document) {
		var vm = this;
		vm.triggerSlider = triggerSlider;
		vm.itemClick = itemClick;

		var viewport = function () {
        var e = window, a = 'inner';
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return {
            width: e[a + 'Width'],
            height: e[a + 'Height']
        };
    };

		  // function that adds information in a scope of the height and width of the page
    $scope.getWindowDimensions = function () {
        return {
            'h': viewport().height,
            'w': viewport().width
        };
    };
    // Detect when window is resized and set some variables
    $scope.$watch($scope.getWindowDimensions, function (newValue, oldValue) {
        $scope.windowHeight = newValue.h;
        $scope.windowWidth = newValue.w;
        if (newValue.w >= 992) {
			 angular.element('#docs-sidebar').addClass('sidebar-visible').removeClass('sidebar-hidden');
			 angular.element('.sidebar-toggler').removeClass('toggler-show');
        }
        if (newValue.w < 992 && newValue.w > 768) {
			 angular.element('#docs-sidebar').addClass('sidebar-visible').removeClass('sidebar-hidden');
			 angular.element('.sidebar-toggler').removeClass('toggler-show');
        }
        if (newValue.w <= 768) {
			angular.element('#docs-sidebar').addClass('sidebar-hidden').removeClass('sidebar-visible');
			angular.element('.sidebar-toggler').addClass('toggler-show').addClass('toggler-hidden');
        }
    }, true);

	 function triggerSlider() {
		if ( angular.element('#docs-sidebar').hasClass('sidebar-visible') ) {

			  angular.element("#docs-sidebar").removeClass('sidebar-visible').addClass('sidebar-hidden');
			  angular.element('.sidebar-toggler').removeClass('toggler-visible').addClass('toggler-hidden');

		} else {

			  angular.element("#docs-sidebar").removeClass('sidebar-hidden').addClass('sidebar-visible');
			  angular.element('.sidebar-toggler').removeClass('toggler-hidden').addClass('toggler-visible');

		}
	 }

	 function itemClick() {
		if ( $scope.windowWidth <= 768) {
			  angular.element("#docs-sidebar").removeClass('sidebar-visible').addClass('sidebar-hidden');
			  angular.element('.sidebar-toggler').removeClass('toggler-visible').addClass('toggler-hidden');

		}
	 }

    }
})();

'use strict';
/** 
  * A simple but useful and efficient directive to toggle a class to an element.   
*/
angular
        .module('cloudApp').factory('ToggleHelper', ['$rootScope',
function ($rootScope) {
    return {

        events: {
            toggle: "cloudApp.toggle",
            toggleByClass: "cloudApp.toggleByClass",
            togglerLinked: "cloudApp.linked",
            toggleableToggled: "cloudApp.toggled"
        },

        commands: {
            alternate: "toggle",
            activate: "on",
            deactivate: "off"
        },

        toggle: function (target, command) {
			console.log('target', target)
            if (command == null) {
                command = "toggle";
            }
            $rootScope.$emit(this.events.toggle, target, command);
        },

        toggleByClass: function (targetClass, command) {
            if (command == null) {
                command = "toggle";
            }
            $rootScope.$emit(this.events.toggleByClass, targetClass, command);
        },

        notifyToggleState: function (elem, attrs, toggleState) {
            $rootScope.$emit(this.events.toggleableToggled, attrs.id, toggleState, attrs.exclusionGroup);
        },

        toggleStateChanged: function (elem, attrs, toggleState) {
            this.updateElemClasses(elem, attrs, toggleState);
            this.notifyToggleState(elem, attrs, toggleState);
        },

        applyCommand: function (command, oldState) {
            switch (command) {
                case this.commands.activate:
                    return true;
                case this.commands.deactivate:
                    return false;
                case this.commands.alternate:
                    return !oldState;
            }
        },

        updateElemClasses: function (elem, attrs, active) {

            if (active) {
                if (attrs.activeClass) {
                    elem.addClass(attrs.activeClass);
                }
                if (attrs.inactiveClass) {
                    elem.removeClass(attrs.inactiveClass);
                }
                var parent = elem.parent().parent();
                if (attrs.parentActiveClass) {
                    parent.addClass(attrs.parentActiveClass);
                }
                if (attrs.parentInactiveClass) {
                    parent.removeClass(attrs.parentInactiveClass);
                }
            } else {
                if (attrs.inactiveClass) {
                    elem.addClass(attrs.inactiveClass);
                }
                if (attrs.activeClass) {
                    elem.removeClass(attrs.activeClass);
                }
                var parent = elem.parent().parent();
                if (attrs.parentInactiveClass) {
                    parent.addClass(attrs.parentInactiveClass);
                }
                if (attrs.parentActiveClass) {
                    parent.removeClass(attrs.parentActiveClass);
                }
            }
        }
    };
}]).run(["$rootScope", "ToggleHelper",
function ($rootScope, ToggleHelper) {

    $rootScope.toggle = function (target, command) {
        if (command == null) {
            command = "toggle";
        }
        ToggleHelper.toggle(target, command);
    };

    $rootScope.toggleByClass = function (targetClass, command) {
        if (command == null) {
            command = "toggle";
        }
        ToggleHelper.toggleByClass(targetClass, command);
    };
}]).directive('ctToggle', ["$rootScope", "ToggleHelper",
function ($rootScope, ToggleHelper) {
    return {
        restrict: "A",
        link: function (scope, elem, attrs) {
            var command = attrs.ctToggle || ToggleHelper.commands.alternate;
            var target = attrs.target;
            var targetClass = attrs.targetClass;
            var bubble = attrs.bubble === "true" || attrs.bubble === "1" || attrs.bubble === 1 || attrs.bubble === "" || attrs.bubble === "bubble";

            if ((!target) && attrs.href) {
                target = attrs.href.slice(1);
            }

            if (!(target || targetClass)) {
                throw "'target' or 'target-class' attribute required with 'ct-toggle'";
            }
            elem.on("click tap", function (e) {

                var angularElem = angular.element(e.target);
                if (!angularElem.hasClass("disabled")) {
                    if (target != null) {
                        ToggleHelper.toggle(target, command);
                    }
                    if (targetClass != null) {
                        ToggleHelper.toggleByClass(targetClass, command);
                    }
                    if (!bubble) {
                        e.preventDefault();
                        return false;
                    } else {
                        return true;
                    }
                }

            });
            var unbindUpdateElemClasses = $rootScope.$on(ToggleHelper.events.toggleableToggled, function (e, id, newState) {
                if (id === target) {
                    ToggleHelper.updateElemClasses(elem, attrs, newState);
                }
            });

            if (target != null) {
                $rootScope.$emit(ToggleHelper.events.togglerLinked, target);
            }

            scope.$on('$destroy', unbindUpdateElemClasses);
        }
    };
}]).directive('toggleable', ["$rootScope", "ToggleHelper",
function ($rootScope, ToggleHelper) {
    return {
        restrict: "A",
        link: function (scope, elem, attrs) {
            var toggleState = false;

            if (attrs["default"]) {
                switch (attrs["default"]) {
                    case "active":
                        toggleState = true;
                        break;
                    case "inactive":
                        toggleState = false;
                }
                ToggleHelper.toggleStateChanged(elem, attrs, toggleState);
            }

            var unbindToggle = $rootScope.$on(ToggleHelper.events.toggle, function (e, target, command) {
                var oldState;
                if (target === attrs.id) {
                    oldState = toggleState;
                    toggleState = ToggleHelper.applyCommand(command, oldState);
                    if (oldState !== toggleState) {
                        ToggleHelper.toggleStateChanged(elem, attrs, toggleState);
                    }
                }
            });

            var unbindToggleByClass = $rootScope.$on(ToggleHelper.events.toggleByClass, function (e, targetClass, command) {
                var oldState;
                if (elem.hasClass(targetClass)) {
                    oldState = toggleState;
                    toggleState = ToggleHelper.applyCommand(command, oldState);
                    if (oldState !== toggleState) {
                        ToggleHelper.toggleStateChanged(elem, attrs, toggleState);
                    }
                }
            });

            var unbindToggleableToggled = $rootScope.$on(ToggleHelper.events.toggleableToggled, function (e, target, newState, sameGroup) {
                if (newState && (attrs.id !== target) && (attrs.exclusionGroup === sameGroup) && (attrs.exclusionGroup != null)) {
                    toggleState = false;
                    ToggleHelper.toggleStateChanged(elem, attrs, toggleState);
                }
            });

            var unbindTogglerLinked = $rootScope.$on(ToggleHelper.events.togglerLinked, function (e, target) {
                if (attrs.id === target) {
                    ToggleHelper.notifyToggleState(elem, attrs, toggleState);
                }
            });

            scope.$on('$destroy', function () {
                unbindToggle();
                unbindToggleByClass();
                unbindToggleableToggled();
                unbindTogglerLinked();
            });
        }
    };
}]);
'use strict';
/** 
  * It's like click, but when you don't click on your element. 
*/
angular
        .module('cloudApp').directive('offClick', ['$document', '$timeout', function ($document, $timeout) {

    function targetInFilter(target, filter) {
        if (!target || !filter) return false;
        var elms = angular.element(document.querySelectorAll(filter));
        var elmsLen = elms.length;
        for (var i = 0; i < elmsLen; ++i)
            if (elms[i].contains(target)) return true;
        return false;
    }

    return {
        restrict: 'A',
        scope: {
            offClick: '&',
            offClickIf: '&'
        },
        link: function (scope, elm, attr) {

            if (attr.offClickIf) {
                scope.$watch(scope.offClickIf, function (newVal, oldVal) {
                    if (newVal && !oldVal) {
                        $timeout(function () {
                            $document.on('click', handler);
                        });
                    } else if (!newVal) {
                        $document.off('click', handler);
                    }
                }
                );
            } else {
                $document.on('click', handler);
            }

            scope.$on('$destroy', function () {
                $document.off('click', handler);
            });

            function handler(event) {
                // This filters out artificial click events. Example: If you hit enter on a form to submit it, an
                // artificial click event gets triggered on the form's submit button.
                if (event.pageX == 0 && event.pageY == 0) return;

                var target = event.target || event.srcElement;
                if (!(elm[0].contains(target) || targetInFilter(target, attr.offClickFilter))) {
                    scope.$apply(scope.offClick());
                }
            }
        }
    };
}]);

'use strict';
/**
 * Make element 100% height of browser window.
 */
angular
        .module('cloudApp').directive('ctFullheight', ['$window', '$rootScope', '$timeout',
function ($window, $rootScope, $timeout) {
    return {
        restrict: "AE",
        scope: {
            ctFullheightIf: '&'
        },
        link: function (scope, elem, attrs) {
            var $win = $($window);
            var $document = $(document);
            var exclusionItems;
            var exclusionHeight;
            var setHeight = true;
            var page;

            scope.initializeWindowSize = function () {
                $timeout(function () {
                    exclusionHeight = 0;
                    if (attrs.ctFullheightIf) {
                        scope.$watch(scope.ctFullheightIf, function (newVal, oldVal) {
                            if (newVal && !oldVal) {
                                setHeight = true;
                            } else if (!newVal) {
                                $(elem).css('height', 'auto');
                                setHeight = false;
                            }
                        });
                    }

                    if (attrs.ctFullheightExclusion) {
                        var exclusionItems = attrs.ctFullheightExclusion.split(',');
                        angular.forEach(exclusionItems, function (_element) {
                            exclusionHeight = exclusionHeight + $(_element).outerHeight(true);
                        });
                    }
                    if (attrs.ctFullheight == 'window') {
                        page = $win;
                    } else {
                        page = $document;
                    }

                    scope.$watch(function () {
                        scope.__height = page.height();
                    });
                    if (setHeight) {
                        $(elem).css('height', 'auto');
                        if (page.innerHeight() < $win.innerHeight()) {
                            page = $win;
                        }
                        $(elem).css('height', page.innerHeight() - exclusionHeight);
                    }
                }, 300);
            };

            scope.initializeWindowSize();
            scope.$watch('__height', function (newHeight, oldHeight) {
                scope.initializeWindowSize();
            });
            $win.on('resize', function () {
                scope.initializeWindowSize();
            });

        }
    };
}]);

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('contact', {
            parent: 'account',
            url: '/contact',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Contact'
            },
            views: {
                'content@': {
                    templateUrl: 'app/contact/contact.html',
                    controller: 'ContactController',
                    controllerAs: 'vm'
                }
            }
        })
		.state('thank-you', {
            parent: 'account',
            url: '/thank-you',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Thank You'
            },
            views: {
                'content@': {
                    templateUrl: 'app/contact/thank-you.html',
                    controller: 'ContactController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('ContactController', ContactController);


        ContactController.$inject = [ '$timeout', 'Auth', 'LoginService', 'errorConstants', '$state', '$rootScope', '$scope', 'AlertService', 'Principal'];

    function ContactController ($timeout, Auth, LoginService, errorConstants, $state, $rootScope, $scope, AlertService, Principal) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.contact = contact;
        vm.contactParam = {};
        vm.success = null;

        vm.contactParam.email = Principal.getUserEmail();

        $timeout(function (){angular.element('#login').focus();});

        function contact () {
            console.log('contactParam', vm.contactParam);
            /*if($scope.form.$invalid){
                vm.errorValidation = 'ERROR';
            }*/
            Auth.contactUs(vm.contactParam).then(function () {
                vm.contactParam = {};
                $scope.form.$setPristine();
                vm.error = null;
                vm.success = 'OK';
                $state.go('thank-you');

            }).catch(function () {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('cloudApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('cloudApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
        'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
        '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
        'of {{$ctrl.queryCount}} items.' +
        '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('cloudApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .constant('errorConstants', (function() {
            var problemBaseUrl = 'http://www.jhipster.tech/problem';
            return {
                EMAIL_ALREADY_USED_TYPE: problemBaseUrl + '/email-already-used',
                LOGIN_ALREADY_USED_TYPE: problemBaseUrl + '/login-already-used',
                EMAIL_NOT_FOUND_TYPE: problemBaseUrl + '/email-not-found',
                COMPANY_ALREADY_USED_TYPE: problemBaseUrl + '/company-already-used'
            }
        })());
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            var fileURL = 'data:' + type +';base64,' + data;
            var win = $window.open('', '_blank');
            win.document.write(
                '<iframe src="' +
                fileURL +
                '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
            );
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('cloudApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .constant('password_pattern', /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])/);
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('signin', {
            parent: 'home',
            url: 'signin',
            data: {
                authorities: [],
                pageTitle: 'DBHawk Sign In'
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/login/signin.html',
                    controller: 'LoginController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal', '$state'];

    function LoginService ($uibModal, $state) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            //$state.go('signin');
           /* modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm'
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );*/
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', 'vcRecaptchaService', '$window', 'APP_VERSION'];

    function LoginController ($rootScope, $state, $timeout, Auth, vcRecaptchaService, $window, appVersion) {
        var vm = this;

 		$rootScope.$on('$viewContentLoaded', function(){
             angular.element(document).find('body').addClass('register-open')
          });

        vm.appVersion = appVersion;
        vm.authenticationError = false;
        //vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = false;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        vm.reCaptchaPublicKey = reCaptchaPublicKey;
        vm.reCaptchaSize = 'invisible';
        vm.recaptchaResponse = false;
       /* if (angular.element($window).width() < 460) {
            vm.reCaptchaSize = 'compact';
        }*/

        $timeout(function (){angular.element('#username').focus();});

        $timeout(function () {
            grecaptcha.execute()
        }, 1000);

        setInterval(function(){ grecaptcha.reset(); }, 1 * 60 * 1000 );

        /*function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
           // $uibModalInstance.dismiss('cancel');
        }*/

        function login (event) {
            //event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $rootScope.$broadcast('authenticationSuccess');
                authClient.signIn({username:vm.username, password:vm.password})
                    .then(function(res) {
                        if (res.status === 'SUCCESS') {
                            authClient.token.getWithRedirect({
                                sessionToken: res.sessionToken,
                                responseType: 'id_token'
                            });
                        }
                    }).fail(function(err) {
                    console.error(err);
                });
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
           // $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
           // $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName] && formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function () {
    'use strict';

    angular.module('cloudApp').service('ConfirmBoxService', ConfirmBoxService);
    ConfirmBoxService.$inject = ['$uibModal'];


        function ConfirmBoxService ($uibModal) {

            var modalDefaults = {
                backdrop: true,
                keyboard: true,
                modalFade: true,
                templateUrl: 'app/components/confirmbox/confirmbox.html'
            };

            var modalOptions = {
                closeButtonText: 'Close',
                actionButtonText: 'OK',
                headerText: 'Proceed?',
                bodyText: 'Perform this action?'
            };

            this.showModal = function (customModalDefaults, customModalOptions) {
                if (!customModalDefaults) customModalDefaults = {};
                customModalDefaults.backdrop = 'static';
                return this.show(customModalDefaults, customModalOptions);
            };

            this.show = function (customModalDefaults, customModalOptions) {
                var tempModalDefaults = {};
                var tempModalOptions = {};

                angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);
                angular.extend(tempModalOptions, modalOptions, customModalOptions);

                if (!tempModalDefaults.controller) {
                    tempModalDefaults.controller = ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                        $scope.modalOptions = tempModalOptions;
                        $scope.modalOptions.ok = function (result) {
                            $uibModalInstance.close(result);
                        };
                        $scope.modalOptions.close = function (result) {
                            $uibModalInstance.dismiss('cancel');
                        };
                    }]
                }

                return $uibModal.open(tempModalDefaults).result;
            };

        };
})();





(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('BootSwatchService', BootSwatchService);

    BootSwatchService.$inject = ['$http'];

    function BootSwatchService ($http) {
        return {
            get: get
        };

        function get() {
            return $http.get('content/themes.json').then(function (response) {
                return response.data.themes;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .directive('jhSwitchTheme', jhSwitchTheme);

    function jhSwitchTheme () {
        var vm = this;

        return {
            restrict: 'A',
            scope: {
                theme : '=jhSwitchTheme'
            },
            link: link
        };

        function link(scope, element, attrs) {
            var currentTheme = $("#bootswatch-css").attr('title');
            if(scope.theme.name === currentTheme){
                element.parent().addClass("active");
            }

            element.on('click',function(){
                $("#bootswatch-css").attr("href", scope.theme.css);
                $(".theme-link").removeClass("active");
                element.parent().addClass("active");
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('BootswatchController', BootswatchController);

    BootswatchController.$inject = ['$scope', 'BootSwatchService'];

    function BootswatchController ($scope, BootSwatchService) {
        var vm = this;

        getThemes();

        function getThemes () {
            /* Get the list of availabel bootswatch themes */
            BootSwatchService.get().then(function(themes) {
                vm.themes = themes;
                vm.themes.unshift({name:'Default',css:''});
            });
        }
    }
})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('cloudApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: message,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('cloudApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (angular.isString(errorHeader)) {
                    var entityName = entityKey;
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = convertedField.charAt(0).toUpperCase() + convertedField.slice(1);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce'];

        function getService ($timeout, $sce) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('cloudApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('cloudApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector'];

    function authExpiredInterceptor($rootScope, $q, $injector) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                if (to.name !== 'accessdenied') {
                    Auth.storePreviousState(to.name, params);
                }
                var LoginService = $injector.get('LoginService');
                LoginService.open();
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage',  '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage,  $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'cloud' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                $window.document.title = titleKey;
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('cloudApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('cloudApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('BUILD_TIMESTAMP', 1723055478385)
        .constant('APP_VERSION', "2.0.0")
        .constant('SERVER_API_URL', "http://3.231.27.25:8080/cloud/")
;
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;



        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                vm.user.langKey = 'en';
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load(login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Users'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'cloud'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Application Metrics'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.includes('web.rest') || key.includes('service')) {
                    vm.servicesStats[key] = value;
                }
            });

            vm.cachesStats = {};
            angular.forEach(newValue.gauges, function (value, key) {
                if (key.includes('jcache.statistics')) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(18),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Logs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('instance-management', {
            parent: 'admin',
            url: '/instance-management',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Instances'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/instances/instances.html',
                    controller: 'InstancesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'created,desc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }
        }).state('instance-management.action', {
            url: '/{instanceId}/{action}',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/instances/instance-management-action-dialog.html',
                    controller: 'InstanceManagementActionController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: {
                            instance : $stateParams.instanceId,
                            action: $stateParams.action
                        }
                    }
                }).result.then(function() {
                    $state.go('instance-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('InstancesService', InstancesService);

    InstancesService.$inject = ['$rootScope', '$http'];

    function InstancesService ($rootScope, $http) {

        return {
            getInstances: getInstances,
            executeAction: executeAction,
            saveInstance: saveInstance
        };

        function getInstances(pageable, runningAndStopped) {
            return $http.get(SERVER_API_URL+"api/admin/instances?page=" + pageable.page + "&sort=" + pageable.sort +
                "&runningAndStopped=" + runningAndStopped);
        }

        function executeAction(instanceId, action) {
            return $http.post(SERVER_API_URL+"api/admin/" + action + "/" + instanceId);
        }

        function saveInstance(instance) {
            return $http.post(SERVER_API_URL+"api/admin/save", instance);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('cloudApp')
        .controller('InstancesController', InstancesController);

    InstancesController.$inject = ['InstancesService', '$uibModal', 'ParseLinks', 'pagingParams', 'paginationConstants', 'AlertService'];

    function InstancesController(InstancesService, $uibModal, ParseLinks, pagingParams, paginationConstants, AlertService) {
        var vm = this;

        vm.regions = {
            "us-east-1": "US East (N. Virginia)",
            "us-east-2": "US East (Ohio)",
            "us-west-1": "US West (N. California)",
            "us-west-2": "US West (Oregon)",
            "eu-central-1": "EU (Frankfurt)",
            "eu-west-1": "EU (Ireland)",
            "eu-west-2": "EU (London)"
        };

        vm.instances = {};
        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.runningAndStopped = true;
        vm.showOnlyRunningAndStoppedInstances = showOnlyRunningAndStoppedInstances;
        vm.transition = transition;
        vm.loadAll = loadAll;
        vm.terminate = terminate;
        vm.editInstance = editInstance;
        vm.saveInstance = saveInstance;
        vm.allowPersonal = saveInstance;

        vm.loadAll({
            page: 0,
            sort: vm.predicate + (vm.reverse ? ',asc' : ',desc')
        }, vm.runningAndStopped);

        function loadAll(pageable, runningAndStopped) {
            InstancesService.getInstances(pageable, runningAndStopped).then(function (response) {
                vm.links = ParseLinks.parse(response.headers('link'));
                vm.totalItems = response.headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.instances = response.data;
            });
        }

        function transition() {
            vm.loadAll({
                page: vm.page - 1,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            }, vm.runningAndStopped);
        }

        function terminate(instanceId) {
            InstancesService.terminateInstance(instanceId).success(function (response) {

            }).error(function (error, status) {
                AlertService.error(error.detail);
            });
        }

        function editInstance(instance) {
            instance.editMode = true;
        }

        function saveInstance(instance) {
            InstancesService.saveInstance(instance).success(function (response) {
                instance.editMode = false;
            }).error(function (error, status) {
                AlertService.error(error.detail);
            });
        }

        function showOnlyRunningAndStoppedInstances() {
            vm.loadAll({
                page: 0,
                sort: vm.predicate + (vm.reverse ? ',asc' : ',desc')
            }, vm.runningAndStopped);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('cloudApp')
        .controller('InstanceManagementActionController', InstanceManagementActionController);

    InstanceManagementActionController.$inject = ['$uibModalInstance', 'InstancesService', 'AlertService', 'entity'];

    function InstanceManagementActionController($uibModalInstance, InstancesService, AlertService, entity) {
        var vm = this;

        vm.clear = clear;
        vm.confirmAction = confirmAction;
        vm.entity = entity;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmAction() {
            console.log(entity);
            InstancesService.executeAction(entity.instance, entity.action).success(function (response) {
                $uibModalInstance.close(true);
            }).error(function (error, status) {
                AlertService.error(error.detail);
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Health Checks'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('cloudApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('EmailListDialogController', EmailListDialogController);

    EmailListDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EmailList'];

    function EmailListDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EmailList) {
        var vm = this;

        vm.emailList = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.emailList.id !== null) {
                EmailList.update(vm.emailList, onSaveSuccess, onSaveError);
            } else {
                EmailList.save(vm.emailList, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('cloudApp:emailListUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('EmailListDetailController', EmailListDetailController);

    EmailListDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'EmailList'];

    function EmailListDetailController($scope, $rootScope, $stateParams, previousState, entity, EmailList) {
        var vm = this;

        vm.emailList = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('cloudApp:emailListUpdate', function(event, result) {
            vm.emailList = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('EmailListDeleteController',EmailListDeleteController);

    EmailListDeleteController.$inject = ['$uibModalInstance', 'entity', 'EmailList'];

    function EmailListDeleteController($uibModalInstance, entity, EmailList) {
        var vm = this;

        vm.emailList = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            EmailList.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('email-list', {
            parent: 'entity',
            url: '/email-list?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'EmailLists'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/email-list/email-lists.html',
                    controller: 'EmailListController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }]
            }
        })
        .state('email-list-detail', {
            parent: 'email-list',
            url: '/email-list/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'EmailList'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/email-list/email-list-detail.html',
                    controller: 'EmailListDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'EmailList', function($stateParams, EmailList) {
                    return EmailList.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'email-list',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('email-list-detail.edit', {
            parent: 'email-list-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/email-list/email-list-dialog.html',
                    controller: 'EmailListDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EmailList', function(EmailList) {
                            return EmailList.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('email-list.new', {
            parent: 'email-list',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/email-list/email-list-dialog.html',
                    controller: 'EmailListDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                domain: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('email-list', null, { reload: 'email-list' });
                }, function() {
                    $state.go('email-list');
                });
            }]
        })
        .state('email-list.edit', {
            parent: 'email-list',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/email-list/email-list-dialog.html',
                    controller: 'EmailListDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EmailList', function(EmailList) {
                            return EmailList.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('email-list', null, { reload: 'email-list' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('email-list.delete', {
            parent: 'email-list',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/email-list/email-list-delete-dialog.html',
                    controller: 'EmailListDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EmailList', function(EmailList) {
                            return EmailList.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('email-list', null, { reload: 'email-list' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function () {
    "use strict";
    angular.module("cloudApp").factory("EmailList", EmailList);

    EmailList.$inject = ["$resource"];

    function EmailList($resource) {
        var resourceUrl = SERVER_API_URL + "api/email-lists/:id";

        var service = $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    },
                },
                update: { method: "PUT" },
            }
        );

        service.checkEmailDomain = function (email) {
            return $resource(SERVER_API_URL + "api/email-lists/check", {}, {
                get: {
                    method: 'GET',
                    params: {email: '@email'}
                }
            })
                .get({email: email})
                .$promise.then(function (response) {
                    if (typeof response.isBanned === "boolean") {
                        return response.isBanned;
                    } else {
                        return response;
                    }
                });
        };

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('EmailListController', EmailListController);

    EmailListController.$inject = ['$state', 'EmailList', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function EmailListController($state, EmailList, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.domain = null;
        vm.search = search;

        loadAll();

        function loadAll () {
            EmailList.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                domain: vm.domain,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.emailLists = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search() {
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'API'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Configuration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('SocialRegisterController', SocialRegisterController);

    SocialRegisterController.$inject = ['$filter', '$stateParams'];

    function SocialRegisterController ($filter, $stateParams) {
        var vm = this;

        vm.success = $stateParams.success;
        vm.error = !vm.success;
        vm.provider = $stateParams.provider;
        vm.providerLabel = $filter('capitalize')(vm.provider);
        vm.success = $stateParams.success;
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('social-register', {
            parent: 'account',
            url: '/social-register/:provider?{success:boolean}',
            data: {
                authorities: [],
                pageTitle: 'Register with {{ label }}'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/social/social-register.html',
                    controller: 'SocialRegisterController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('SocialService', SocialService);

    SocialService.$inject = ['$http', '$cookies'];

    function SocialService ($http, $cookies) {
        var socialService = {
            getProviderSetting: getProviderSetting,
            getProviderURL: getProviderURL,
            getCSRF: getCSRF
        };

        return socialService;

        function getProviderSetting (provider) {
            switch(provider) {
            case 'google': return 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email';
            case 'facebook': return 'public_profile,email';
            case 'twitter': return '';
                // jhipster-needle-add-social-button
            default: return 'Provider setting not defined';
            }
        }

        function getProviderURL (provider) {
            return 'signin/' + provider;
        }

        function getCSRF () {
            return $cookies.get($http.defaults.xsrfCookieName);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .directive('jhSocial', jhSocial);

    jhSocial.$inject = ['$filter', 'SocialService'];

    function jhSocial($filter, SocialService) {
        var directive = {
            restrict: 'E',
            scope: {
                provider: '@ngProvider'
            },
            templateUrl: 'app/account/social/directive/social.html',
            link: linkFunc
        };

        return directive;

        /* private helper methods */

        function linkFunc(scope) {
            
            scope.label = $filter('capitalize')(scope.provider);
            scope.providerSetting = SocialService.getProviderSetting(scope.provider);
            scope.providerURL = SocialService.getProviderURL(scope.provider);
            scope.csrf = SocialService.getCSRF();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth'];

    function SettingsController (Principal, Auth) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.resend = resend;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }

        function resend () {
            Auth.resendActivation(vm.settingsAccount).then(function() {
                vm.errorResend = null;
                vm.successResend = 'OK';

            }).catch(function() {
                vm.successResend = null;
                vm.errorResend = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Sessions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController (Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function invalidate (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: [],
                pageTitle: 'DBHawk: Reset Password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', '$scope', 'Auth', 'errorConstants'];

    function RequestResetController ($timeout, $scope, Auth, errorConstants) {
        var vm = this;
        
         $scope.$on('$viewContentLoaded', function(){
             angular.element(document).find('body').addClass('register-open')
          });

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_NOT_FOUND_TYPE) {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService', 'password_pattern'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService, passwordPattern) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.passwordValidationError = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            vm.passwordValidationError = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function (err) {
                    if (err.data && err.data.detail &&  err.data.detail === 'error.validation') {
                        vm.passwordValidationError = 'ERROR';
                        vm.success = null;
                    } else {
                        vm.success = null;
                        vm.error = 'ERROR';
                        vm.passwordValidationError = null;
                    }
                });
            }
        }

        vm.getPasswordPattern = function () {
            return passwordPattern;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'DBHawk account registration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('cloudApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$timeout', 'EmailList', 'Auth', 'LoginService', 'errorConstants', '$state', '$rootScope', '$scope', 'password_pattern', '$http', 'AlertService', 'vcRecaptchaService', '$window'];

    function RegisterController($timeout, EmailList, Auth, LoginService, errorConstants, $state, $rootScope, $scope, passwordPattern, $http, AlertService, vcRecaptchaService, $window) {
        var vm = this;

        $scope.$on('$viewContentLoaded', function () {
            angular.element(document).find('body').addClass('register-open')
        });

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {
            countryCode: ""
        };
        vm.success = null;
        vm.emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;                
        vm.passwordExcudedEmailPattern = null;
        vm.reCaptchaPublicKey = reCaptchaPublicKey;
        vm.reCaptchaSize = 'invisible';
        vm.countryCodes = [
            { value: "USA (+1)", label: "USA (+1)" },
            { value: "Argentina (+54)", label: "Argentina (+54)" },
            { value: "Aruba (+297)", label: "Aruba (+297)" },
            { value: "Australia (+61)", label: "Australia (+61)" },
            { value: "Austria (+43)", label: "Austria (+43)" },
            { value: "Bahrain (+973)", label: "Bahrain (+973)" },
            { value: "Barbados (+1246)", label: "Barbados (+1246)" },
            { value: "Belarus (+375)", label: "Belarus (+375)" },
            { value: "Belgium (+32)", label: "Belgium (+32)" },
            { value: "Belize (+501)", label: "Belize (+501)" },
            { value: "Bermuda (+1441)", label: "Bermuda (+1441)" },
            { value: "Brazil (+55)", label: "Brazil (+55)" },
            { value: "British Virgin Islands (+1284)", label: "British Virgin Islands (+1284)" },
            { value: "Canada (+1)", label: "Canada (+1)" },
            { value: "Chile (+56)", label: "Chile (+56)" },
            { value: "China (+86)", label: "China (+86)" },
            { value: "Colombia (+57)", label: "Colombia (+57)" },
            { value: "Costa Rica (+506)", label: "Costa Rica (+506)" },
            { value: "Croatia (+385)", label: "Croatia (+385)" },
            { value: "Cyprus (+357)", label: "Cyprus (+357)" },
            { value: "Czech Republic (+420)", label: "Czech Republic (+420)" },
            { value: "Denmark (+45)", label: "Denmark (+45)" },
            { value: "Dominican Republic (+1809)", label: "Dominican Republic (+1809)" },
            { value: "Ecuador (+593)", label: "Ecuador (+593)" },
            { value: "Egypt (+20)", label: "Egypt (+20)" },
            { value: "El Salvador (+503)", label: "El Salvador (+503)" },
            { value: "Estonia (+372)", label: "Estonia (+372)" },
            { value: "Fiji (+679)", label: "Fiji (+679)" },
            { value: "Finland (+358)", label: "Finland (+358)" },
            { value: "France (+33)", label: "France (+33)" },
            { value: "French Guiana (+594)", label: "French Guiana (+594)" },
            { value: "French Polynesia (+689)", label: "French Polynesia (+689)" },
            { value: "Georgia (+995)", label: "Georgia (+995)" },
            { value: "Germany (+49)", label: "Germany (+49)" },
            { value: "Gibraltar (+350)", label: "Gibraltar (+350)" },
            { value: "Greece (+30)", label: "Greece (+30)" },
            { value: "Greenland (+299)", label: "Greenland (+299)" },
            { value: "Hong Kong (SAR) (+852)", label: "Hong Kong (SAR) (+852)" },
            { value: "Hungary (+36)", label: "Hungary (+36)" },
            { value: "Iceland (+354)", label: "Iceland (+354)" },
            { value: "India (+91)", label: "India (+91)" },
            { value: "Indonesia (+62)", label: "Indonesia (+62)" },
            { value: "Ireland (+353)", label: "Ireland (+353)" },
            { value: "Israel (+972)", label: "Israel (+972)" },
            { value: "Italy (+39)", label: "Italy (+39)" },
            { value: "Jamaica (+1876)", label: "Jamaica (+1876)" },
            { value: "Japan (+81)", label: "Japan (+81)" },
            { value: "Jordan (+962)", label: "Jordan (+962)" },
            { value: "Kenya (+254)", label: "Kenya (+254)" },
            { value: "South (+82)", label: "Korea" },
            { value: "Kuwait (+965)", label: "Kuwait (+965)" },
            { value: "Latvia (+371)", label: "Latvia (+371)" },
            { value: "Lebanon (+961)", label: "Lebanon (+961)" },
            { value: "Luxembourg (+352)", label: "Luxembourg (+352)" },
            { value: "Malaysia (+60)", label: "Malaysia (+60)" },
            { value: "Mauritius (+230)", label: "Mauritius (+230)" },
            { value: "Mexico (+52)", label: "Mexico (+52)" },
            { value: "Morocco (+212)", label: "Morocco (+212)" },
            { value: "Nepal (+977)", label: "Nepal (+977)" },
            { value: "Netherlands (+31)", label: "Netherlands (+31)" },
            { value: "Netherlands Antilles (+599)", label: "Netherlands Antilles (+599)" },
            { value: "Nigeria (+234)", label: "Nigeria (+234)" },
            { value: "Norway (+47)", label: "Norway (+47)" },
            { value: "Oman (+968)", label: "Oman (+968)" },
            { value: "Pakistan (+92)", label: "Pakistan (+92)" },
            { value: "Panama (+507)", label: "Panama (+507)" },
            { value: "Papua New Guinea (+675)", label: "Papua New Guinea (+675)" },
            { value: "Paraguay (+595)", label: "Paraguay (+595)" },
            { value: "Peru (+51)", label: "Peru (+51)" },
            { value: "Philippines (+63)", label: "Philippines (+63)" },
            { value: "Poland (+48)", label: "Poland (+48)" },
            { value: "Portugal (+351)", label: "Portugal (+351)" },
            { value: "Puerto Rico (+1787)", label: "Puerto Rico (+1787)" },
            { value: "Qatar (+974)", label: "Qatar (+974)" },
            { value: "Romania (+40)", label: "Romania (+40)" },
            { value: "Russian Federation (+7)", label: "Russian Federation (+7)" },
            { value: "Saudi Arabia (+966)", label: "Saudi Arabia (+966)" },
            { value: "Singapore (+65)", label: "Singapore (+65)" },
            { value: "South Africa (+27)", label: "South Africa (+27)" },
            { value: "South Sudan (+211)", label: "South Sudan (+211)" },
            { value: "Spain (+34)", label: "Spain (+34)" },
            { value: "Sri Lanka (+94)", label: "Sri Lanka (+94)" },
            { value: "Sweden (+46)", label: "Sweden (+46)" },
            { value: "Switzerland (+41)", label: "Switzerland (+41)" },
            { value: "Taiwan (+886)", label: "Taiwan (+886)" },
            { value: "Thailand (+66)", label: "Thailand (+66)" },
            { value: "The Bahamas (+1242)", label: "The Bahamas (+1242)" },
            { value: "Turkey (+90)", label: "Turkey (+90)" },
            { value: "Turkmenistan (+993)", label: "Turkmenistan (+993)" },
            { value: "Turks and Caicos Islands (+1649)", label: "Turks and Caicos Islands (+1649)" },
            { value: "Ukraine (+380)", label: "Ukraine (+380)" },
            { value: "United Arab Emirates (+971)", label: "United Arab Emirates (+971)" },
            { value: "United Kingdom (+44)", label: "United Kingdom (+44)" },
            { value: "Uruguay (+598)", label: "Uruguay (+598)" },
            { value: "Venezuela (+58)", label: "Venezuela (+58)" },
            { value: "Vietnam (+84)", label: "Vietnam (+84)" },
            { value: "Virgin Islands (+1340)", label: "Virgin Islands (+1340)" },
            { value: "Zambia (+260)", label: "Zambia (+260)" },
            { value: "Zimbabwe (+263)", label: "Zimbabwe (+263)" }
        ];


        /* if (angular.element($window).width() < 460) {
             vm.reCaptchaSize = 'compact';
         }*/



        vm.registerAccount.domain = "";
        $http.get("https://api.ipify.org/?format=json").then(function (response) {
            vm.registerAccount.ip = response.data.ip;
        });

        $timeout(function () {
            angular.element('#login').focus();
        });

        $timeout(function () {
            grecaptcha.execute()
        }, 1000);

        setInterval(function () { grecaptcha.reset(); }, 1 * 60 * 1000);

        vm.emailTouched = false;
        vm.emailInvalid = false;
        vm.emailInvalidReason = '';
        
        EmailList.query({}, onSuccess, onError);
        
        vm.checkEmail = function(email) {
            return EmailList.checkEmailDomain(email.split('@')[1])
                .then(function(isBanned) {
                    vm.emailInvalid = isBanned;
                    vm.emailInvalidReason = isBanned ? 'blocked' : '';
                    return isBanned;
                })
                .catch(function(error) {
                    vm.emailInvalid = true;
                    vm.emailInvalidReason = 'error';
                    return true; // Treat errors as if the email is banned
                });
        };
        
        function onSuccess(data) {
            vm.blockedEmailDomains = data.map(function(resource) {
                return resource.domain;
            });
        
            vm.validateEmail = function() {
                vm.emailTouched = true;
                if (!vm.registerAccount) {
                    return;
                }
                var email = vm.registerAccount.email;
        
                if (!email || email.length < 5 || email.length > 100 || !vm.emailPattern.test(email)) {
                    vm.emailInvalid = true;
                    vm.emailInvalidReason = 'format';
                } else {
                    vm.checkEmail(email).then(function(isBanned) {
                        if (!isBanned) {
                            vm.emailInvalid = false;
                            vm.emailInvalidReason = '';
                        }
                    });
                }
            };
        }
        
        function onError(error) {
            console.error('Error fetching email list:', error);
            // Handle error (e.g., show an alert to the user)
        }
        
        function register() {

            /*if($scope.form.$invalid){
                vm.errorValidation = 'ERROR';
            }*/

            vm.registerAccount.langKey = 'en';
            vm.doNotMatch = null;
            vm.error = null;
            vm.errorUserExists = null;
            vm.errorEmailExists = null;
            vm.errorEmailNotAllowed = null;
            vm.registerAccount.login = vm.registerAccount.email;

            vm.registerAccount.firstName = vm.registerAccount.firstName;
            vm.registerAccount.domain = 'demo' + vm.registerAccount.login;

            Auth.createAccount(vm.registerAccount).then(function () {
                vm.success = 'OK';
                Auth.login({
                    username: vm.registerAccount.login,
                    password: vm.registerAccount.password,
                    rememberMe: false
                }).then(function () {
                    vm.authenticationError = false;
                    //$state.go('instance-dbh');

                    authClient.signIn({ username: vm.registerAccount.login, password: vm.registerAccount.password })
                        .then(function (res) {
                            if (res.status === 'SUCCESS') {
                                $rootScope.$broadcast('authenticationSuccess');

                                authClient.token.getWithRedirect({
                                    sessionToken: res.sessionToken,
                                    responseType: 'id_token'
                                });
                            }
                        }).fail(function (err) {
                            console.error(err);
                        });

                }).catch(function () {
                    vm.authenticationError = true;
                });
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.LOGIN_ALREADY_USED_TYPE) {
                    vm.errorUserExists = 'ERROR';
                } else if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_ALREADY_USED_TYPE) {
                    vm.errorEmailExists = 'ERROR';
                } else if (vm.error === 'EMAIL_NOT_ALLOWED') {
                    vm.errorEmailNotAllowed = 'ERROR';
                }
                /*else if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.COMPANY_ALREADY_USED_TYPE) {
                    vm.errorCompanyExists = 'ERROR';
                }*/
                else {
                    vm.error = 'ERROR';
                }
            });
        }

        vm.loginPage = function () {
            $state.go('signin');
        }

        /*vm.processDomain = function () {
            vm.registerAccount.domain = vm.registerAccount.firstName.replace(/[^a-z0-9]/gi, '').toLowerCase();
        }*/

        vm.getPasswordPattern = function () {
            if (vm.registerAccount.email) {
                if (!vm.passwordExcudedEmailPattern) {
                    var passPattern = passwordPattern + "";
                    vm.passwordExcudedEmailPattern = new RegExp(passPattern.slice(1, -1) + "(?!.*" + vm.registerAccount.email + ")");
                }
                return vm.passwordExcudedEmailPattern;

            } else {
                return passwordPattern;
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('my-profile', {
            parent: 'account',
            url: '/my-profile',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'DBHawk: My Profile'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/profile/profile.html',
                    controller: 'ProfileController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('ProfileController', ProfileController);

    ProfileController.$inject = ['Auth', 'Principal', 'DbhawkUserService'];

    function ProfileController (Auth, Principal, DbhawkUserService) {
        var vm = this;

        vm.changeProfile = changeProfile;
        vm.error = null;
        vm.success = null;
		vm.profileParam = {};

        Principal.identity().then(function(account) {
			vm.profileParam.email = account.email;
        });
		
	    DbhawkUserService.getCompanyDetails().then(
            function (response) {
				vm.profileParam.company_name = response.data.companyName;

            }).catch(function (response) {
          
        });

        function changeProfile () {
    
        }

    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('cloudApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small>Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'DBHawk: Password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal', 'password_pattern'];

    function PasswordController (Auth, Principal, passwordPattern) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.success = null;
        vm.passwordExcudedEmailPattern = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.oldPassword, vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }

        vm.getPasswordPattern = function () {
            if (vm.account.email) {
                if (!vm.passwordExcudedEmailPattern) {
                    var passPattern = passwordPattern + "";
                    vm.passwordExcudedEmailPattern = new RegExp(passPattern.slice(1, -1) + "(?!.*" + vm.account.email + ")");
                }
                return vm.passwordExcudedEmailPattern;

            } else {
                return passwordPattern;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('delete', {
            parent: 'account',
            url: '/delete-account',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'DBHawk: Delete Account'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/delete-account/delete-account.html',
                    controller: 'DeleteAccountController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('DeleteAccountController', DeleteAccountController);

    DeleteAccountController.$inject = ['Auth', 'Principal'];

    function DeleteAccountController (Auth, Principal) {
        var vm = this;
		
		vm.deleteAccount = deleteAccount;
		vm.logout = logout;

        function deleteAccount() {
      
			Principal.identity(true).then(function(account) {
				Auth.deleteAccount(account).then(function() {
					vm.error = null;
					vm.success = 'OK';
					vm.logout();
				}).catch(function() {
					vm.success = null;
					vm.error = 'ERROR';
				});
			});
        }
		
		function logout() {
            Auth.logout();
            $state.go('home');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .service('InviteService', InviteService);

    InviteService.$inject = ['$http'];

    function InviteService($http) {
        this.getInvite = function getInvite(invite){
            return $http.get(SERVER_API_URL+'api/invites/'+invite);
        }

        /*this.sendInviteAdmin = function sendInvite(account, company, instance){
            return $http.post(SERVER_API_URL+'api/registerdbhawkadmin/'+company+'/'+instance, account);
        }*/
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('company', {
            parent: 'home',
            url: 'company',
            data: {
                authorities: [],
                pageTitle: 'Registration User'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/company/company.html',
                    controller: 'CompanyController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('CompanyRes', CompanyRes);

    CompanyRes.$inject = ['$resource'];

    function CompanyRes ($resource) {
        var service = $resource(SERVER_API_URL+'api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            },
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('CompanyController', CompanyController);


    CompanyController.$inject = [ '$timeout', 'Auth', 'LoginService', 'errorConstants', '$state', '$location', 'Company', 'InviteService', 'AlertService'];

    function CompanyController ($timeout, Auth, LoginService, errorConstants, $state, $location, Company, InviteService, AlertService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        var obj = $location.search();

        if(!(obj.company && obj.invite)) {
            $state.go('home');
        }
        else{
            Company.get({id: obj.company}).$promise.then(function(comp) {
                vm.company = comp;
            }, function(errResponse) {
                vm.error = 'Company not found';
            });

            InviteService.getInvite(obj.invite).then(function(response) {
                var data = response.data;
                vm.invite = data;
                vm.registerAccount.email = vm.invite.email;

            }).catch(function(response) {
                AlertService.error(response);
            });



        }


        function register () {

            var obj = $location.search();

            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey =  'en' ;
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;
                vm.registerAccount.login = vm.registerAccount.email;

                Auth.registerDbhawk(vm.registerAccount, obj.company, obj.invite ).then(function (response) {
                    vm.result = response;
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.LOGIN_ALREADY_USED_TYPE) {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_ALREADY_USED_TYPE) {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'Activation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            }/*,
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ]
            }*/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService', '$state'];

    function ActivationController ($stateParams, Auth, LoginService, $state) {
        var vm = this;

        Auth.activateAccount(verificationData).then(function () {
            vm.error = null;
            vm.success = 'OK';

        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = function () {
            $state.go('signin');
        };

        vm.home = function () {
            $state.go('instance-dbh');
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('cloudApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('cloudApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/contact/contact.html','<section id="page-title" class="padding-top-15 padding-bottom-15">\r\n    <div class="row">\r\n        <h1 class="mainTitle">Contact Us</h1>\r\n        <div class="reload-block">\r\n\r\n        </div>\r\n\r\n    </div>\r\n</section>\r\n\r\n<div class="container-fluid container-fullws mlr-0" >\r\n    <div class="row">\r\n\t\t\t<div class="col-sm-8 col-sm-offset-2 col-md-10 col-md-offset-1">\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<div class="col-sm-12 col-md-6 border-right">\r\n\t\t\t\t\t\t<div class="panel panel-white">\r\n\t\t\t\t\t\t\t\t<div class="col-sm-12">\r\n\t\t\t\t\t\t\t\t<h3 class="color-blue">Get in touch with us</h3>\r\n\t\t\t\t\t\t\t\t\t     <form name="form" role="form" novalidate ng-submit="vm.contact()"\r\n\t\t\t\t\t\t\t\t\t\t\tshow-validation>\r\n\t\t\t\t\t\t\t\t\t\t\t<jhi-alert></jhi-alert>\r\n\t\t\t\t\t\t\t\t\t\t\t<p>\r\n\t\t\t\t\t\t\t\t\t\t\t\tIf you have, any questions send us a message and we will answer as soon as possible.\r\n\t\t\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="control-label" for="field_region">Subject</label>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<select class="form-control" id="field_region" name="region" ng-model="vm.contactParam.subject">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<option value="Pricing Details">Pricing Details</option>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<option value="Pricing Details">Technical Support</option>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<option value="Other">Other</option>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</select>\r\n\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" id="name" name="contactName" placeholder="Your Name"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tuib-tooltip="Name is required" tooltip-is-open="form.contactName.$dirty && form.contactName.$invalid"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\ttooltip-trigger="none" tooltip-placement="auto right" style=""\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-model="vm.contactParam.contactName" ng-minlength=2 ng-maxlength=100 required>\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="control-label">Company Email * </label>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="email" class="form-control" id="em" name="em" ng-model="vm.contactParam.email"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t   uib-tooltip="Invalid Email" tooltip-is-open="form.em.$invalid && form.em.$dirty"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t   tooltip-trigger="none" tooltip-placement="auto right"  required>\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="control-label">Telephone number *</label>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" id="tel" name="phone" ng-model="vm.contactParam.phone" placeholder="6782214185"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tuib-tooltip="Invalid Phone Number" tooltip-is-open="form.phone.$invalid && form.phone.$dirty"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\ttooltip-trigger="none" tooltip-placement="auto right" ng-intl-tel-input required\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t   ng-pattern="/^\\+?\\d{9,10}$/">\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="control-label" for="message">Message *</label>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<textarea class="form-control textarea" id="message" name="message" placeholder="Your Message"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tuib-tooltip=" Your Message is required to be at least 2 characters and no longer 750 characters." tooltip-is-open="form.message.$dirty && form.message.$invalid"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\ttooltip-trigger="none" tooltip-placement="auto right" ng-model="vm.contactParam.message"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-minlength=2 ng-maxlength=750 required cols="5" rows="3"></textarea>\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\r\n\r\n\t\t\t\t\t\t\t\t\t\t\t<div class="form-actions">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<button type="submit" ng-disabled="form.$invalid" class="btn btn-primary pull-right">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tSubmit <i class="fa fa-arrow-circle-right"></i>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t\t\t\t\t</form>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class="col-sm-12 col-md-6 pt-125 pl-50">\r\n\t\t\t\t\t\t<div class="panel panel-white">\r\n\t\t\t\t\t\t\t\t<div class="col-sm-12">\r\n\t\t\t\t\t\t\t\t\t<div class="text-center">\r\n\t\t\t\t\t\t\t\t\t\t<h2 class="mb-1 fs-29">Contact Details</h2>\r\n\t\t\t\t\t\t\t\t\t\t<div class="red-divider"></div>\r\n\t\t\t\t\t\t\t\t\t\t<div class="location-content">\r\n\t\t\t\t\t\t\t\t\t\t\t<div>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<h4 class="cont-add"><i class="fa fa-map-marker"></i>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tSan Diego, CA<br>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t13223-1 Black Mountain Road<br>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tSan Diego, CA 92129<br>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tUSA<br>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</h4><br />\r\n\t\t\t\t\t\t\t\t\t\t\t\t<h4 class="text-left m-l-35"><i class="fa fa-user"></i> Phone: (678) 221-4185</h4>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<h4 class="text-left m-l-35"><i class="fa fa-envelope"></i> Email: support@datasparc.com</h4>\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t\t\t\t\t<div class="alert alert-secondary">\r\n\t\t\t\t\t\t\t\t\t\t\t<h5 class="mb-1"> </h5>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n    </div>\r\n</div>\r\n\r\n<footer data-ng-include=" \'app/components/copyright/copyright.html\' "></footer>\r\n\r\n\r\n\r\n\r\n\r\n');
$templateCache.put('app/contact/thank-you.html','<div class="container-fluid container-fullws mlr-0" >\r\n    <div class="row">\r\n\t\t\t<div class="12">\r\n\t\t\t\t<div class="row">\r\n\t\t\t\t\t<h2 class="text-center">Thank You!</h2>\r\n\t\t\t\t\t<div class="red-divider"></div>\r\n\t\t\t\t\t<h4 class="text-center pt-30">The information you have provided has been sent. We will get back with you as soon as we can.</h4>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n    </div>\r\n</div>\r\n\r\n<footer data-ng-include=" \'app/components/copyright/copyright.html\' "></footer>\r\n');
$templateCache.put('app/documentation/documentation - Copy.html','<div class="container-fluid container-fullws mlr-0">\r\n          <div class="docs-wrapper">\r\n\t    <div id="docs-sidebar" class="docs-sidebar sidebar-visible">\r\n\t\t    <nav id="docs-nav" class="docs-nav">\r\n\t\t\t    <ul class="section-items list-unstyled nav flex-column pb-3">\r\n\t\t\t\t    <li class="nav-item section-title"><a class="nav-link scrollto active" href="#section-1" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy><span class="theme-icon-holder mr-2"><i class="ti-direction-alt"></i></span>Introduction</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-1" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Connect to various databases</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-2" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 1.2</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-3" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 1.3</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-4"ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 1.4</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-5"ng-click="vm.itemClick()"  du-smooth-scroll du-scrollspy>Section Item 1.5</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-6" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 1.6</a></li>\r\n\t\t\t\t    <li class="nav-item section-title mt-3"><a class="nav-link scrollto" href="#section-2" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy><span class="theme-icon-holder mr-2"><i class="ti-arrow-down"></i></span>Installation</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-2-1" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 2.1</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-2-2" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 2.2</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-2-3" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 2.3</a></li>\r\n\t\t\t\t    <li class="nav-item section-title mt-3"><a class="nav-link scrollto" href="#section-3" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy><span class="theme-icon-holder mr-2"><i class="fa fa-inbox"></i></span>APIs</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-3-1" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 3.1</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-3-2" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 3.2</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-3-3" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 3.3</a></li>\r\n\t\t\t\t    <li class="nav-item section-title mt-3"><a class="nav-link scrollto" href="#section-4" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy><span class="theme-icon-holder mr-2"><i class="fa fa-cogs"></i></span>Integrations</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-4-1" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 4.1</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-4-2" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 4.2</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-4-3" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 4.3</a></li>\r\n\t\t\t\t    <li class="nav-item section-title mt-3"><a class="nav-link scrollto" href="#section-5" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy><span class="theme-icon-holder mr-2"><i class="fa fa-tools"></i></span>Utilities</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-5-1" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 5.1</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-5-2" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 5.2</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-5-3" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 5.3</a></li>\r\n\t\t\t\t    <li class="nav-item section-title mt-3"><a class="nav-link scrollto" ng-click="vm.itemClick()" href="#section-6" du-smooth-scroll du-scrollspy><span class="theme-icon-holder mr-2"><i class="fa fa-laptop-code"></i></span>Web</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-6-1" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 6.1</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-6-2" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 6.2</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-6-3" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 6.3</a></li>\r\n\t\t\t\t    <li class="nav-item section-title mt-3"><a class="nav-link scrollto" href="#section-7" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy><span class="theme-icon-holder mr-2"><i class="fa fa-tablet-alt"></i></span>Mobile</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-7-1" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 7.1</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-7-2" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 7.2</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-7-3" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 7.3</a></li>\r\n\t\t\t\t    <li class="nav-item section-title mt-3"><a class="nav-link scrollto" href="#section-8" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy><span class="theme-icon-holder mr-2"><i class="fa fa-book-reader"></i></span>Resources</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-8-1" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 8.1</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-8-2" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 8.2</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-8-3" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 8.3</a></li>\r\n\t\t\t\t    <li class="nav-item section-title mt-3"><a class="nav-link scrollto" href="#section-9" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy><span class="theme-icon-holder mr-2"><i class="fa fa-lightbulb"></i></span>FAQs</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-9-1" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 9.1</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-9-2" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 9.2</a></li>\r\n\t\t\t\t    <li class="nav-item"><a class="nav-link scrollto" href="#item-9-3" ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy>Section Item 9.3</a></li>\r\n\t\t\t    </ul>\r\n\r\n\t\t    </nav><!--//docs-nav-->\r\n\t\t\t\r\n\t    </div><!--//docs-sidebar-->\r\n\t    <div class="docs-content">\r\n\t\t<a  class="sidebar-toggler" ng-click="vm.triggerSlider()">\r\n\t\t\t\t<i class="ti-align-justify"></i>\r\n\t\t\t</a>\r\n\t\t    <div class="container">\r\n\t\t\t    <article class="docs-article" id="section-1">\r\n\t\t\t\t    <header class="docs-header">\r\n\t\t\t\t\t    <h1 class="docs-heading">Introduction <span class="docs-time">Last updated: 2019-06-01</span></h1>\r\n\t\t\t\t\t    <section class="docs-intro">\r\n\t\t\t\t\t\t    <p>Section intro goes here. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque finibus condimentum nisl id vulputate. Praesent aliquet varius eros interdum suscipit. Donec eu purus sed nibh convallis bibendum quis vitae turpis. Duis vestibulum diam lorem, vitae dapibus nibh facilisis a. Fusce in malesuada odio.</p>\r\n\t\t\t\t\t\t</section><!--//docs-intro-->\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t\t<h5>Github Code Example:</h5>\r\n\t\t\t\t\t\t<p>You can <a class="theme-link" href="https://gist.github.com/"  target="_blank">embed your code snippets using Github gists</a></p>\r\n\t\t\t\t\t\t<div class="docs-code-block">\r\n\t\t\t\t\t\t\t<!-- ** Embed github code starts ** -->\r\n\t\t\t\t\t\t\t<script src="https://gist.github.com/xriley/fce6cf71edfd2dadc7919eb9c98f3f17.js"></script>\r\n\t\t\t\t\t\t\t<!-- ** Embed github code ends ** -->\r\n\t\t\t\t\t\t</div><!--//docs-code-block-->\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t     <h5>Highlight.js Example:</h5>\r\n\t\t\t\t\t\t<p>You can <a class="theme-link" href="https://github.com/highlightjs/highlight.js" target="_blank">embed your code snippets using highlight.js</a> It supports <a class="theme-link" href="https://highlightjs.org/static/demo/" target="_blank">185 languages and 89 styles</a>.</p>\r\n\t\t\t\t\t\t<p>This template uses <a class="theme-link" href="https://highlightjs.org/static/demo/" target="_blank">Atom One Dark</a> style for the code blocks: <br><code>&#x3C;link rel=&#x22;stylesheet&#x22; href=&#x22;//cdnjs.cloudflare.com/ajax/libs/highlight.js/9.15.2/styles/atom-one-dark.min.css&#x22;&#x3E;</code></p>\r\n\t\t\t\t\t\t<div class="docs-code-block">\r\n\t\t\t\t\t\t\t<pre class="shadow-lg rounded"><code class="json hljs">[\r\n  {\r\n    <span class="hljs-attr">"title"</span>: <span class="hljs-string">"apples"</span>,\r\n    <span class="hljs-attr">"count"</span>: [<span class="hljs-number">12000</span>, <span class="hljs-number">20000</span>],\r\n    <span class="hljs-attr">"description"</span>: {<span class="hljs-attr">"text"</span>: <span class="hljs-string">"..."</span>, <span class="hljs-attr">"sensitive"</span>: <span class="hljs-literal">false</span>}\r\n  },\r\n  {\r\n    <span class="hljs-attr">"title"</span>: <span class="hljs-string">"oranges"</span>,\r\n    <span class="hljs-attr">"count"</span>: [<span class="hljs-number">17500</span>, <span class="hljs-literal">null</span>],\r\n    <span class="hljs-attr">"description"</span>: {<span class="hljs-attr">"text"</span>: <span class="hljs-string">"..."</span>, <span class="hljs-attr">"sensitive"</span>: <span class="hljs-literal">false</span>}\r\n  }\r\n]\r\n\r\n\r\n</code></pre>\r\n\t\t\t\t\t\t</div><!--//docs-code-block-->\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t\t\r\n\t\t\t\t    </header>\r\n\t\t\t\t    <section class="docs-section" id="item-1-1">\r\n\t\t\t\t\t\t<h2 class="section-heading">Connect to various databases</h2>\r\n\t\t\t\t\t\t<p>With DBHawk, you can connect to multiple databases. Once you are registered, click on the <b>Access DBHawk</b> button, it should launch the DBHawk web-application in the new browser tab. Go to the DBHawk application and select the desired database to connect.</p>\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t\t<figure class="figure docs-figure py-3">\r\n\t\t\t\t\t\t    <a href="assets/images/dbhawk-login.png" data-title="Image Lightbox Example" data-toggle="lightbox"><img class="figure-img img-fluid shadow rounded" src="assets/images/dbhawk-login.png" alt="" style="width: 600px;"></a>\r\n\t\t\t\t\t\t</figure>\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t\t<p>Code Example: <code>npm install &lt;package&gt;</code></p>\r\n\t\t\t\t\t\t<h5>Unordered List Examples:</h5>\r\n\t\t\t\t\t\t<ul>\r\n\t\t\t\t\t\t    <li><strong class="mr-1">HTML5:</strong> <code>&lt;div id="foo"&gt;</code></li>\r\n\t\t\t\t\t\t    <li><strong class="mr-1">CSS:</strong> <code>#foo { color: red }</code></li>\r\n\t\t\t\t\t\t    <li><strong class="mr-1">JavaScript:</strong> <code>console.log(&#x27;#foo\\bar&#x27;);</code></li>\r\n\t\t\t\t\t\t</ul>\r\n\t\t\t\t\t\t<h5>Ordered List Examples:</h5>\r\n\t\t\t\t\t\t<ol>\r\n\t\t\t\t\t\t\t<li>Download lorem ipsum dolor sit amet.</li>\r\n\t\t\t\t\t\t\t<li>Click ipsum faucibus venenatis.</li>\r\n\t\t\t\t\t\t\t<li>Configure fermentum malesuada nunc.</li>\r\n\t\t\t\t\t\t\t<li>Deploy donec non ante libero.</li>\r\n\t\t\t\t\t\t</ol>\r\n                        <h5>Callout Examples:</h5>\r\n                        <div class="callout-block callout-block-info">\r\n                            \r\n                            <div class="content">\r\n                                <h4 class="callout-title">\r\n\t                                <span class="callout-icon-holder mr-1">\r\n\t\t                                <i class="fas fa-info-circle"></i>\r\n\t\t                            </span><!--//icon-holder-->\r\n\t                                Note\r\n\t                            </h4>\r\n                                <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium <code>&lt;code&gt;</code> , Nemo enim ipsam voluptatem quia voluptas <a href="#">link example</a> sit aspernatur aut odit aut fugit.</p>\r\n                            </div><!--//content-->\r\n                        </div><!--//callout-block-->\r\n                        \r\n                        <div class="callout-block callout-block-warning">\r\n                            <div class="content">\r\n                                <h4 class="callout-title">\r\n\t                                <span class="callout-icon-holder mr-1">\r\n\t\t                                <i class="fas fa-bullhorn"></i>\r\n\t\t                            </span><!--//icon-holder-->\r\n\t                                Warning\r\n\t                            </h4>\r\n                                <p>Nunc hendrerit odio quis dignissim efficitur. Proin ut finibus libero. Morbi posuere fringilla felis eget sagittis. Fusce sem orci, cursus in tortor <a href="#">link example</a> tellus vel diam viverra elementum.</p>\r\n                            </div><!--//content-->\r\n                        </div><!--//callout-block-->\r\n                        \r\n                        <div class="callout-block callout-block-success">\r\n                            <div class="content">\r\n                                <h4 class="callout-title">\r\n\t                                <span class="callout-icon-holder mr-1">\r\n\t\t                                <i class="fas fa-thumbs-up"></i>\r\n\t\t                            </span><!--//icon-holder-->\r\n\t                                Tip\r\n\t                            </h4>\r\n                                <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. <a href="#">Link example</a> aenean commodo ligula eget dolor.</p>\r\n                            </div><!--//content-->\r\n                        </div><!--//callout-block-->\r\n                        \r\n                        <div class="callout-block callout-block-danger mr-1">\r\n                            <div class="content">\r\n                                <h4 class="callout-title">\r\n\t                                <span class="callout-icon-holder">\r\n\t\t                                <i class="fas fa-exclamation-triangle"></i>\r\n\t\t                            </span><!--//icon-holder-->\r\n\t                                Danger\r\n\t                            </h4>\r\n                                <p>Morbi eget interdum sapien. Donec sed turpis sed nulla lacinia accumsan vitae ut tellus. Aenean vestibulum <a href="#">Link example</a> maximus ipsum vel dignissim. Morbi ornare elit sit amet massa feugiat, viverra dictum ipsum pellentesque. </p>\r\n                            </div><!--//content-->\r\n                        </div><!--//callout-block-->\r\n                        \r\n                        <h5 class="mt-5">Alert Examples:</h5>\r\n                        <div class="alert alert-primary" role="alert">\r\n\t\t\t\t\t\t  This is a primary alert\u2014check it out!\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class="alert alert-secondary" role="alert">\r\n\t\t\t\t\t\t  This is a secondary alert\u2014check it out!\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class="alert alert-success" role="alert">\r\n\t\t\t\t\t\t  This is a success alert\u2014check it out!\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class="alert alert-danger" role="alert">\r\n\t\t\t\t\t\t  This is a danger alert\u2014check it out!\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class="alert alert-warning" role="alert">\r\n\t\t\t\t\t\t  This is a warning alert\u2014check it out!\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class="alert alert-info" role="alert">\r\n\t\t\t\t\t\t  This is a info alert\u2014check it out!\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class="alert alert-light" role="alert">\r\n\t\t\t\t\t\t  This is a light alert\u2014check it out!\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class="alert alert-dark" role="alert">\r\n\t\t\t\t\t\t  This is a dark alert\u2014check it out!\r\n\t\t\t\t\t\t</div>\r\n                        \r\n                       \r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t\t\t\r\n\t\t\t\t\t<section class="docs-section" id="item-1-2">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 1.2</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t\t<h5>Image Lightbox Example:</h5>\r\n\t\t\t\t\t\t<figure class="figure docs-figure py-3">\r\n\t\t\t\t\t\tC:\\bb\\dbhawk-cloud\\src\\main\\webapp\\app\\documentation\\assets\\images\r\n\t\t\t\t\t\t    <a href="assets/images/dbhawk-login.png" data-title="Image Lightbox Example" data-toggle="lightbox"><img class="figure-img img-fluid shadow rounded" src="assets/images/dbhawk-login.png" alt="" style="width: 430px;"></a>\r\n\t\t\t\t\t\t    <figcaption class="figure-caption mt-3"><i class="fas fa-info-circle mr-2"></i>Credit: the above screencast is taken from <a  class="theme-link" href="https://themes.3rdwavemedia.com/bootstrap-templates/product/appify-bootstrap-4-admin-template-for-app-developers/" target="_blank"><i class="fas fa-external-link-alt"></i>Appify theme</a>.</figcaption>\r\n\t\t\t\t\t\t</figure>\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t\t<h5>Custom Table:</h5>\r\n\t\t\t\t\t\t<div class="table-responsive my-4">\r\n\t\t\t\t\t\t\t<table class="table table-bordered">\r\n\t\t\t\t\t\t\t\t<tbody>\r\n\t\t\t\t\t\t\t\t    <tr>\r\n\t\t\t\t\t\t\t\t\t    <th class="theme-bg-light"><a class="theme-link" href="#">Option 1</a></th>\r\n\t\t\t\t\t\t\t\t\t    <td>Option 1 desc lorem ipsum dolor sit amet, consectetur adipiscing elit. </td>\r\n\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t      <th class="theme-bg-light"><a class="theme-link" href="#">Option 2</a></th>\r\n\t\t\t\t\t\t\t\t\t      <td>Option 2 desc lorem ipsum dolor sit amet, consectetur adipiscing elit. </td>\r\n\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t    <th class="theme-bg-light"><a class="theme-link" href="#">Option 3</a></th>\r\n\t\t\t\t\t\t\t\t\t    <td>Option 3 desc lorem ipsum dolor sit amet, consectetur adipiscing elit. </td>\r\n\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t    <th class="theme-bg-light"><a class="theme-link" href="#">Option 4</a></th>\r\n\t\t\t\t\t\t\t\t\t    <td>Option 4 desc lorem ipsum dolor sit amet, consectetur adipiscing elit. </td>\r\n\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t</tbody>\r\n\t\t\t\t\t\t\t</table>\r\n\t\t\t\t\t\t</div><!--//table-responsive-->\r\n\t\t\t\t\t\t<h5>Stripped Table:</h5>\r\n\t\t\t\t\t\t<div class="table-responsive my-4">\r\n\t\t\t\t\t\t\t<table class="table table-striped">\r\n\t\t\t\t\t\t\t\t<thead>\r\n\t\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t\t<th scope="col">#</th>\r\n\t\t\t\t\t\t\t\t\t\t<th scope="col">First</th>\r\n\t\t\t\t\t\t\t\t\t\t<th scope="col">Last</th>\r\n\t\t\t\t\t\t\t\t\t\t<th scope="col">Handle</th>\r\n\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t</thead>\r\n\t\t\t\t\t\t\t\t<tbody>\r\n\t\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t\t<th scope="row">1</th>\r\n\t\t\t\t\t\t\t\t\t\t<td>Mark</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>Otto</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>@mdo</td>\r\n\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t\t<th scope="row">2</th>\r\n\t\t\t\t\t\t\t\t\t\t<td>Jacob</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>Thornton</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>@fat</td>\r\n\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t\t<th scope="row">3</th>\r\n\t\t\t\t\t\t\t\t\t\t<td>Larry</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>the Bird</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>@twitter</td>\r\n\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t</tbody>\r\n\t\t\t\t\t\t\t</table>\r\n\t\t\t\t\t\t</div><!--//table-responsive-->\r\n\t\t\t\t\t\t<h5>Bordered Dark Table:</h5>\r\n\t\t\t\t\t\t<div class="table-responsive my-4">\r\n\t\t\t\t\t\t\t<table class="table table-bordered table-dark">\r\n\t\t\t\t\t\t\t\t<thead>\r\n\t\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t\t<th scope="col">#</th>\r\n\t\t\t\t\t\t\t\t\t\t<th scope="col">First</th>\r\n\t\t\t\t\t\t\t\t\t\t<th scope="col">Last</th>\r\n\t\t\t\t\t\t\t\t\t\t<th scope="col">Handle</th>\r\n\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t</thead>\r\n\t\t\t\t\t\t\t\t<tbody>\r\n\t\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t\t<th scope="row">1</th>\r\n\t\t\t\t\t\t\t\t\t\t<td>Mark</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>Otto</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>@mdo</td>\r\n\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t\t<th scope="row">2</th>\r\n\t\t\t\t\t\t\t\t\t\t<td>Jacob</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>Thornton</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>@fat</td>\r\n\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t\t\t<th scope="row">3</th>\r\n\t\t\t\t\t\t\t\t\t\t<td>Larry</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>the Bird</td>\r\n\t\t\t\t\t\t\t\t\t\t<td>@twitter</td>\r\n\t\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t\t</tbody>\r\n\t\t\t\t\t\t\t</table>\r\n\t\t\t\t\t\t</div><!--//table-responsive-->\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t\t\t\r\n\t\t\t\t\t<section class="docs-section" id="item-1-3">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 1.3</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t\t<h5>Badges Examples:</h5>\r\n\t\t\t\t\t\t<div class="my-4">\r\n\t\t\t\t\t\t    <span class="badge badge-primary">Primary</span>\r\n\t\t\t\t\t\t\t<span class="badge badge-secondary">Secondary</span>\r\n\t\t\t\t\t\t\t<span class="badge badge-success">Success</span>\r\n\t\t\t\t\t\t\t<span class="badge badge-danger">Danger</span>\r\n\t\t\t\t\t\t\t<span class="badge badge-warning">Warning</span>\r\n\t\t\t\t\t\t\t<span class="badge badge-info">Info</span>\r\n\t\t\t\t\t\t\t<span class="badge badge-light">Light</span>\r\n\t\t\t\t\t\t\t<span class="badge badge-dark">Dark</span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<h5>Button Examples:</h5>\r\n\t\t\t\t\t\t<div class="row my-3">\r\n                        <div class="col-md-6 col-12">\r\n                                <ul class="list list-unstyled pl-0">\r\n                                    <li><a href="#" class="btn btn-primary">Primary Button</a></li>\r\n                                    <li><a href="#" class="btn btn-secondary">Secondary Button</a></li>\r\n                                    <li><a href="#" class="btn btn-light">Light Button</a></li>\r\n                                    <li><a href="#" class="btn btn-success">Succcess Button</a></li>\r\n                                    <li><a href="#" class="btn btn-info">Info Button</a></li>\r\n                                    <li><a href="#" class="btn btn-warning">Warning Button</a></li>\r\n                                    <li><a href="#" class="btn btn-danger">Danger Button</a></li>\r\n                                </ul>\r\n                            </div>\r\n                            <div class="col-md-6 col-12">\r\n                                <ul class="list list-unstyled pl-0">\r\n                                    <li><a href="#" class="btn btn-primary"><i class="fas fa-download mr-2"></i> Download Now</a></li>\r\n                                    <li><a href="#" class="btn btn-secondary"><i class="fas fa-book mr-2"></i> View Docs</a></li>\r\n                                    <li><a href="#" class="btn btn-light"><i class="fas fa-arrow-alt-circle-right mr-2"></i> View Features</a></li>\r\n                                    <li><a href="#" class="btn btn-success"><i class="fas fa-code-branch mr-2"></i> Fork Now</a></li>\r\n                                    <li><a href="#" class="btn btn-info"><i class="fas fa-play-circle mr-2"></i> Find Out Now</a></li>\r\n                                    <li><a href="#" class="btn btn-warning"><i class="fas fa-bug mr-2"></i> Report Bugs</a></li>\r\n                                    <li><a href="#" class="btn btn-danger"><i class="fas fa-exclamation-circle mr-2"></i> Submit Issues</a></li>\r\n                                </ul>\r\n                            </div>\r\n                        </div><!--//row-->\r\n                        \r\n                        <h5>Progress Examples:</h5>\r\n                        <div class="my-4">\r\n\t                        <div class="progress my-4">\r\n\t\t\t\t\t\t\t\t<div class="progress-bar bg-success" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<div class="progress my-4">\r\n\t\t\t\t\t\t\t    <div class="progress-bar bg-info" role="progressbar" style="width: 50%" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<div class="progress my-4">\r\n\t\t\t\t\t\t\t    <div class="progress-bar bg-warning" role="progressbar" style="width: 75%" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<div class="progress my-4">\r\n\t\t\t\t\t\t\t    <div class="progress-bar bg-danger" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>\r\n\t\t\t\t\t\t\t</div>\r\n                        </div>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t\t\t\r\n\t\t\t\t\t<section class="docs-section" id="item-1-4">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 1.4</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t\t<h5>Pagination Example:</h5>\r\n\t\t\t\t\t\t<nav aria-label="Page navigation example">\r\n\t\t\t\t\t\t    <ul class="pagination pl-0">\r\n\t\t\t\t\t\t\t    <li class="page-item disabled"><a class="page-link" href="#">Previous</a></li>\r\n\t\t\t\t\t\t\t    <li class="page-item active"><a class="page-link" href="#">1</a></li>\r\n\t\t\t\t\t\t\t    <li class="page-item"><a class="page-link" href="#">2</a></li>\r\n\t\t\t\t\t\t\t    <li class="page-item"><a class="page-link" href="#">3</a></li>\r\n\t\t\t\t\t\t\t    <li class="page-item"><a class="page-link" href="#">Next</a></li>\r\n\t\t\t\t\t\t    </ul>\r\n\t\t\t\t\t\t</nav>\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t\t\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t\t\t<section class="docs-section" id="item-1-5">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 1.5</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t\t\t<section class="docs-section" id="item-1-6">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 1.6</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t\t\t\r\n\t\t\t    </article>\r\n\t\t\t    \r\n\t\t\t    <article class="docs-article" id="section-2">\r\n\t\t\t\t    <header class="docs-header">\r\n\t\t\t\t\t    <h1 class="docs-heading">Installation</h1>\r\n\t\t\t\t\t    <section class="docs-intro">\r\n\t\t\t\t\t\t    <p>Section intro goes here. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque finibus condimentum nisl id vulputate. Praesent aliquet varius eros interdum suscipit. Donec eu purus sed nibh convallis bibendum quis vitae turpis. Duis vestibulum diam lorem, vitae dapibus nibh facilisis a. Fusce in malesuada odio.</p>\r\n\t\t\t\t\t\t</section><!--//docs-intro-->\r\n\t\t\t\t    </header>\r\n\t\t\t\t     <section class="docs-section" id="item-2-1">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 2.1</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t\t\t\r\n\t\t\t\t\t<section class="docs-section" id="item-2-2">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 2.2</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t\t\t\r\n\t\t\t\t\t<section class="docs-section" id="item-2-3">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 2.3</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t    </article><!--//docs-article-->\r\n\t\t\t    \r\n\t\t\t    \r\n\t\t\t    <article class="docs-article" id="section-3">\r\n\t\t\t\t    <header class="docs-header">\r\n\t\t\t\t\t    <h1 class="docs-heading">APIs</h1>\r\n\t\t\t\t\t    <section class="docs-intro">\r\n\t\t\t\t\t\t    <p>Section intro goes here. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque finibus condimentum nisl id vulputate. Praesent aliquet varius eros interdum suscipit. Donec eu purus sed nibh convallis bibendum quis vitae turpis. Duis vestibulum diam lorem, vitae dapibus nibh facilisis a. Fusce in malesuada odio.</p>\r\n\t\t\t\t\t\t</section><!--//docs-intro-->\r\n\t\t\t\t    </header>\r\n\t\t\t\t     <section class="docs-section" id="item-3-1">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 3.1</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t\t\t\r\n\t\t\t\t\t<section class="docs-section" id="item-3-2">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 3.2</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t\t\t\r\n\t\t\t\t\t<section class="docs-section" id="item-3-3">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 3.3</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t    </article><!--//docs-article-->\r\n\t\t\t    \r\n\t\t\t    <article class="docs-article" id="section-4">\r\n\t\t\t\t    <header class="docs-header">\r\n\t\t\t\t\t    <h1 class="docs-heading">Intergrations</h1>\r\n\t\t\t\t\t    <section class="docs-intro">\r\n\t\t\t\t\t\t    <p>Section intro goes here. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque finibus condimentum nisl id vulputate. Praesent aliquet varius eros interdum suscipit. Donec eu purus sed nibh convallis bibendum quis vitae turpis. Duis vestibulum diam lorem, vitae dapibus nibh facilisis a. Fusce in malesuada odio.</p>\r\n\t\t\t\t\t\t</section><!--//docs-intro-->\r\n\t\t\t\t    </header>\r\n\t\t\t\t     <section class="docs-section" id="item-4-1">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 4.1</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t\t\t\r\n\t\t\t\t\t<section class="docs-section" id="item-4-2">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 4.2</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t\t\t\r\n\t\t\t\t\t<section class="docs-section" id="item-4-3">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 4.3</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t    </article><!--//docs-article-->\r\n\t\t\t    \r\n\t\t\t    <article class="docs-article" id="section-5">\r\n\t\t\t\t    <header class="docs-header">\r\n\t\t\t\t\t    <h1 class="docs-heading">Utilities</h1>\r\n\t\t\t\t\t    <section class="docs-intro">\r\n\t\t\t\t\t\t    <p>Section intro goes here. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque finibus condimentum nisl id vulputate. Praesent aliquet varius eros interdum suscipit. Donec eu purus sed nibh convallis bibendum quis vitae turpis. Duis vestibulum diam lorem, vitae dapibus nibh facilisis a. Fusce in malesuada odio.</p>\r\n\t\t\t\t\t\t</section><!--//docs-intro-->\r\n\t\t\t\t    </header>\r\n\t\t\t\t     <section class="docs-section" id="item-5-1">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 5.1</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t\t\t\r\n\t\t\t\t\t<section class="docs-section" id="item-5-2">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 5.2</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t\t\t\r\n\t\t\t\t\t<section class="docs-section" id="item-5-3">\r\n\t\t\t\t\t\t\t<h2 class="section-heading">Section Item 5.3</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t    </article><!--//docs-article-->\r\n\t\t\t    \r\n\t\t\t    \r\n\t\t        <article class="docs-article" id="section-6">\r\n\t\t\t\t    <header class="docs-header">\r\n\t\t\t\t\t    <h1 class="docs-heading">Web</h1>\r\n\t\t\t\t\t    <section class="docs-intro">\r\n\t\t\t\t\t\t    <p>Section intro goes here. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque finibus condimentum nisl id vulputate. Praesent aliquet varius eros interdum suscipit. Donec eu purus sed nibh convallis bibendum quis vitae turpis. Duis vestibulum diam lorem, vitae dapibus nibh facilisis a. Fusce in malesuada odio.</p>\r\n\t\t\t\t\t\t</section><!--//docs-intro-->\r\n\t\t\t\t    </header>\r\n\t\t\t\t     <section class="docs-section" id="item-6-1">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 6.1</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t\t\t\r\n\t\t\t\t\t<section class="docs-section" id="item-6-2">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 6.2</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t\t\t\r\n\t\t\t\t\t<section class="docs-section" id="item-6-3">\r\n\t\t\t\t\t\t\t<h2 class="section-heading">Section Item 6.3</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t    </article><!--//docs-article-->\r\n\t\t\t    \r\n\t\t\t    \r\n\t\t\t    <article class="docs-article" id="section-7">\r\n\t\t\t\t    <header class="docs-header">\r\n\t\t\t\t\t    <h1 class="docs-heading">Mobile</h1>\r\n\t\t\t\t\t    <section class="docs-intro">\r\n\t\t\t\t\t\t    <p>Section intro goes here. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque finibus condimentum nisl id vulputate. Praesent aliquet varius eros interdum suscipit. Donec eu purus sed nibh convallis bibendum quis vitae turpis. Duis vestibulum diam lorem, vitae dapibus nibh facilisis a. Fusce in malesuada odio.</p>\r\n\t\t\t\t\t\t</section><!--//docs-intro-->\r\n\t\t\t\t    </header>\r\n\t\t\t\t     <section class="docs-section" id="item-7-1">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 7.1</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t\t\t\r\n\t\t\t\t\t<section class="docs-section" id="item-7-2">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 7.2</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t\t\t\r\n\t\t\t\t\t<section class="docs-section" id="item-7-3">\r\n\t\t\t\t\t\t\t<h2 class="section-heading">Section Item 7.3</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t    </article><!--//docs-article-->\r\n\t\t\t    \r\n\t\t\t    \r\n\t\t\t    <article class="docs-article" id="section-8">\r\n\t\t\t\t    <header class="docs-header">\r\n\t\t\t\t\t    <h1 class="docs-heading">Resources</h1>\r\n\t\t\t\t\t    <section class="docs-intro">\r\n\t\t\t\t\t\t    <p>Section intro goes here. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque finibus condimentum nisl id vulputate. Praesent aliquet varius eros interdum suscipit. Donec eu purus sed nibh convallis bibendum quis vitae turpis. Duis vestibulum diam lorem, vitae dapibus nibh facilisis a. Fusce in malesuada odio.</p>\r\n\t\t\t\t\t\t</section><!--//docs-intro-->\r\n\t\t\t\t    </header>\r\n\t\t\t\t     <section class="docs-section" id="item-8-1">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 8.1</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t\t\t\r\n\t\t\t\t\t<section class="docs-section" id="item-8-2">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 8.2</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t\t\t\r\n\t\t\t\t\t<section class="docs-section" id="item-8-3">\r\n\t\t\t\t\t\t\t<h2 class="section-heading">Section Item 8.3</h2>\r\n\t\t\t\t\t\t<p>Vivamus efficitur fringilla ullamcorper. Cras condimentum condimentum mauris, vitae facilisis leo. Aliquam sagittis purus nisi, at commodo augue convallis id. Sed interdum turpis quis felis bibendum imperdiet. Mauris pellentesque urna eu leo gravida iaculis. In fringilla odio in felis ultricies porttitor. Donec at purus libero. Vestibulum libero orci, commodo nec arcu sit amet, commodo sollicitudin est. Vestibulum ultricies malesuada tempor.</p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t    </article><!--//docs-article-->\r\n\t\t\t    \r\n\t\t\t    \r\n\t\t\t    <article class="docs-article" id="section-9">\r\n\t\t\t\t    <header class="docs-header">\r\n\t\t\t\t\t    <h1 class="docs-heading">FAQs</h1>\r\n\t\t\t\t\t    <section class="docs-intro">\r\n\t\t\t\t\t\t    <p>Section intro goes here. You can list all your FAQs using the format below.</p>\r\n\t\t\t\t\t\t</section><!--//docs-intro-->\r\n\t\t\t\t    </header>\r\n\t\t\t\t     <section class="docs-section" id="item-9-1">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 9.1 <small>(FAQ Category One)</small></h2>\r\n\t\t\t\t\t\t<h5 class="pt-3"><i class="fas fa-question-circle mr-1"></i>What\'s sit amet quam eget lacinia?</h5>\r\n\t\t\t\t\t\t<p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium.</p>\r\n\t\t\t\t\t\t<h5 class="pt-3"><i class="fas fa-question-circle mr-1"></i>How to ipsum dolor sit amet quam tortor?</h5>\r\n\t\t\t\t\t\t<p>Donec sodales sagittis magna. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. </p>\r\n\t\t\t\t\t\t<h5 class="pt-3"><i class="fas fa-question-circle mr-1"></i>Can I  bibendum sodales?</h5>\r\n\t\t\t\t\t\t<p>Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. </p>\r\n\t\t\t\t\t\t<h5 class="pt-3"><i class="fas fa-question-circle mr-1"></i>Where arcu sed urna gravida?</h5>\r\n\t\t\t\t\t\t<p>Aenean et sodales nisi, vel efficitur sapien. Quisque molestie diam libero, et elementum diam mollis ac. In dignissim aliquam est eget ullamcorper. Sed id sodales tortor, eu finibus leo. Vivamus dapibus sollicitudin justo vel fermentum. Curabitur nec arcu sed urna gravida lobortis. Donec lectus est, imperdiet eu viverra viverra, ultricies nec urna. </p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t\t\t\r\n\t\t\t\t\t<section class="docs-section" id="item-9-2">\r\n\t\t\t\t\t\t<h2 class="section-heading">Section Item 9.2 <small>(FAQ Category Two)</small></h2>\r\n\t\t\t\t\t\t<h5 class="pt-3"><i class="fas fa-question-circle mr-1"></i>What\'s sit amet quam eget lacinia?</h5>\r\n\t\t\t\t\t\t<p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium.</p>\r\n\t\t\t\t\t\t<h5 class="pt-3"><i class="fas fa-question-circle mr-1"></i>How to ipsum dolor sit amet quam tortor?</h5>\r\n\t\t\t\t\t\t<p>Donec sodales sagittis magna. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. </p>\r\n\t\t\t\t\t\t<h5 class="pt-3"><i class="fas fa-question-circle mr-1"></i>Can I  bibendum sodales?</h5>\r\n\t\t\t\t\t\t<p>Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. </p>\r\n\t\t\t\t\t\t<h5 class="pt-3"><i class="fas fa-question-circle mr-1"></i>Where arcu sed urna gravida?</h5>\r\n\t\t\t\t\t\t<p>Aenean et sodales nisi, vel efficitur sapien. Quisque molestie diam libero, et elementum diam mollis ac. In dignissim aliquam est eget ullamcorper. Sed id sodales tortor, eu finibus leo. Vivamus dapibus sollicitudin justo vel fermentum. Curabitur nec arcu sed urna gravida lobortis. Donec lectus est, imperdiet eu viverra viverra, ultricies nec urna. </p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t\t\t\r\n\t\t\t\t\t<section class="docs-section" id="item-9-3">\r\n\t\t\t\t\t\t\t<h2 class="section-heading">Section Item 9.3 <small>(FAQ Category Three)</small></h2>\r\n\t\t\t\t\t\t    <h5 class="pt-3"><i class="fas fa-question-circle mr-1"></i>How to dapibus sollicitudin justo vel fermentum?</h5>\r\n\t\t\t\t\t\t\t<p>Donec sodales sagittis magna. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. </p>\r\n\t\t\t\t\t\t\t<h5 class="pt-3"><i class="fas fa-question-circle mr-1"></i>How long bibendum sodales?</h5>\r\n\t\t\t\t\t\t\t<p>Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. </p>\r\n\t\t\t\t\t\t\t<h5 class="pt-3"><i class="fas fa-question-circle mr-1"></i>Where dapibus sollicitudin?</h5>\r\n\t\t\t\t\t\t\t<p>Aenean et sodales nisi, vel efficitur sapien. Quisque molestie diam libero, et elementum diam mollis ac. In dignissim aliquam est eget ullamcorper. Sed id sodales tortor, eu finibus leo. Vivamus dapibus sollicitudin justo vel fermentum. Curabitur nec arcu sed urna gravida lobortis. Donec lectus est, imperdiet eu viverra viverra, ultricies nec urna. </p>\r\n\t\t\t\t\t</section><!--//section-->\r\n\t\t\t    </article><!--//docs-article-->\r\n\r\n\t\t\t    <footer class="footer">\r\n\t\t\t\t    <div class="container text-center py-5">\r\n\t\t\t\t        <small class="copyright">Template Copyright &copy; <a href="https://themes.3rdwavemedia.com/" target="_blank">3rd Wave Media</a></small>\r\n\t\t\t\t        <ul class="social-list list-unstyled pt-4 mb-0">\r\n\t\t\t\t\t\t    <li class="list-inline-item"><a href="#"><i class="fab fa-github fa-fw"></i></a></li> \r\n\t\t\t\t            <li class="list-inline-item"><a href="#"><i class="fab fa-twitter fa-fw"></i></a></li>\r\n\t\t\t\t            <li class="list-inline-item"><a href="#"><i class="fab fa-slack fa-fw"></i></a></li>\r\n\t\t\t\t            <li class="list-inline-item"><a href="#"><i class="fab fa-product-hunt fa-fw"></i></a></li>\r\n\t\t\t\t            <li class="list-inline-item"><a href="#"><i class="fab fa-facebook-f fa-fw"></i></a></li>\r\n\t\t\t\t            <li class="list-inline-item"><a href="#"><i class="fab fa-instagram fa-fw"></i></a></li>\r\n\t\t\t\t        </ul><!--//social-list-->\r\n\t\t\t\t    </div>\r\n\t\t\t    </footer>\r\n\t\t    </div> \r\n\t    </div>\r\n    </div><!--//docs-wrapper-->\r\n\t\r\n\t\r\n          \r\n         \r\n</div>\r\n<footer data-ng-include=" \'app/components/copyright/copyright.html\' "></footer>\r\n\r\n');
$templateCache.put('app/documentation/documentation.html','<div class="container-fluid container-fullws mlr-0" style="padding-bottom: 200px">\r\n    <div class="docs-wrapper">\r\n        <div id="docs-sidebar" class="docs-sidebar sidebar-visible">\r\n            <nav id="docs-nav" class="docs-nav">\r\n                <ul class="section-items list-unstyled nav flex-column pb-3">\r\n                    <li class="nav-item section-title"><a class="nav-link scrollto active" href="#section-1"\r\n                                                          ng-click="vm.itemClick()" du-smooth-scroll du-scrollspy><span\r\n                        class="theme-icon-holder mr-2"><i class="ti-direction-alt"></i></span>Introduction</a></li>\r\n                    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-1" ng-click="vm.itemClick()"\r\n                                            du-smooth-scroll du-scrollspy>Change Theme</a></li>\r\n                    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-2" ng-click="vm.itemClick()"\r\n                                            du-smooth-scroll du-scrollspy>Connect to various databases</a></li>\r\n                    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-3" ng-click="vm.itemClick()"\r\n                                            du-smooth-scroll du-scrollspy>Browse database objects</a></li>\r\n                    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-4" ng-click="vm.itemClick()"\r\n                                            du-smooth-scroll du-scrollspy>View Table\'s data</a></li>\r\n                    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-5" ng-click="vm.itemClick()"\r\n                                            du-smooth-scroll du-scrollspy>Apply Data Filter</a></li>\r\n                    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-6" ng-click="vm.itemClick()"\r\n                                            du-smooth-scroll du-scrollspy>Export Data</a></li>\r\n                    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-7" ng-click="vm.itemClick()"\r\n                                            du-smooth-scroll du-scrollspy>Import Data</a></li>\r\n                    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-8" ng-click="vm.itemClick()"\r\n                                            du-smooth-scroll du-scrollspy>SQL Query Builder</a></li>\r\n                    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-9" ng-click="vm.itemClick()"\r\n                                            du-smooth-scroll du-scrollspy>SQL Query Editor</a></li>\r\n                    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-10" ng-click="vm.itemClick()"\r\n                                            du-smooth-scroll du-scrollspy>Manage Data Sources</a></li>\r\n                    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-11" ng-click="vm.itemClick()"\r\n                                            du-smooth-scroll du-scrollspy>Manage DBHawk Users & Groups</a></li>\r\n                    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-12" ng-click="vm.itemClick()"\r\n                                            du-smooth-scroll du-scrollspy>Object Access Control Policy</a></li>\r\n                    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-13" ng-click="vm.itemClick()"\r\n                                            du-smooth-scroll du-scrollspy>User Acitivities Auditing</a></li>\r\n                    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-14" ng-click="vm.itemClick()"\r\n                                            du-smooth-scroll du-scrollspy>LDAP, SAML, ADFS, Okta Integration</a></li>\r\n\r\n                    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-15" ng-click="vm.itemClick()"\r\n                                            du-smooth-scroll du-scrollspy>Data Reports</a></li>\r\n                    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-16" ng-click="vm.itemClick()"\r\n                                            du-smooth-scroll du-scrollspy>SQL Job Scheduler</a></li>\r\n                    <li class="nav-item"><a class="nav-link scrollto" href="#item-1-17" ng-click="vm.itemClick()"\r\n                                            du-smooth-scroll du-scrollspy>Charts & Dashboards</a></li>\r\n\r\n                </ul>\r\n\r\n            </nav><!--//docs-nav-->\r\n\r\n        </div><!--//docs-sidebar-->\r\n        <div class="docs-content">\r\n            <a class="sidebar-toggler" ng-click="vm.triggerSlider()">\r\n                <i class="ti-align-justify"></i>\r\n            </a>\r\n            <div class="container">\r\n                <article class="docs-article" id="section-1">\r\n                    <header class="docs-header">\r\n                        <h1 class="docs-heading">Introduction</h1>\r\n                        <section class="docs-intro">\r\n                            <p>Datasparc offers data security, database management, data governance and data analytics -\r\n                                all in one solution.\r\n\r\n                                With Datasparc\'s flagship product DBHawk, users only receive access to the data they\r\n                                need. DBHawk provides secure access to on-premise and cloud databases. DBHawk supports a\r\n                                wide array of SQL and NoSQL databases, including AWS Athena, Amazon Redshift, Cassandra,\r\n                                Greenplum, MongoDB, MySQL, Oracle, Microsoft SQL Server, SAP Hana, and Teradata. DBHawk\r\n                                integrates with SAML, LDAP, SSO, and OKTA. Its comprehensive object access control\r\n                                policy and auditing features allow logging all database activities, making it ideal for\r\n                                organizations seeking to comply with data protection regulations such as GDPR and HIPAA.\r\n\r\n                                CIOReview has named Datasparc as one of its Top 20 Most Promising Enterprise Security\r\n                                Solutions Providers for 2019.</p>\r\n                        </section><!--//docs-intro-->\r\n\r\n                        <section class="docs-section" id="item-1-1">\r\n                            <h2 class="section-heading">Change Theme</h2>\r\n                            <p>You can change the theme by clicking on the Profile button.</p>\r\n                            <figure class="figure docs-figure py-3">\r\n                                <a href="content/images/assets/images/change-theme.png"\r\n                                   data-title="Image Lightbox Example" data-toggle="lightbox"><img\r\n                                    class="figure-img img-fluid shadow rounded"\r\n                                    src="content/images/assets/images/change-theme.png" alt=""\r\n                                    style="width: 400px;"></a>\r\n                            </figure>\r\n                        </section><!--//section-->\r\n\r\n                        <section class="docs-section" id="item-1-2">\r\n                            <h2 class="section-heading">Connect to various databases</h2>\r\n                            <p>With DBHawk, you can connect to multiple databases. Once you are registered, click on the\r\n                                <b>Access DBHawk</b> button, it should launch the DBHawk web-application in the new\r\n                                browser tab. Go to the DBHawk application and select the desired database to connect.\r\n                            </p>\r\n                            <figure class="figure docs-figure py-3">\r\n                                <a href="content/images/assets/images/dbhawk-login.png"\r\n                                   data-title="Image Lightbox Example" data-toggle="lightbox"><img\r\n                                    class="figure-img img-fluid shadow rounded"\r\n                                    src="content/images/assets/images/dbhawk-login.png" alt=""\r\n                                    style="width: 600px;"></a>\r\n                            </figure>\r\n                        </section><!--//section-->\r\n\r\n                        <section class="docs-section" id="item-1-3">\r\n                            <h2 class="section-heading">Browse database objects</h2>\r\n                            <p>After successfully connecting to a particular database, you can browse various database\r\n                                objects. View table\'s data, get total rows in a table, as well as browse various other\r\n                                objects such as database views, indexes, sequences, functions, synonyms, procedures,\r\n                                etc.</p>\r\n                            <figure class="figure docs-figure py-3">\r\n                                <a href="content/images/assets/images/browse_database_objects.png"\r\n                                   data-title="Image Lightbox Example" data-toggle="lightbox"><img\r\n                                    class="figure-img img-fluid shadow rounded"\r\n                                    src="content/images/assets/images/browse_database_objects.png" alt=""\r\n                                    style="width: 187px;"></a>\r\n                            </figure>\r\n                        </section><!--//section-->\r\n\r\n                        <section class="docs-section" id="item-1-4">\r\n                            <h2 class="section-heading">View Table\'s data</h2>\r\n                            <p>After successfully connecting to a particular database, you can browse various database\r\n                                objects. View table\'s data, get total rows in a table</p>\r\n                            <figure class="figure docs-figure py-3">\r\n                                <a href="content/images/assets/images/view-table-data.png"\r\n                                   data-title="Image Lightbox Example" data-toggle="lightbox"><img\r\n                                    class="figure-img img-fluid shadow rounded"\r\n                                    src="content/images/assets/images/view-table-data.png" alt="" style="width: 400px;"></a>\r\n                            </figure>\r\n                        </section><!--//section-->\r\n\r\n                        <section class="docs-section" id="item-1-5">\r\n                            <h2 class="section-heading">Apply Data Filter</h2>\r\n                            <p>With DBHawk you can apply various data filters to Table or View\'s data.</p>\r\n                            <figure class="figure docs-figure py-3">\r\n                                <a href="content/images/assets/images/apply-data-filter.png"\r\n                                   data-title="Image Lightbox Example" data-toggle="lightbox"><img\r\n                                    class="figure-img img-fluid shadow rounded"\r\n                                    src="content/images/assets/images/apply-data-filter.png" alt=""\r\n                                    style="width: 600px;"></a>\r\n                            </figure>\r\n                        </section><!--//section-->\r\n\r\n                        <section class="docs-section" id="item-1-6">\r\n                            <h2 class="section-heading">Export Data</h2>\r\n                            <p>DBHawk supports exporting data in various formats such as Excel, PDF, CSV, HTML, etc. If\r\n                                AWS storage information is configured, it allows exporting data to the S3 bucket. DBHawk\r\n                                also supports exporting more than a million rows of data as Excel. In this case, DBHawk\r\n                                will create a new sheet for more than a million rows of data.</p>\r\n                            <figure class="figure docs-figure py-3">\r\n                                <a href="content/images/assets/images/export-data.png"\r\n                                   data-title="Image Lightbox Example" data-toggle="lightbox"><img\r\n                                    class="figure-img img-fluid shadow rounded"\r\n                                    src="content/images/assets/images/export-data.png" alt="" style="width: 600px;"></a>\r\n                            </figure>\r\n                        </section><!--//section-->\r\n\r\n                        <section class="docs-section" id="item-1-7">\r\n                            <h2 class="section-heading">Import Data</h2>\r\n                            <p>DBHawk allows importing CSV data into the Table. After successfully import, it also\r\n                                allows to schedule an import data job for auto import.</p>\r\n                            <figure class="figure docs-figure py-3">\r\n                                <a href="content/images/assets/images/import-data.png"\r\n                                   data-title="Image Lightbox Example" data-toggle="lightbox"><img\r\n                                    class="figure-img img-fluid shadow rounded"\r\n                                    src="content/images/assets/images/import-data.png" alt="" style="width: 600px;"></a>\r\n                            </figure>\r\n                        </section><!--//section-->\r\n\r\n                        <section class="docs-section" id="item-1-8">\r\n                            <h2 class="section-heading">SQL Query Builder</h2>\r\n                            <p>With DBHawk SQL Query Builder, you can drag and drop tables and build the query without\r\n                                writing any SQL statement.</p>\r\n                            <figure class="figure docs-figure py-3">\r\n                                <a href="content/images/assets/images/sql-query-builder.png"\r\n                                   data-title="Image Lightbox Example" data-toggle="lightbox"><img\r\n                                    class="figure-img img-fluid shadow rounded"\r\n                                    src="content/images/assets/images/sql-query-builder.png" alt=""\r\n                                    style="width: 600px;"></a>\r\n                            </figure>\r\n                        </section><!--//section-->\r\n\r\n                        <section class="docs-section" id="item-1-9">\r\n                            <h2 class="section-heading">SQL Query Editor</h2>\r\n                            <p>With DBHawk SQL Query Editor, you can write various SQL queries. You can export results\r\n                                in various formats. You can build charts, dashboards, schedule jobs to receive results\r\n                                automatically by email. You can create various data reports.</p>\r\n                            <figure class="figure docs-figure py-3">\r\n                                <a href="content/images/assets/images/SQL-Query-Editor.png"\r\n                                   data-title="Image Lightbox Example" data-toggle="lightbox"><img\r\n                                    class="figure-img img-fluid shadow rounded"\r\n                                    src="content/images/assets/images/SQL-Query-Editor.png" alt=""\r\n                                    style="width: 600px;"></a>\r\n                            </figure>\r\n                        </section><!--//section-->\r\n\r\n                        <section class="docs-section" id="item-1-10">\r\n                            <h2 class="section-heading">Manage Data Sources</h2>\r\n                            <p>With Full Access, you can log in to DBHawk with an admin user role. With the admin role,\r\n                                you can set up and manage various database connections.</p>\r\n                            <figure class="figure docs-figure py-3">\r\n                                <a href="content/images/assets/images/manage-datasources.png"\r\n                                   data-title="Image Lightbox Example" data-toggle="lightbox"><img\r\n                                    class="figure-img img-fluid shadow rounded"\r\n                                    src="content/images/assets/images/manage-datasources.png" alt=""\r\n                                    style="width: 600px;"></a>\r\n                            </figure>\r\n                        </section><!--//section-->\r\n\r\n                        <section class="docs-section" id="item-1-11">\r\n                            <h2 class="section-heading">Manage DBHawk Users & Groups</h2>\r\n                            <p>You can create DBHawk users with admin or a regular user role. You can set expiration\r\n                                date, set up 2FA, assign users to the various groups.</p>\r\n                            <figure class="figure docs-figure py-3">\r\n                                <a href="content/images/assets/images/dbhawk-user-mgmt.png"\r\n                                   data-title="Image Lightbox Example" data-toggle="lightbox"><img\r\n                                    class="figure-img img-fluid shadow rounded"\r\n                                    src="content/images/assets/images/dbhawk-user-mgmt.png" alt=""\r\n                                    style="width: 600px;"></a>\r\n                            </figure>\r\n                        </section><!--//section-->\r\n\r\n                        <section class="docs-section" id="item-1-12">\r\n                            <h2 class="section-heading">Object Access Control Policy</h2>\r\n                            <p>With DBHawk Object Control policy, you can restrict database object access. You can\r\n                                create a policy to allow access to only certain objects.</p>\r\n                            <figure class="figure docs-figure py-3">\r\n                                <a href="content/images/assets/images/object-access-control-policy.png"\r\n                                   data-title="Image Lightbox Example" data-toggle="lightbox">\r\n                                    <img class="figure-img img-fluid shadow rounded"\r\n                                         src="content/images/assets/images/object-access-control-policy.png" alt=""\r\n                                         style="width: 600px;"></a>\r\n                            </figure>\r\n                        </section><!--//section-->\r\n\r\n                        <section class="docs-section" id="item-1-13">\r\n                            <h2 class="section-heading">User Acitivities Auditing</h2>\r\n                            <p>DBHawk logs each user activities. This includes the user\'s login time, from where the\r\n                                user is login, what SQL query user is executing, what data user is viewing, etc.</p>\r\n                            <figure class="figure docs-figure py-3">\r\n                                <a href="content/images/assets/images/audit-log.png" data-title="Image Lightbox Example"\r\n                                   data-toggle="lightbox">\r\n                                    <img class="figure-img img-fluid shadow rounded"\r\n                                         src="content/images/assets/images/audit-log.png" alt="" style="width: 600px;"></a>\r\n                            </figure>\r\n                        </section><!--//section-->\r\n\r\n                        <section class="docs-section" id="item-1-14">\r\n                            <h2 class="section-heading">LDAP, SAML, ADFS, Okta Integration</h2>\r\n                            <p>DBHawk supports various external systems integration to make database user management\r\n                                easy. This integration includes SAML2, LDAP, ADFS, and Okta.</p>\r\n                            <figure class="figure docs-figure py-3">\r\n                                <a href="content/images/assets/images/user-integration.png"\r\n                                   data-title="Image Lightbox Example" data-toggle="lightbox">\r\n                                    <img class="figure-img img-fluid shadow rounded"\r\n                                         src="content/images/assets/images/user-integration.png" alt=""\r\n                                         style="width: 250px;"></a>\r\n                            </figure>\r\n                        </section><!--//section-->\r\n\r\n                        <section class="docs-section" id="item-1-15">\r\n                            <h2 class="section-heading">Data Reports</h2>\r\n                            <p>DBHawk allows to create various data reports. Users can create Excel, PDF reports.</p>\r\n                            <figure class="figure docs-figure py-3">\r\n                                <a href="content/images/assets/images/report-manager.png"\r\n                                   data-title="Image Lightbox Example" data-toggle="lightbox">\r\n                                    <img class="figure-img img-fluid shadow rounded"\r\n                                         src="content/images/assets/images/report-manager.png" alt=""\r\n                                         style="width: 250px;"></a>\r\n                            </figure>\r\n                        </section><!--//section-->\r\n                        <section class="docs-section" id="item-1-16">\r\n                            <h2 class="section-heading">SQL Job Scheduler</h2>\r\n                            <p>With DBHawk job scheduler, you can schedule a SQL query to run at the regular intervals.\r\n                                User has the option to save results or receive results by email.</p>\r\n                            <figure class="figure docs-figure py-3">\r\n                                <a href="content/images/assets/images/dbhawk-job-scheduler.png"\r\n                                   data-title="Image Lightbox Example" data-toggle="lightbox">\r\n                                    <img class="figure-img img-fluid shadow rounded"\r\n                                         src="content/images/assets/images/dbhawk-job-scheduler.png" alt=""\r\n                                         style="width: 250px;"></a>\r\n                            </figure>\r\n                        </section><!--//section-->\r\n                        <section class="docs-section" id="item-1-17">\r\n                            <h2 class="section-heading">Charts & Dashboards</h2>\r\n                            <p>DBHawk supports creating various SQL results charts and dashboards. Users can run SQL\r\n                                statements and create various data charts by dragging and dropping result columns. </p>\r\n                            <figure class="figure docs-figure py-3">\r\n                                <a href="content/images/assets/images/charts-dashboards.png"\r\n                                   data-title="Image Lightbox Example" data-toggle="lightbox">\r\n                                    <img class="figure-img img-fluid shadow rounded"\r\n                                         src="content/images/assets/images/charts-dashboards.png" alt=""\r\n                                         style="width: 600px;"></a>\r\n                            </figure>\r\n                        </section><!--//section-->\r\n                    </header>\r\n                </article>\r\n\r\n                <footer class="footer">\r\n                    <div class="container text-center py-5">\r\n\r\n                    </div>\r\n                </footer>\r\n            </div>\r\n        </div>\r\n    </div><!--//docs-wrapper-->\r\n\r\n</div>\r\n<footer data-ng-include=" \'app/components/copyright/copyright.html\' "></footer>\r\n\r\n');
$templateCache.put('app/home/home.html','<div ng-cloak>\r\n    <div class="row">\r\n       <!-- <div class="col-md-4">\r\n            <span class="hipster img-responsive img-rounded"></span>\r\n        </div>-->\r\n        <div class="col-md-12">\r\n\r\n\r\n\r\n            Home\r\n            <div ng-switch="vm.isAuthenticated()">\r\n                <div class="panel-body" ng-switch-when="true">\r\n                    You are logged in as user "{{vm.account.login}}".\r\n                </div>\r\n\r\n\r\n\r\n                <div class="panel-body" ng-switch-when="false">\r\n                    <ng-include src="\'app/account/register/register.html\'"></ng-include>\r\n                </div>\r\n\r\n\r\n\r\n            </div>\r\n\r\n\r\n            <p>\r\n            </p>\r\n        </div>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('app/account/company/company.html','<div class="row">\r\n    <div class="main-login  col-sm-8 col-sm-offset-2 col-md-5 col-md-offset-3 p-0">\r\n        <div class="login-logo">\r\n            <img src="content/images/db_hawk-logo.png"  alt="Logo">\r\n        </div>\r\n        <div class="box-login">\r\n\r\n            <fieldset>\r\n                <legend>\r\n                    Join your company to use DBHawk Instance\r\n                </legend>\r\n                <p></p>\r\n                <h4>Registration for {{vm.company.companyName}} </h4>\r\n                <div class="alert alert-success" ng-show="vm.success">\r\n                    <strong>Registration saved!</strong>  <strong> <a ng-href="{{vm.result.dbhawkUrl + \'/?cuser=\' + vm.registerAccount.email}}">Log in DBHawk with your email</a></strong>\r\n                </div>\r\n\r\n                <div class="alert alert-danger" ng-show="vm.error">\r\n                    <strong>Registration failed!</strong> Make sure invite is not used and Please try again later.\r\n                </div>\r\n\r\n                <div class="alert alert-danger" ng-show="vm.errorUserExists">\r\n                    <strong>Login name already registered!</strong> Please choose another one.\r\n                </div>\r\n\r\n                <div class="alert alert-danger" ng-show="vm.errorEmailExists">\r\n                    <strong>Email is already in use!</strong> Please choose another one.\r\n                </div>\r\n\r\n                <div class="alert alert-danger" ng-show="vm.doNotMatch">\r\n                    The password and its confirmation do not match!\r\n                </div>\r\n\r\n                <div class="" ng-show="!vm.success">\r\n                    <form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation>\r\n                        <div class="form-group">\r\n                            <label class="control-label" for="email">Email</label>\r\n                            <input type="email" class="form-control" id="email" name="email" placeholder="Your email"\r\n                                   ng-model="vm.registerAccount.email" ng-minlength=5 ng-maxlength=100 readonly>\r\n                            <div ng-show="form.email.$dirty && form.email.$invalid" >\r\n                                <p class="help-block"\r\n                                   ng-show="form.email.$error.required">\r\n                                    Your email is required.\r\n                                </p>\r\n                                <p class="help-block"\r\n                                   ng-show="form.email.$error.email">\r\n                                    Your email is invalid.\r\n                                </p>\r\n                                <p class="help-block"\r\n                                   ng-show="form.email.$error.minlength">\r\n                                    Your email is required to be at least 5 characters.\r\n                                </p>\r\n                                <p class="help-block"\r\n                                   ng-show="form.email.$error.maxlength">\r\n                                    Your email cannot be longer than 100 characters.\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n                        <div class="form-group">\r\n                            <label class="control-label" for="password">New password</label>\r\n                            <input type="password" class="form-control" id="password" name="password" placeholder="New password"\r\n\r\n                                   ng-model="vm.registerAccount.password" ng-minlength=8 ng-maxlength=50 required>\r\n\r\n                            <div ng-show="form.password.$dirty && form.password.$invalid" >\r\n                                <p class="help-block"\r\n                                   ng-show="form.password.$invalid">\r\n                                    Your  password is required to be at least 8 characters.\r\n                                </p>\r\n                            </div>\r\n\r\n                            <password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar>\r\n\r\n                        </div>\r\n\r\n                        <div class="form-group">\r\n                            <label class="control-label" for="confirmPassword">New password confirmation</label>\r\n                            <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password"\r\n\r\n                                   ng-model="vm.confirmPassword" ng-minlength=8 ng-maxlength=50 required>\r\n\r\n                            <div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid" >\r\n                                <p class="help-block"\r\n                                   ng-show="form.confirmPassword.$invalid">\r\n                                    Your confirm password is required to be at least 8 characters.\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n                        <div class="form-actions">\r\n                            <div class="checkbox clip-check check-primary">\r\n                                <input type="checkbox" id="accept"  ng-model="vm.accept" required>\r\n                                <label for="accept">\r\n                                    I accept <a class="alert-link" href="https://www.datasparc.com/terms-of-use/" target="_blank">the Terms of Service and have read Services Privacy Policy</a>.\r\n                                </label>\r\n                            </div>\r\n\r\n                            <button type="submit"  ng-disabled="form.$invalid" class="btn btn-primary pull-right">\r\n                                Register <i class="fa fa-arrow-circle-right"></i>\r\n                            </button>\r\n                        </div>\r\n                    </form>\r\n                </div>\r\n\r\n            </fieldset>\r\n            <!-- start: COPYRIGHT -->\r\n            <div ng-include="\'app/components/copyright/copyright.html\'"></div>\r\n            <!-- end: COPYRIGHT -->\r\n        </div>\r\n        <!-- end: LOGIN BOX -->\r\n    </div>\r\n</div>\r\n');
$templateCache.put('app/account/delete-account/delete-account.html','<section id="page-title" class="padding-top-15 padding-bottom-15" ng-switch on="isSelected(instance)" ng-repeat="instance in vm.instances track by instance.id ">\r\n    <div class="row">\r\n        <h1 class="mainTitle">{{instance.name}}</h1>\r\n    \r\n    </div>\r\n</section>\r\n\r\n<div class="container-fluid container-fullw mlr-0">\r\n\t<div class="row">\r\n\t\t<div class="container-fluid container-fullw bg-white mlr-0">\r\n\t\t\t<div class="row">\r\n\t\t\t\t<div class="col-sm-12">\r\n\t\t\t\t\t<h2 class="text-center">Delete Account</h2>\r\n\t\t\t\t\t<div class="red-divider"></div>\r\n\t\t\t\t\t<div class="col-md-4 col-md-offset-4 pt-30 pb-20">\r\n\t\t\t\t\t\t\t<h4 class="text-center pb-30">Are you sure you want to delete this account?</h4>\r\n\t\t\t\t\t\t\t<div>\r\n\t\t\t\t\t\t\t\t<button type="button"  class="btn btn-danger pull-right mr-65"><i class="ti-close"></i> Delete Account</button>\r\n\t\t\t\t\t\t\t\t<a ui-sref="home" type="button"  class="btn btn-default pull-right mr-15">Cancel</a>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n\r\n<footer data-ng-include=" \'app/components/copyright/copyright.html\' "></footer>\r\n\r\n');
$templateCache.put('app/account/activate/activate.html','<div>\r\n    <div class="row">\r\n        <div class="col-md-8 col-md-offset-2">\r\n            <h1>Activation</h1>\r\n\r\n            <div class="alert alert-success" ng-show="vm.success">\r\n                <strong>Your email has been activated.</strong> Now you can launch instance\r\n            </div>\r\n\r\n            <div class="alert alert-danger" ng-show="vm.error">\r\n                <strong>Your user could not be activated.</strong> Please use the registration form to sign up.\r\n            </div>\r\n\r\n        </div>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('app/account/profile/profile.html','<div class="container-fluid container-fullw mlr-0">\r\n\t<div class="row">\r\n\t\t<div class="container-fluid container-fullw bg-white mlr-0">\r\n\t\t\t<div class="row">\r\n\t\t\t\t<div class="col-sm-12">\r\n\t\t\t\t\t<h2 class="text-center">My Profile</h2>\r\n\t\t\t\t\t<div class="red-divider"></div>\r\n\t\t\t\t\t<div class="col-md-4 col-md-offset-4 pt-30">\r\n\r\n\t\t\t\t\t\t<div class="alert alert-success" ng-show="vm.success">\r\n\t\t\t\t\t\t\t<strong>Profile Updated!</strong>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class="alert alert-danger" ng-show="vm.error" >\r\n\t\t\t\t\t\t\t<strong>An error has occurred!</strong> The profile could not be updated.\r\n\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t<form name="form" role="form" novalidate ng-submit="vm.changeProfile()" show-validation>\r\n\r\n\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t   <label class="control-label">\r\n\t\t\t\t\t\t\t\t  Company Name *\r\n\t\t\t\t\t\t\t   </label>\r\n\t\t\t\t\t\t\t   <input type="text" class="form-control " id="company_name" name="company_name" ng-model="vm.profileParam.company_name"\r\n\t\t\t\t\t\t\t\t\tplaceholder="Company Name" uib-tooltip="Company Name is required" tooltip-is-open="form.company_name.$dirty && form.company_name.$invalid"\r\n\t\t\t\t\t\t\t\t\ttooltip-trigger="none" tooltip-placement="auto right" required>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t    <div class="form-group">\r\n\t\t\t\t\t\t\t   <label class="control-label">\r\n\t\t\t\t\t\t\t\t  Email *\r\n\t\t\t\t\t\t\t   </label>\r\n\t\t\t\t\t\t\t   <input type="email" class="form-control ng-pristine ng-valid ng-not-empty ng-valid-email ng-valid-required ng-touched" id="em" name="em" ng-model="vm.profileParam.email" uib-tooltip="Invalid Email" tooltip-is-open="form.em.$invalid &amp;&amp; form.em.$dirty" tooltip-trigger="none" tooltip-placement="auto right" required="" aria-invalid="false">\r\n\t\t\t\t\t\t    </div>\r\n\r\n\t\t\t\t\t\t\t<button type="submit" ng-disabled="form.$invalid" class="btn btn-primary pull-right"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</button>\r\n\t\t\t\t\t\t</form>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n\r\n<footer data-ng-include=" \'app/components/copyright/copyright.html\' "></footer>\r\n\r\n');
$templateCache.put('app/account/password/password.html','<section id="page-title" class="padding-top-15 padding-bottom-15" ng-switch on="isSelected(instance)" ng-repeat="instance in vm.instances track by instance.id ">\r\n    <div class="row">\r\n        <h1 class="mainTitle">{{instance.name}}</h1>\r\n\r\n    </div>\r\n</section>\r\n\r\n<div class="container-fluid container-fullw mlr-0">\r\n\t<div class="row">\r\n\t\t<div class="container-fluid container-fullw bg-white mlr-0">\r\n\t\t\t<div class="row">\r\n\t\t\t\t<div class="col-sm-12">\r\n\t\t\t\t\t<h4 class="text-center">Change Password for {{vm.account.login}}</h4>\r\n\t\t\t\t\t<div class="red-divider"></div>\r\n\t\t\t\t\t<div class="col-md-4 col-md-offset-4 pt-30">\r\n\r\n\t\t\t\t\t\t<div class="alert alert-success" ng-show="vm.success">\r\n\t\t\t\t\t\t\t<strong>Password changed!</strong>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class="alert alert-danger" ng-show="vm.error" >\r\n\t\t\t\t\t\t\t<strong>An error has occurred!</strong> The password could not be changed.\r\n\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t<div class="alert alert-danger" ng-show="vm.doNotMatch">\r\n\t\t\t\t\t\t\tThe password and its confirmation do not match!\r\n\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t<form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation>\r\n\r\n\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t<label class="control-label" for="oldPassword">Old password</label>\r\n\t\t\t\t\t\t\t\t<input type="password" class="form-control" id="oldPassword" name="oldPassword" placeholder="Old password"\r\n\t\t\t\t\t\t\t\t\t   ng-model="vm.oldPassword" ng-minlength=8 ng-maxlength=50 required ng-pattern="vm.getPasswordPattern()">\r\n\t\t\t\t\t\t\t\t<div ng-show="form.oldPassword.$dirty && form.oldPassword.$invalid">\r\n\t\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t\t   ng-show="form.oldPassword.$error.required">\r\n\t\t\t\t\t\t\t\t\t\tYour password is required.\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t\t   ng-show="form.oldPassword.$error">\r\n\t\t\t\t\t\t\t\t\t\tYour password is required to be at least 8 characters, one uppercase letter,\r\n\t\t\t\t\t\t\t\t\t\tone lowercase letter and one number. Prevents email from appearing in the password.\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t\t   ng-show="form.oldPassword.$error.maxlength">\r\n\t\t\t\t\t\t\t\t\t\tYour password cannot be longer than 50 characters.\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t<label class="control-label" for="password">New password</label>\r\n\t\t\t\t\t\t\t\t<input type="password" class="form-control" id="password" name="password" placeholder="New password"\r\n\t\t\t\t\t\t\t\t\t   ng-model="vm.password" ng-minlength=8 ng-maxlength=50 required ng-pattern="vm.getPasswordPattern()">\r\n\t\t\t\t\t\t\t\t<div ng-show="form.password.$dirty && form.password.$invalid">\r\n\t\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t\t   ng-show="form.password.$error.required">\r\n\t\t\t\t\t\t\t\t\t\tYour password is required.\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t\t   ng-show="form.password.$error">\r\n\t\t\t\t\t\t\t\t\t\tYour password is required to be at least 8 characters, one uppercase letter,\r\n\t\t\t\t\t\t\t\t\t\tone lowercase letter and one number. Prevents email from appearing in the password.\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t\t   ng-show="form.password.$error.maxlength">\r\n\t\t\t\t\t\t\t\t\t\tYour password cannot be longer than 50 characters.\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<password-strength-bar password-to-check="vm.password"></password-strength-bar>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t<label class="control-label" for="confirmPassword">New password confirmation</label>\r\n\t\t\t\t\t\t\t\t<input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password"\r\n\t\t\t\t\t\t\t\t\t   ng-model="vm.confirmPassword" ng-minlength=4 ng-maxlength=50 required>\r\n\t\t\t\t\t\t\t\t<div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid">\r\n\t\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t\t   ng-show="form.confirmPassword.$error.required">\r\n\t\t\t\t\t\t\t\t\t\tYour confirmation password is required.\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t\t   ng-show="form.confirmPassword.$error.minlength">\r\n\t\t\t\t\t\t\t\t\t\tYour confirmation password is required to be at least 4 characters.\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t\t   ng-show="form.confirmPassword.$error.maxlength">\r\n\t\t\t\t\t\t\t\t\t\tYour confirmation password cannot be longer than 50 characters.\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t\t<button type="submit" ng-disabled="form.$invalid" class="btn btn-primary pull-right"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</button>\r\n\t\t\t\t\t\t</form>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n\r\n<footer data-ng-include=" \'app/components/copyright/copyright.html\' "></footer>\r\n\r\n');
$templateCache.put('app/account/settings/settings.html','<div>\r\n    <div class="row">\r\n        <div class="col-md-8 col-md-offset-2">\r\n            <h2>User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2>\r\n\r\n            <div class="alert alert-success" ng-show="vm.success">\r\n                <strong>Settings saved!</strong>\r\n            </div>\r\n\r\n            <div class="alert alert-success" ng-show="vm.successResend">\r\n                <strong>Verification email sent!</strong>\r\n            </div>\r\n\r\n            <div class="alert alert-danger" ng-show="!vm.settingsAccount.activated">\r\n                Email {{vm.settingsAccount.login}} is not activated. <a href="" ng-click="vm.resend()"><strong> Resend Activation Link </strong></a>\r\n            </div>\r\n\r\n           <jhi-alert-error></jhi-alert-error>\r\n\r\n            <form name="form" role="form" novalidate ng-submit="vm.save()" show-validation>\r\n\r\n                <div class="form-group">\r\n                    <label class="control-label" for="firstName">Company Name:</label>\r\n                    <input type="text" class="form-control" id="firstName" name="firstName" placeholder="Your first name"\r\n                           ng-model="vm.settingsAccount.firstName" ng-minlength=1 ng-maxlength=50  maxlength="50">\r\n                    <div ng-show="form.firstName.$dirty && form.firstName.$invalid">\r\n                        <p class="help-block"\r\n                               ng-show="form.firstName.$error.required">\r\n                            Company Name is required.\r\n                        </p>\r\n                        <p class="help-block"\r\n                               ng-show="form.firstName.$error.minlength">\r\n                            Your Company Name is required to be at least 1 character.\r\n                        </p>\r\n                        <p class="help-block"\r\n                               ng-show="form.firstName.$error.maxlength">\r\n                            Your Company Name cannot be longer than 50 characters.\r\n                        </p>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class="form-group">\r\n                    <label class="control-label" for="email">Email</label>\r\n                    <input readonly type="email" class="form-control" id="email" name="email" placeholder="Your email"\r\n                           ng-model="vm.settingsAccount.email" ng-minlength=5 ng-maxlength=100 required maxlength="100">\r\n                    <div ng-show="form.email.$dirty && form.email.$invalid">\r\n                        <p class="help-block"\r\n                               ng-show="form.email.$error.required">\r\n                            Your email is required.\r\n                        </p>\r\n                        <p class="help-block"\r\n                               ng-show="form.email.$error.email">\r\n                            Your email is invalid.\r\n                        </p>\r\n                        <p class="help-block"\r\n                               ng-show="form.email.$error.minlength">\r\n                            Your email is required to be at least 5 characters.\r\n                        </p>\r\n                        <p class="help-block"\r\n                               ng-show="form.email.$error.maxlength">\r\n                            Your email cannot be longer than 100 characters.\r\n                        </p>\r\n                    </div>\r\n                </div>\r\n\r\n                <button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button>\r\n            </form>\r\n        </div>\r\n    </div>\r\n\r\n</div>\r\n');
$templateCache.put('app/account/sessions/sessions.html','<div>\r\n    <h2>Active sessions for [<b>{{vm.account.login}}</b>]</h2>\r\n\r\n    <div class="alert alert-success" ng-show="vm.success">\r\n        <strong>Session invalidated!</strong>\r\n    </div>\r\n    <div class="alert alert-danger" ng-show="vm.error">\r\n        <strong>An error has occured!</strong> The session could not be invalidated.\r\n    </div>\r\n\r\n    <div class="table-responsive">\r\n        <table class="table table-striped">\r\n            <thead>\r\n                <tr>\r\n                    <th>IP Address</th>\r\n                    <th>User agent</th>\r\n                    <th>Date</th>\r\n                    <th></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-repeat="session in vm.sessions">\r\n                    <td>{{session.ipAddress}}</td>\r\n                    <td>{{session.userAgent}}</td>\r\n                    <td>{{session.tokenDate | date:\'longDate\'}}</td>\r\n                    <td>\r\n                        <button type="submit"\r\n                                class="btn btn-primary"\r\n                                ng-click="vm.invalidate(session.series)">\r\n                                 Invalidate\r\n                        </button>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('app/account/register/register.html','<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">\r\n<!-- start: REGISTRATION -->\r\n<div class="dbh-conteiner dbh-auth-conteiner">\r\n    <div class="">\r\n        <div class="row justify-content-center dbh-mobie-logo-wrap"><a href="https://www.datasparc.com/"> <img src="content/images/datasparc-logo.png" class="logo"></a> </div>\r\n        <div class="row">\r\n            <div class="row pb-5">\r\n                <div class="row dbh-logo-wrap">\r\n                    <a href="https://www.datasparc.com/"> \r\n                        <img src="content/images/datasparc-logo.png" class="logo">\r\n                    </a> \r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class="row d-flex flex-row-reverse">\r\n            <div class="col-lg-6 dbh-image-block">\r\n                <div class="row"></div>\r\n                <div class="row align-content mt-5">\r\n                    <div class="row justify-content-center dbh-image-wrap">\r\n                        <div class="dbh-f-image-wrap col-sm-2 mini-logo">\r\n                            <img src="content/images/trazado-300.png" class="">\r\n                        </div>\r\n                        <div class="dbh-f-block col-sm-10">\r\n                            <p class="dbh-f-title">Hybrid Tool for All Databases</p>\r\n                            <p class="dbh-f-desc">DBHawk provides secure access to on-premise and cloud databases. DBHawk supports a wide array of SQL and NoSQL databases.</p>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class="row align-content">\r\n                    <div class="row justify-content-center dbh-image-wrap">\r\n                        <div class="dbh-f-image-wrap col-sm-2 mini-logo">\r\n                            <img src="content/images/trazado-288.png" class="">\r\n                        </div>\r\n                        <div class="dbh-f-block col-sm-10">\r\n                            <p class="dbh-f-title">Zero Trust Data Access</p>\r\n                            <p class="dbh-f-desc">Users only receive access to the data they need without exposing database username and password.</p>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class="row align-content">\r\n                    <div class="row justify-content-center dbh-image-wrap">\r\n                        <div class="dbh-f-image-wrap col-sm-2 mini-logo">\r\n                            <img src="content/images/trazado-271.png" class="">\r\n                        </div>\r\n                        <div class="dbh-f-block col-sm-10">\r\n                            <p class="dbh-f-title">DBHawk - All In One Solution</p>\r\n                            <p class="dbh-f-desc">Data Security, Database management, Data governance and data analytics</p>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class="col-lg-6 dbh-pr-6 pr-2">\r\n                <div class="card pt-3 pb-0 dbh-form-wrap">\r\n                    <div class="mb-3 pt-2 px-1 dbh-form-title">\r\n                        <h1 class="dbh-h1"><strong>Get Started Free</strong></h1>\r\n                        <h3 class="dbh-h3">No Credit Card Required</h3>\r\n                    </div>\r\n                    <div class="alert alert-danger" ng-show="vm.error">\r\n                        <strong>Registration failed!</strong> Please try again later.\r\n                    </div>\r\n\r\n                    <div class="alert alert-danger" ng-show="vm.errorUserExists">\r\n                        <strong>Login name already registered!</strong> Please choose another one.\r\n                    </div>\r\n\r\n                    <div class="alert alert-danger" ng-show="vm.errorEmailExists">\r\n                        <strong>Email is already in use!</strong> Please choose another one.\r\n                    </div>\r\n                    <div class="alert alert-danger" ng-show="vm.errorEmailNotAllowed">\r\n                        <strong>Email Not Allowed!</strong> please enter valid company email address.\r\n                    </div>\r\n\r\n                    <div class="alert alert-danger" ng-show="vm.errorCompanyExists">\r\n                        <strong>Company or domain is already in use!</strong>\r\n                    </div>\r\n\r\n                    <div class="alert alert-danger" ng-show="vm.errorValidation">\r\n                        <strong>Validation error!</strong>\r\n                    </div>\r\n\r\n                    <div class="alert alert-danger" ng-show="vm.doNotMatch">\r\n                        The password and its confirmation do not match!\r\n                    </div>\r\n                    <form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation>\r\n                        <div class="row px-4 mb-2">\r\n                            <input class="dbh-input dbh-input1" type="text" name="firstName" id="firstName" placeholder="First Name*" \r\n                                   ng-model="vm.registerAccount.firstName" ng-minlength=2 ng-maxlength=100 required>\r\n                            <div ng-show="form.firstName.$touched && form.firstName.$invalid">\r\n                                <p class="help-block">\r\n                                    A valid first name is required.\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n                        <div class="row px-4 mb-2">\r\n                            <input class="dbh-input dbh-input1" type="text" name="lastName" id="lastName" placeholder="Last Name*"\r\n                                   ng-model="vm.registerAccount.lastName" ng-minlength=2 ng-maxlength=100 required>\r\n                            <div ng-show="form.lastName.$touched && form.lastName.$invalid">\r\n                                <p class="help-block">\r\n                                    A valid last name is required.\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n                        <div class="row px-4 mb-2">\r\n                            <input class="dbh-input" type="text" name="email" id="email" \r\n                                   placeholder="Company Email*" \r\n                                   ng-model="vm.registerAccount.email" \r\n                                   ng-minlength="5" \r\n                                   ng-maxlength="100" \r\n                                   required \r\n                                   ng-blur="vm.validateEmail()"\r\n                                   >\r\n                            <div ng-show="vm.emailTouched && vm.emailInvalid">\r\n                                <p class="help-block" ng-show="vm.emailInvalidReason === \'format\'">\r\n                                    A valid email is required.\r\n                                </p>\r\n                                <p class="help-block" ng-show="vm.emailInvalidReason === \'blocked\'">\r\n                                    This email domain is not allowed. <br>\r\n                                    Please enter a valid company email address!\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n                        <div class="row px-4 mb-2">\r\n                            <input type="password" name="password" id="password" class="dbh-input" placeholder="Password*" ng-model="vm.registerAccount.password"  ng-minlength=8 ng-maxlength=50 required ng-pattern="vm.getPasswordPattern()">\r\n                            <div ng-show="form.password.$touched && form.password.$invalid">\r\n                                <p class="help-block">\r\n                                    Your password must be at least 8 characters, one uppercase letter,\r\n                                    one lowercase letter, and one number.\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n                        <div class="row px-4 mb-2">\r\n                            <input class="dbh-input" type="text" name="companyName" id="companyName"  placeholder="Company Name*"   ng-model="vm.registerAccount.companyName" ng-minlength=5 ng-maxlength=100 required>\r\n                            <div ng-show="form.companyName.$touched && form.companyName.$invalid">\r\n                                <p class="help-block">\r\n                                    A valid company name is required.\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n                        <div class="row px-4 mb-2">\r\n                            <select class="dbh-select" name="countryCode" id="countryCode" placeholder="Country Code*"\r\n                                ng-model="vm.registerAccount.countryCode" required>\r\n                                <option value="" class="dbh-option-default" selected>Country Code*</option>\r\n                                <option ng-selected="vm.registerAccount.countryCode == vmCountryCode.value" \r\n                                    ng-repeat="vmCountryCode in vm.countryCodes" \r\n                                    ng-value="vmCountryCode.value">{{vmCountryCode.label}}</option>\r\n                            </select>\r\n                            <div ng-show="form.countryCode.$touched && form.countryCode.$invalid">\r\n                                <p class="help-block">\r\n                                    A valid country code is required.\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n                        <div class="row px-4 mb-2">\r\n                            <input class="dbh-input" type="text" name="phoneNumber" id="phoneNumber" \r\n                                   placeholder="Phone Number*" ng-model="vm.registerAccount.phoneNumber" \r\n                                   ng-minlength=5 ng-maxlength=12 required>\r\n                            <div ng-show="form.phoneNumber.$touched && form.phoneNumber.$invalid">\r\n                                <p class="help-block">\r\n                                    A valid phone number is required.\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n                        <div class="row px-4 mb-2">\r\n                            <textarea class="dbh-textarea" rows="3" name="dataUseCase" id="dataUseCase" \r\n                                      placeholder="Please describe your data access use case or problem*" \r\n                                      ng-model="vm.registerAccount.dataUseCase" required>\r\n                            </textarea>\r\n                            <div ng-show="form.dataUseCase.$touched && form.dataUseCase.$invalid">\r\n                                <p class="help-block">\r\n                                    A valid your data access use case or problem is required.\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n                        <div class="row px-4 mb-2">\r\n                            <textarea class="dbh-textarea" rows="3" name="database" id="database" \r\n                                      placeholder="Database*" ng-model="vm.registerAccount.database" required>\r\n                            </textarea>\r\n                            <div ng-show="form.database.$touched && form.database.$invalid">\r\n                                <p class="help-block">\r\n                                    A valid database is required.\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n                        <div class="row px-4 mb-3">\r\n                            <label class="control-label text-sm1 my-2"><strong> Our databases are located on*</strong></label>\r\n                            <div>\r\n                                <div class="custom-control custom-checkbox custom-control-inline mr-5">\r\n                                    <input id="dbLocOnPremise" name="dbLocOnPremise" type="checkbox" class="custom-control-input" value="onpremise"\r\n                                           ng-model="vm.registerAccount.dbLocOnPremise"/>\r\n                                    <label for="dbLocOnPremise" class="custom-control-label text-sm1 mb-0 font-weight-bold">On Premise</label>\r\n                                </div>\r\n                                <div class="custom-control custom-checkbox custom-control-inline mr-5">\r\n                                    <input id="dbLocCloud" name="dbLocCloud" type="checkbox" class="custom-control-input" value="cloud"\r\n                                           ng-model="vm.registerAccount.dbLocCloud"/>\r\n                                    <label for="dbLocCloud" class="custom-control-label text-sm1 mb-0 font-weight-bold">Cloud</label>\r\n                                </div>\r\n                                <div class="custom-control custom-checkbox custom-control-inline mr-5">\r\n                                    <input id="dbLocHybrid" name="dbLocHybrid" type="checkbox" class="custom-control-input" value="hybrid"\r\n                                           ng-model="vm.registerAccount.dbLocHybrid"/>\r\n                                    <label for="dbLocHybrid" class="custom-control-label text-sm1 mb-0 font-weight-bold">Hybrid</label>\r\n                                </div>\r\n                            </div>\r\n                            <div ng-show="(form.dbLocOnPremise.$touched && form.dbLocOnPremise.$invalid)\r\n                                            || (form.dbLocCloud.$touched && form.dbLocCloud.$invalid)\r\n                                            || (form.dbLocHybrid.$touched && form.dbLocHybrid.$invalid)">\r\n                                <p class="help-block">\r\n                                    A valid database location is required.\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n                        <div class="row px-4 mb-2">\r\n                            <div class="custom-control custom-checkbox custom-control-inline">\r\n                                <input id="agree" type="checkbox" class="custom-control-input" ng-model="vm.accept" required>\r\n                                <label for="agree" class="custom-control-label text-sm">I accept <a href="https://www.datasparc.com/Datasparc-DBHawk-EULA.pdf" target="_blank" class="dbh-link">Terms of Service</a> and <a href="https://www.datasparc.com/privacy-policy/" target="_blank" class="dbh-link">Datasparc\'s Privacy Policy</a></label>\r\n                            </div>\r\n                        </div>\r\n                        <div class="row mb-3 px-3 mt-4 justify-content-end"> \r\n                            <button type="submit" ng-disabled="form.$invalid || vm.emailInvalid" class="dbh-button submit-btn register-anm">Create Account</button>\r\n                         </div>\r\n                        <div class="row mb-4 px-3"> <span class="dbh-signin-wrap">Already have an account? <a ui-sref="signin" class="dbh-link">Sign In</a></span> </div>\r\n\r\n                        <div class="row px-2 mb-1">\r\n                            <p class="register-conditions">\r\n                                By including your details above, you agree to receive periodic communication from Datasparc Inc regarding our products and services. Your information will be kept entirely confidential and used only by authorized members of our staff. For our full privacy policy click&nbsp;<a data-wpel-link="internal" href="https://www.datasparc.com/privacy-policy/" rel="nofollow" target="_blank" class="tve-froala" style="outline: none;">here</a>.\r\n                            </p>\r\n                        </div>\r\n                        <div vc-recaptcha key="vm.reCaptchaPublicKey" size="vm.reCaptchaSize" ng-model="vm.recaptchaResponse"></div>\r\n                    </form>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<!-- end: REGISTRATION -->\r\n');
$templateCache.put('app/account/social/social-register.html','<div>\r\n    <div class="row">\r\n        <div class="col-md-8 col-md-offset-2">\r\n            <h1 ng-show="success">Registration with</h1>\r\n            <h1 ng-show="error">Registration</h1>\r\n\r\n            <div class="alert alert-success" ng-show="vm.success">\r\n                <strong>Registration saved!</strong> Please check your email for confirmation.\r\n            </div>\r\n\r\n            <div class="alert alert-danger" ng-show="vm.error">\r\n                <strong>Registration failed!</strong> Please try again later.\r\n            </div>\r\n\r\n            <jh-social ng-if="vm.success" ng-provider="{{ vm.provider }}"></jh-social>\r\n            <br/>\r\n            <div class="alert alert-warning">\r\n                If you want to <a class="alert-link" href="#/login">sign in</a>, you can try the default accounts:<br/>- Administrator (login="admin" and password="admin") <br/>- User (login="user" and password="user").\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('app/admin/configuration/configuration.html','<div>\r\n    <h2>Configuration</h2>\r\n\r\n    <span>Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control">\r\n    <h3 ng-hide="filteredConfig.length === 0">Spring configuration</h3>\r\n    <table class="table table-condensed table-striped table-bordered table-responsive"\r\n        style="table-layout:fixed" ng-hide="filteredConfig.length === 0">\r\n        <thead>\r\n        <tr>\r\n            <th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span>Prefix</span></th>\r\n            <th class="col-sm-8">Properties</th>\r\n        </tr>\r\n        </thead>\r\n\r\n        <tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)">\r\n            <td><span>{{entry.prefix}}</span></td>\r\n            <td>\r\n                <div class="row" ng-repeat="(key, value) in entry.properties">\r\n                    <div class="col-md-4">{{key}}</div>\r\n                    <div class="col-md-8">\r\n                        <span class="pull-right label label-success break">{{value}}</span>\r\n                    </div>\r\n                </div>\r\n            </td>\r\n        </tr>\r\n    </table>\r\n    <div ng-repeat="(key, value) in vm.allConfiguration">\r\n        <h4 ng-hide="filtered.length === 0"><span>{{key}}</span></h4>\r\n        <table class="table table-condensed table-striped table-bordered table-responsive"\r\n               style="table-layout:fixed" ng-hide="filtered.length === 0">\r\n            <thead>\r\n            <tr>\r\n                <th class="col-sm-4">Property</th>\r\n                <th class="col-sm-8">Value</th>\r\n            </tr>\r\n            </thead>\r\n            <tbody>\r\n            <tr ng-repeat="item in filtered = (value | filter:filter)">\r\n                <td class="break">{{item.key}}</td>\r\n                <td class="break">\r\n                    <span class="pull-right label label-success break">{{item.val}}</span>\r\n                </td>\r\n            </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('app/admin/audits/audits.html','<div>\r\n    <h2>Audits</h2>\r\n\r\n    <div class="row">\r\n        <div class="col-md-5">\r\n            <h4>Filter by date</h4>\r\n            <p class="input-group">\r\n                <span class="input-group-addon">from</span>\r\n                <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required/>\r\n                <span class="input-group-addon">to</span>\r\n                <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required/>\r\n            </p>\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <table class="table table-condensed table-striped table-bordered table-responsive">\r\n        <thead>\r\n        <tr>\r\n            <th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span>Date</span></th>\r\n            <th ng-click="predicate = \'principal\'; reverse=!reverse"><span>User</span></th>\r\n            <th ng-click="predicate = \'type\'; reverse=!reverse"><span>State</span></th>\r\n            <th ng-click="predicate = \'data.message\'; reverse=!reverse"><span>Extra data</span></th>\r\n        </tr>\r\n        </thead>\r\n\r\n        <tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered">\r\n            <td><span>{{audit.timestamp| date:\'medium\'}}</span></td>\r\n            <td><small>{{audit.principal}}</small></td>\r\n            <td>{{audit.type}}</td>\r\n            <td>\r\n                <span ng-show="audit.data.message">{{audit.data.message}}</span>\r\n                <span ng-show="audit.data.remoteAddress"><span>Remote Address</span> {{audit.data.remoteAddress}}</span>\r\n            </td>\r\n        </tr>\r\n    </table>\r\n\r\n    <div class="text-center">\r\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0"\r\n        width="100%" height="900" scrolling="auto" target=\'_top\' title="Swagger UI"></iframe>\r\n');
$templateCache.put('app/admin/email-list/email-list-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.emailList.id)">\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title">Confirm delete operation</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <p>Are you sure you want to delete this Email List?</p>\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger">\r\n            <span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span>\r\n        </button>\r\n    </div>\r\n</form>\r\n');
$templateCache.put('app/admin/email-list/email-list-detail.html','\r\n<div>\r\n    <h2><span>Email List</span> {{vm.emailList.id}}</h2>\r\n    <hr>\r\n    <jhi-alert-error></jhi-alert-error>\r\n    <dl class="dl-horizontal jh-entity-details">\r\n        <dt><span>Domain</span></dt>\r\n        <dd>\r\n            <span>{{vm.emailList.domain}}</span>\r\n        </dd>\r\n    </dl>\r\n\r\n    <button type="submit"\r\n            ui-sref="{{ vm.previousState }}"\r\n            class="btn btn-info">\r\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span>\r\n    </button>\r\n\r\n    <button type="button" ui-sref="email-list-detail.edit({id:vm.emailList.id})" class="btn btn-primary">\r\n        <span class="glyphicon glyphicon-pencil"></span>\r\n        <span class="hidden-sm-down"> Edit</span>\r\n    </button>\r\n</div>\r\n');
$templateCache.put('app/admin/email-list/email-list-dialog.html','\r\n<form name="editForm" role="form" novalidate ng-submit="vm.save()">\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myEmailListLabel">Create or edit a Email List</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <div class="form-group" ng-show="vm.emailList.id">\r\n            <label for="id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="vm.emailList.id" readonly />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_domain">Domain</label>\r\n            <input type="text" class="form-control" name="domain" id="field_domain"\r\n                    ng-model="vm.emailList.domain"\r\n                    />\r\n        </div>\r\n\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>\r\n        </button>\r\n    </div>\r\n</form>\r\n');
$templateCache.put('app/admin/email-list/email-lists.html','<div>\r\n    <h2>Email Lists</h2>\r\n    <jhi-alert></jhi-alert>\r\n    <div class="container-fluid">\r\n        <div class="row">\r\n            <div class="col-xs-4 no-padding-left">\r\n                <button class="btn btn-primary" ui-sref="email-list.new" >\r\n                    <span class="glyphicon glyphicon-plus"></span>\r\n                    <span >\r\n                        Create new Email List\r\n                    </span>\r\n                </button>\r\n            </div>\r\n            <div class="form-inline">\r\n                <div class="form-group">\r\n                    <input ng-model="vm.domain" type="text" class="form-control" />\r\n                    <button type="button" class="btn btn-primary" ng-click="vm.search()">\r\n                        <span>Search</span>\r\n                    </button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <br/>\r\n    <div class="table-responsive">\r\n        <table class="jh-table table table-striped">\r\n            <thead>\r\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\r\n                    <th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n                    <th jh-sort-by="domain"><span>Domain</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n                    <th></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-repeat="emailList in vm.emailLists track by emailList.id">\r\n                    <td><a ui-sref="email-list-detail({id:emailList.id})">{{emailList.id}}</a></td>\r\n                    <td>{{emailList.domain}}</td>\r\n                    <td class="text-right">\r\n                        <div class="btn-group flex-btn-group-container">\r\n                            <button type="submit"\r\n                                    ui-sref="email-list-detail({id:emailList.id})"\r\n                                    class="btn btn-info btn-sm">\r\n                                <span class="glyphicon glyphicon-eye-open"></span>\r\n                                <span class="hidden-sm-down"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="email-list.edit({id:emailList.id})"\r\n                                    class="btn btn-primary btn-sm">\r\n                                <span class="glyphicon glyphicon-pencil"></span>\r\n                                <span class="hidden-sm-down"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="email-list.delete({id:emailList.id})"\r\n                                    class="btn btn-danger btn-sm">\r\n                                <span class="glyphicon glyphicon-remove-circle"></span>\r\n                                <span class="hidden-sm-down"></span>\r\n                            </button>\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n    <div class="text-center">\r\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\r\n    </div>\r\n    <uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager>\r\n</div>\r\n');
$templateCache.put('app/admin/health/health.html','<div>\r\n    <h2>Health Checks</h2>\r\n\r\n    <p>\r\n        <button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span>\r\n        </button>\r\n    </p>\r\n\r\n    <table id="healthCheck" class="table table-striped">\r\n        <thead>\r\n            <tr>\r\n                <th class="col-md-7">Service Name</th>\r\n                <th class="col-md-2 text-center">Status</th>\r\n                <th class="col-md-2 text-center">Details</th>\r\n\r\n            </tr>\r\n        </thead>\r\n        <tbody>\r\n            <tr ng-repeat="health in vm.healthData">\r\n                <td><span class="text-capitalize">{{ vm.baseName(health.name) }}</span> {{vm.subSystemName(health.name)}}</td>\r\n                <td class="text-center">\r\n                    <span class="label" ng-class="vm.getLabelClass(health.status)">\r\n                        {{ health.status }}\r\n                    </span>\r\n                </td>\r\n                <td class="text-center">\r\n                    <a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error">\r\n                        <i class="glyphicon glyphicon-eye-open"></i>\r\n                    </a>\r\n                </td>\r\n            </tr>\r\n        </tbody>\r\n    </table>\r\n</div>\r\n');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header">\r\n    <button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span>\r\n    </button>\r\n    <h4 class="modal-title" id="showHealthLabel"><span class="text-capitalize">{{ vm.baseName(vm.currentHealth.name) }}</span>\r\n        {{vm.subSystemName(vm.currentHealth.name)}}\r\n    </h4>\r\n</div>\r\n<div class="modal-body pad">\r\n    <div ng-show="vm.currentHealth.details">\r\n        <h4>Properties</h4>\r\n        <table class="table table-striped">\r\n            <thead>\r\n                <tr>\r\n                    <th class="col-md-6 text-left">Name</th>\r\n                    <th class="col-md-6 text-left">Value</th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-repeat="(k,v) in vm.currentHealth.details">\r\n                    <td class="col-md-6 text-left">{{k}}</td>\r\n                    <td class="col-md-6 text-left">{{v}}</td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n    <div ng-show="vm.currentHealth.error">\r\n        <h4>Error</h4>\r\n            <pre>{{vm.currentHealth.error}}</pre>\r\n    </div>\r\n</div>\r\n<div class="modal-footer">\r\n    <button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button>\r\n</div>\r\n');
$templateCache.put('app/admin/instances/instance-management-action-dialog.html','<form name="deleteForm" ng-submit="vm.confirmAction()">\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title">Confirm operation</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <p>Are you sure you want to {{vm.entity.action}} this Instance?</p>\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\r\n        </button>\r\n        <button type="submit" class="btn btn-danger">\r\n            <span class="glyphicon glyphicon-stop"></span>&nbsp;<span>Perform</span>\r\n        </button>\r\n    </div>\r\n</form>\r\n');
$templateCache.put('app/admin/instances/instances.html','<div>\r\n    <h2>Instances</h2>\r\n\r\n    <div class="form-actions">\r\n        <div class="checkbox clip-check check-primary">\r\n            <input type="checkbox" id="runningAndStopped"  ng-model="vm.runningAndStopped" ng-change="vm.showOnlyRunningAndStoppedInstances()">\r\n            <label for="runningAndStopped">\r\n                Display running and stopped instances\r\n            </label>\r\n        </div>\r\n    </div>\r\n\r\n    <jhi-alert></jhi-alert>\r\n\r\n    <div class="table-responsive">\r\n        <table class="jh-table table">\r\n            <thead>\r\n            <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\r\n                <th></th>\r\n                <th jh-sort-by="instanceId"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n                <th jh-sort-by="name"><span>Name</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n                <th jh-sort-by="name"><span>User</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n                <th jh-sort-by="name"><span>Comp Email</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n                <th jh-sort-by="region"><span>Region</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n                <th jh-sort-by="status"><span>Status</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n                <th jh-sort-by="active"><span>Active</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n                <th jh-sort-by="trialExpired"><span>Trial Expired</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n                <th jh-sort-by="trialDays"><span>Trial Days</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n                <th jh-sort-by="created"><span>Created Date</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n                <th jh-sort-by="userLastLogin"><span>Last Login</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n            </tr>\r\n            </thead>\r\n            <tbody>\r\n            <tr ng-repeat="instance in vm.instances track by instance.instanceId">\r\n                <td class="text-left">\r\n                    <div class="btn-group flex-btn-group-container">\r\n\r\n\r\n                        <button type="button"  ui-sref="instance-management.action({instanceId:instance.instanceId, action: \'allow\'})"  ng-show="instance.sentPersReq"\r\n                                class="btn btn-success btn-sm">\r\n                            <span class="glyphicon glyphicon-ok"></span>\r\n                            Allow Full\r\n                        </button>\r\n\r\n                        &nbsp;\r\n\r\n\r\n                        <button type="button" ng-click="vm.editInstance(instance)" ng-hide="instance.editMode"\r\n                                class="btn btn-primary btn-sm">\r\n                            <span class="glyphicon glyphicon-pencil"></span>\r\n                            Edit\r\n                        </button>\r\n                        <button type="button" ng-click="vm.saveInstance(instance)" ng-show="instance.editMode"\r\n                                class="btn btn-primary btn-sm">\r\n                            <span class="glyphicon glyphicon-save"></span>\r\n                            Save\r\n                        </button>\r\n                        <button type="submit" class="btn btn-success btn-sm"\r\n                                ui-sref="instance-management.action({instanceId:instance.instanceId, action: \'start\'})">\r\n                            <span class="glyphicon glyphicon-play"></span><span></span>\r\n                            Start\r\n                        </button>\r\n                        <button type="submit" class="btn btn-warning btn-sm"\r\n                                ui-sref="instance-management.action({instanceId:instance.instanceId, action: \'stop\'})">\r\n                            <span class="glyphicon glyphicon-stop"></span><span></span>\r\n                            Stop\r\n                        </button>\r\n                        <button type="submit" class="btn btn-danger btn-sm" ng-hide="!instance.active"\r\n                                ui-sref="instance-management.action({instanceId:instance.instanceId, action: \'terminate\'})">\r\n                            <span class="glyphicon glyphicon-remove-circle"></span><span></span>\r\n                            Terminate\r\n                        </button>\r\n                        </div>\r\n\r\n                </td>\r\n                <td>{{instance.instanceId}}</td>\r\n                <td><a href="{{instance.dbhawkUrl}}/" target="_blank">{{instance.name}}</a></td>\r\n                <td>{{instance.userName}}</td>\r\n                <td>{{instance.requestEmail}}</td>\r\n                <td>{{vm.regions[instance.region]}}</td>\r\n                <td>{{instance.status}}</td>\r\n                <td>{{instance.active}}</td>\r\n                <td><span ng-hide="instance.editMode">{{instance.trialExpired}}</span>\r\n                    <input type="checkbox" name="trialExpired"\r\n                           ng-show="instance.editMode"\r\n                           ng-model="instance.trialExpired"/>\r\n\r\n                </td>\r\n                <td><span ng-hide="instance.editMode">{{instance.trialDays}}</span>\r\n                    <input type="number" name="trialDays"\r\n                           ng-show="instance.editMode"\r\n                           ng-model="instance.trialDays" placeholder="Trial Days"\r\n                           required="" min="1" style="width: 50px" />\r\n                </td>\r\n                <td>{{instance.created | date:\'medium\'}}</td>\r\n                <td>{{instance.userLastLogin | date:\'medium\'}}</td>\r\n            </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n    <div class="text-center">\r\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\r\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('app/admin/metrics/metrics.html','<div>\r\n    <h2>Application Metrics</h2>\r\n    <p>\r\n        <button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button>\r\n    </p>\r\n\r\n    <h3>JVM Metrics</h3>\r\n    <div class="row" ng-hide="vm.updatingMetrics">\r\n        <div class="col-md-4">\r\n            <b>Memory</b>\r\n            <p><span>Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p>\r\n            <uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success">\r\n                <span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value  | number:0}}%</span>\r\n            </uib-progressbar>\r\n            <p><span>Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p>\r\n            <uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success">\r\n                <span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value  | number:0}}%</span>\r\n            </uib-progressbar>\r\n            <p><span>Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p>\r\n            <uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success">\r\n                <span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value  | number:0}}%</span>\r\n            </uib-progressbar>\r\n        </div>\r\n        <div class="col-md-4">\r\n            <b>Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a>\r\n            <p><span>Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p>\r\n            <uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success">\r\n                <span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value  | number:0}}%</span>\r\n            </uib-progressbar>\r\n            <p><span>Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p>\r\n            <uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning">\r\n                <span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value  | number:0}}%</span>\r\n            </uib-progressbar>\r\n            <p><span>Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p>\r\n            <uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning">\r\n                <span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value  | number:0}}%</span>\r\n            </uib-progressbar>\r\n            <p><span>Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p>\r\n            <uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success">\r\n                <span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value  | number:0}}%</span>\r\n            </uib-progressbar>\r\n        </div>\r\n        <div class="col-md-4">\r\n            <b>Garbage collections</b>\r\n            <div class="row">\r\n                <div class="col-md-9">Mark Sweep count</div>\r\n                <div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div>\r\n            </div>\r\n            <div class="row">\r\n                <div class="col-md-9">Mark Sweep time</div>\r\n                <div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div>\r\n            </div>\r\n            <div class="row">\r\n                <div class="col-md-9">Scavenge count</div>\r\n                <div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div>\r\n            </div>\r\n            <div class="row">\r\n                <div class="col-md-9">Scavenge time</div>\r\n                <div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class="well well-lg" ng-show="vm.updatingMetrics">Updating...</div>\r\n\r\n    <h3>HTTP requests (events per second)</h3>\r\n        <p><span>Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span>Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p>\r\n    <div class="table-responsive">\r\n        <table class="table table-striped">\r\n            <thead>\r\n            <tr>\r\n                <th>Code</th>\r\n                <th>Count</th>\r\n                <th class="text-right">Mean</th>\r\n                <th class="text-right"><span>Average</span> (1 min)</th>\r\n                <th class="text-right"><span>Average</span> (5 min)</th>\r\n                <th class="text-right"><span>Average</span> (15 min)</th>\r\n            </tr>\r\n            </thead>\r\n            <tbody>\r\n            <tr>\r\n                <td>OK</td>\r\n                <td>\r\n                    <uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success">\r\n                        <span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span>\r\n                    </uib-progressbar>\r\n                </td>\r\n                <td class="text-right">\r\n                    {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}\r\n                </td>\r\n                <td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}\r\n                </td>\r\n                <td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}\r\n                </td>\r\n                <td class="text-right">\r\n                    {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}\r\n                </td>\r\n            </tr>\r\n            <tr>\r\n                <td>Not Found</td>\r\n                <td>\r\n                    <uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success">\r\n                        <span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span>\r\n                    </uib-progressbar>\r\n                </td>\r\n                <td class="text-right">\r\n                    {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}\r\n                </td>\r\n                <td class="text-right">\r\n                    {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}\r\n                </td>\r\n                <td class="text-right">\r\n                    {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}\r\n                </td>\r\n                <td class="text-right">\r\n                    {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}\r\n                </td>\r\n            </tr>\r\n            <tr>\r\n                <td>Server error</td>\r\n                <td>\r\n                    <uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success">\r\n                        <span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span>\r\n                    </uib-progressbar>\r\n                </td>\r\n                <td class="text-right">\r\n                    {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}\r\n                </td>\r\n                <td class="text-right">\r\n                    {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}\r\n                </td>\r\n                <td class="text-right">\r\n                    {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}\r\n                </td>\r\n                <td class="text-right">\r\n                    {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}\r\n                </td>\r\n            </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n\r\n    <h3>Services statistics (time in millisecond)</h3>\r\n    <div class="table-responsive">\r\n        <table class="table table-striped">\r\n            <thead>\r\n            <tr>\r\n                <th>Service name</th>\r\n                <th class="text-right">Count</th>\r\n                <th class="text-right">Mean</th>\r\n                <th class="text-right">Min</th>\r\n                <th class="text-right">p50</th>\r\n                <th class="text-right">p75</th>\r\n                <th class="text-right">p95</th>\r\n                <th class="text-right">p99</th>\r\n                <th class="text-right">Max</th>\r\n            </tr>\r\n            </thead>\r\n            <tbody>\r\n            <tr ng-repeat="(k, v) in vm.servicesStats">\r\n                <td>{{k}}</td>\r\n                <td class="text-right">{{v.count}}</td>\r\n                <td class="text-right">{{v.mean * 1000 | number:0}}</td>\r\n                <td class="text-right">{{v.min * 1000 | number:0}}</td>\r\n                <td class="text-right">{{v.p50 * 1000 | number:0}}</td>\r\n                <td class="text-right">{{v.p75 * 1000 | number:0}}</td>\r\n                <td class="text-right">{{v.p95 * 1000 | number:0}}</td>\r\n                <td class="text-right">{{v.p99 * 1000 | number:0}}</td>\r\n                <td class="text-right">{{v.max * 1000 | number:0}}</td>\r\n            </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n    <h3>Cache statistics</h3>\r\n    <div class="table-responsive">\r\n        <table class="table table-striped">\r\n            <thead>\r\n            <tr>\r\n                <th>Cache name</th>\r\n                <th class="text-right">Cache Hits</th>\r\n                <th class="text-right">Cache Misses</th>\r\n                <th class="text-right">Cache Gets</th>\r\n                <th class="text-right">Cache Puts</th>\r\n                <th class="text-right">Cache Removals</th>\r\n                <th class="text-right">Cache Evictions</th>\r\n                <th class="text-right">Cache Hit %</th>\r\n                <th class="text-right">Cache Miss %</th>\r\n                <th class="text-right">Average get time (\xB5s)</th>\r\n                <th class="text-right">Average put time (\xB5s)</th>\r\n                <th class="text-right">Average remove time (\xB5s)</th>\r\n            </tr>\r\n            </thead>\r\n            <tbody>\r\n            <tr ng-repeat="(k, v) in vm.cachesStats" ng-once>\r\n                <td>{{v.name}}</td>\r\n                <td class="text-right">{{vm.metrics.gauges[k + \'.cache-hits\'].value}}</td>\r\n                <td class="text-right">{{vm.metrics.gauges[k + \'.cache-misses\'].value}}</td>\r\n                <td class="text-right">{{vm.metrics.gauges[k + \'.cache-gets\'].value}}</td>\r\n                <td class="text-right">{{vm.metrics.gauges[k + \'.cache-puts\'].value}}</td>\r\n                <td class="text-right">{{vm.metrics.gauges[k + \'.cache-removals\'].value}}</td>\r\n                <td class="text-right">{{vm.metrics.gauges[k + \'.cache-evictions\'].value}}</td>\r\n                <td class="text-right">{{vm.metrics.gauges[k + \'.cache-hit-percentage\'].value}}</td>\r\n                <td class="text-right">{{vm.metrics.gauges[k + \'.cache-miss-percentage\'].value}}</td>\r\n                <td class="text-right">{{vm.metrics.gauges[k + \'.average-get-time\'].value | number:2}}</td>\r\n                <td class="text-right">{{vm.metrics.gauges[k + \'.average-put-time\'].value | number:2}}</td>\r\n                <td class="text-right">{{vm.metrics.gauges[k + \'.average-remove-time\'].value | number:2}}</td>\r\n            </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n    <h3 ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3>\r\n    <div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">\r\n        <table class="table table-striped">\r\n            <thead>\r\n                <tr>\r\n                    <th><span>Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th>\r\n                    <th class="text-right">Count</th>\r\n                    <th class="text-right">Mean</th>\r\n                    <th class="text-right">Min</th>\r\n                    <th class="text-right">p50</th>\r\n                    <th class="text-right">p75</th>\r\n                    <th class="text-right">p95</th>\r\n                    <th class="text-right">p99</th>\r\n                    <th class="text-right">Max</th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr>\r\n                    <td>\r\n                        <div class="progress progress-striped">\r\n                            <uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success">\r\n                                <span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value  | number:0}}%</span>\r\n                            </uib-progressbar>\r\n                        </div>\r\n                    </td>\r\n                    <td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td>\r\n                    <td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td>\r\n                    <td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td>\r\n                    <td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td>\r\n                    <td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td>\r\n                    <td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td>\r\n                    <td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td>\r\n                    <td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump -->\r\n<div class="modal-header">\r\n    <button type="button" class="close" ng-click="vm.cancel()">&times;</button>\r\n    <h4 class="modal-title">Threads dump</h4>\r\n</div>\r\n<div class="modal-body pad">\r\n    <span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp;\r\n    <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp;\r\n    <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp;\r\n    <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp;\r\n    <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;\r\n    <div class="voffset2">&nbsp;</div>\r\n    Filter\r\n    <input type="text" ng-model="threadDumpFilter" class="form-control">\r\n    <div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter">\r\n        <h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}})\r\n            <a ng-click="show = !show">\r\n               <span ng-show="!show">Show StackTrace</span>\r\n               <span ng-show="show">Hide StackTrace</span>\r\n            </a>\r\n        </h5>\r\n        <div class="well" ng-show="show">\r\n            <div ng-repeat="(stK, stV) in v.stackTrace">\r\n                {{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}})\r\n                <span class="voffset1"></span>\r\n            </div>\r\n        </div>\r\n        <table class="table table-condensed">\r\n            <thead>\r\n                <tr>\r\n                    <th class="text-right">Blocked Time</th>\r\n                    <th class="text-right">Blocked Count</th>\r\n                    <th class="text-right">Waited Time</th>\r\n                    <th class="text-right">Waited Count</th>\r\n                    <th>Lock Name</th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr>\r\n                    <td>{{v.blockedTime}}</td>\r\n                    <td>{{v.blockedCount}}</td>\r\n                    <td>{{v.waitedTime}}</td>\r\n                    <td>{{v.waitedCount}}</td>\r\n                    <td>{{v.lockName}}</td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n\r\n    </div>\r\n</div>\r\n<div class="modal-footer">\r\n    <button type="button" class="btn btn-default  pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button>\r\n</div>\r\n');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive">\r\n    <h2>Logs</h2>\r\n\r\n    <p>There are {{ vm.loggers.length }} loggers.</p>\r\n\r\n    <span>Filter</span> <input type="text" ng-model="filter" class="form-control">\r\n\r\n    <table class="table table-condensed table-striped table-bordered">\r\n        <thead>\r\n        <tr title="click to order">\r\n            <th ng-click="predicate = \'name\'; reverse=!reverse"><span>Name</span></th>\r\n            <th ng-click="predicate = \'level\'; reverse=!reverse"><span>Level</span></th>\r\n        </tr>\r\n        </thead>\r\n\r\n        <tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse">\r\n            <td><small>{{logger.name | characters:140}}</small></td>\r\n            <td>\r\n                <button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button>\r\n                <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button>\r\n                <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button>\r\n                <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button>\r\n                <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button>\r\n            </td>\r\n        </tr>\r\n    </table>\r\n</div>\r\n');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)">\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title">Confirm delete operation</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <p>Are you sure you want to delete this User?</p>\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\r\n        </button>\r\n        <button type="submit" class="btn btn-danger">\r\n            <span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span>\r\n        </button>\r\n    </div>\r\n</form>\r\n');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div>\r\n    <h2>\r\n        <span>User</span> [<b>{{vm.user.login}}</b>]\r\n    </h2>\r\n    <dl class="dl-horizontal jh-entity-details">\r\n        <dt><span>Login</span></dt>\r\n        <dd>\r\n            <span>{{vm.user.login}}</span>\r\n            <span class="label label-danger" ng-show="!vm.user.activated"\r\n                 >Deactivated</span>\r\n            <span class="label label-success" ng-show="vm.user.activated"\r\n                 >Activated</span>\r\n        </dd>\r\n        <dt><span>First Name</span></dt>\r\n        <dd>{{vm.user.firstName}}</dd>\r\n        <dt><span>Last Name</span></dt>\r\n        <dd>{{vm.user.lastName}}</dd>\r\n        <dt><span>Email</span></dt>\r\n        <dd>{{vm.user.email}}</dd>\r\n        <dt><span>Created By</span></dt>\r\n        <dd>{{vm.user.createdBy}}</dd>\r\n        <dt><span>Created Date</span></dt>\r\n        <dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd>\r\n        <dt><span>Last Modified By</span></dt>\r\n        <dd>{{vm.user.lastModifiedBy}}</dd>\r\n        <dt><span>Last Modified Date</span></dt>\r\n        <dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd>\r\n        <dt><span>Profiles</span></dt>\r\n        <dd>\r\n            <ul class="list-unstyled">\r\n                <li ng-repeat="authority in vm.user.authorities">\r\n                    <span class="label label-info">{{authority}}</span>\r\n                </li>\r\n            </ul>\r\n        </dd>\r\n    </dl>\r\n    <button type="submit"\r\n            ui-sref="user-management"\r\n            class="btn btn-info">\r\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span>\r\n    </button>\r\n</div>\r\n');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation>\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myUserLabel">\r\n            Create or edit a User</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <div class="form-group" ng-show="vm.user.id">\r\n            <label>ID</label>\r\n            <input type="text" class="form-control" name="id"\r\n                   ng-model="vm.user.id" readonly>\r\n        </div>\r\n\r\n        <div class="form-group">\r\n            <label class="control-label">Login</label>\r\n            <input type="text" class="form-control" name="login"\r\n                   ng-model="vm.user.login" required ng-minlength=1 ng-maxlength=50 ng-pattern="/^[_\'.@A-Za-z0-9-]*$/">\r\n\r\n            <div ng-show="editForm.login.$invalid">\r\n                <p class="help-block"\r\n                   ng-show="editForm.login.$error.required">\r\n                    This field is required.\r\n                </p>\r\n\r\n                <p class="help-block"\r\n                   ng-show="editForm.login.$error.maxlength"\r\n                  >\r\n                    This field cannot be longer than 50 characters.\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label">First Name</label>\r\n            <input type="text" class="form-control" name="firstName"\r\n                   ng-model="vm.user.firstName" ng-maxlength="50">\r\n\r\n            <div ng-show="editForm.firstName.$invalid">\r\n                <p class="help-block"\r\n                   ng-show="editForm.firstName.$error.maxlength"\r\n                  >\r\n                    This field cannot be longer than 50 characters.\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label>Last Name</label>\r\n            <input type="text" class="form-control" name="lastName"\r\n                   ng-model="vm.user.lastName" ng-maxlength="50">\r\n\r\n            <div ng-show="editForm.lastName.$invalid">\r\n                <p class="help-block"\r\n                   ng-show="editForm.lastName.$error.maxlength"\r\n                  >\r\n                    This field cannot be longer than 50 characters.\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label">Email</label>\r\n            <input type="email" class="form-control" name="email"\r\n                   ng-model="vm.user.email" required ng-maxlength="100">\r\n\r\n            <div ng-show="editForm.email.$invalid">\r\n                <p class="help-block"\r\n                   ng-show="editForm.email.$error.required">\r\n                    This field is required.\r\n                </p>\r\n\r\n                <p class="help-block"\r\n                   ng-show="editForm.email.$error.maxlength"\r\n                  >\r\n                    This field cannot be longer than 100 characters.\r\n                </p>\r\n\t\t\t\t<p class="help-block"\r\n                   ng-show="editForm.email.$error.email">\r\n                    Your email is invalid.\r\n                 </p>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label for="activated">\r\n                <input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated">\r\n                <span>Activated</span>\r\n            </label>\r\n        </div>\r\n\r\n        <div class="form-group">\r\n            <label>Profiles</label>\r\n            <select class="form-control" multiple name="authority" ng-model="vm.user.authorities"\r\n                    ng-options="authority for authority in vm.authorities">\r\n            </select>\r\n        </div>\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span\r\n           >Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>\r\n        </button>\r\n    </div>\r\n</form>\r\n');
$templateCache.put('app/admin/user-management/user-management.html','<div>\r\n    <h2>Users</h2>\r\n    <jhi-alert></jhi-alert>\r\n    <div class="row">\r\n      <div class="col-md-4">\r\n          <button class="btn btn-primary" ui-sref="user-management.new">\r\n              <span class="glyphicon glyphicon-flash"></span> <span>Create a new User</span>\r\n          </button>\r\n      </div>\r\n    </div>\r\n    <div class="table-responsive">\r\n        <table class="jh-table table table-striped">\r\n            <thead>\r\n            <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\r\n                <th jh-sort-by="id"><span>ID</span><span class="glyphicon glyphicon-sort"></span></th>\r\n                <th jh-sort-by="login"><span>Login</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n                <th jh-sort-by="email"><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n                <th></th>\r\n                                <th><span>Profiles</span></th>                <th jh-sort-by="createdDate"><span>Created Date</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n                <th jh-sort-by="lastModifiedBy"><span>Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n                <th jh-sort-by="lastModifiedDate"><span>Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th>\r\n                <th></th>\r\n            </tr>\r\n            </thead>\r\n            <tbody>\r\n            <tr ng-repeat="user in vm.users track by user.login">\r\n                <td><a ui-sref="user-management-detail({login:user.login})">{{user.login}}</a></td>\r\n                <td>{{user.login}}</td>\r\n                <td>{{user.email}}</td>\r\n                <td>\r\n                    <button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated"\r\n                           >Deactivated</button>\r\n                    <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated"\r\n                            ng-disabled="vm.currentAccount.login === user.login">Activated</button>\r\n                </td>\r\n\r\n                <td>\r\n                    <div ng-repeat="authority in user.authorities">\r\n                        <span class="label label-info">{{ authority }}</span>\r\n                    </div>\r\n                </td>\r\n                <td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td>\r\n                <td>{{user.lastModifiedBy}}</td>\r\n                <td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td>\r\n                <td class="text-right">\r\n                    <div class="btn-group flex-btn-group-container">\r\n                        <button type="submit"\r\n                                ui-sref="user-management-detail({login:user.login})"\r\n                                class="btn btn-info btn-sm">\r\n                            <span class="glyphicon glyphicon-eye-open"></span>\r\n                            <span class="hidden-xs hidden-sm"></span>\r\n                        </button>\r\n                        <button type="submit"\r\n                                ui-sref="user-management.edit({login:user.login})"\r\n                                class="btn btn-primary btn-sm">\r\n                            <span class="glyphicon glyphicon-pencil"></span>\r\n                            <span class="hidden-xs hidden-sm"></span>\r\n                        </button>\r\n                        <button type="submit"\r\n                                ui-sref="user-management.delete({login:user.login})"\r\n                                class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login === user.login">\r\n                            <span class="glyphicon glyphicon-remove-circle"></span>\r\n                            <span class="hidden-xs hidden-sm"></span>\r\n                        </button>\r\n                    </div>\r\n                </td>\r\n            </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n    <div class="text-center">\r\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\r\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('app/components/confirmbox/confirmbox.html','<div class="modal-header">\r\n    <h3>{{modalOptions.headerText}}</h3>\r\n</div>\r\n<div class="modal-body">\r\n    <p>{{modalOptions.bodyText}}</p>\r\n</div>\r\n<div class="modal-footer">\r\n    <button type="button" class="btn"\r\n            data-ng-click="modalOptions.close()">{{modalOptions.closeButtonText}}\r\n    </button>\r\n    <button class="btn btn-primary"\r\n            data-ng-click="modalOptions.ok();">{{modalOptions.actionButtonText}}\r\n    </button>\r\n</div>\r\n');
$templateCache.put('app/components/copyright/copyright.html','<div class="footer-inner text-center">\r\n\t<div class="">\r\n            <div class="copyright">Copyright \xA9 <a href="https://www.datasparc.com/" target="_blank">Datasparc Inc</a>. All Rights Reserved | <a href="https://www.datasparc.com/Datasparc-DBHawk-EULA.pdf" target="_blank">Terms of Use</a> | <a href="https://www.datasparc.com/privacy-policy/" target="_blank">Privacy Policy</a></div>\r\n\t</div>\r\n\r\n</div>\r\n');
$templateCache.put('app/components/copyright/terms.html','<div class="form-group" >\r\n    <div class="checkbox clip-check check-primary">\r\n        <input type="checkbox" id="agree" ng-model="vm.accept" required>\r\n        <label for="agree" class="terms-signin">\r\n            I accept <a class="alert-link term-link" href="https://www.datasparc.com/Datasparc-DBHawk-EULA.pdf" target="_blank">Terms of Service</a>\r\n            and <a class="alert-link term-link" href="https://www.datasparc.com/privacy-policy/" target="_blank">Datasparc\'s Privacy Policy</a>.\r\n        </label>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('app/components/login/login.html','<div class="modal-header">\r\n    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n            ng-click="vm.cancel()">&times;</button>\r\n    <h4 class="modal-title">Sign in</h4>\r\n</div>\r\n<div class="modal-body">\r\n    <div class="row">\r\n        <div class="col-md-4 col-md-offset-4">\r\n            <h1>Sign in</h1>\r\n        </div>\r\n        <div class="col-md-8 col-md-offset-2">\r\n            <div class="alert alert-danger" ng-show="vm.authenticationError">\r\n                <strong>Failed to sign in!</strong> Please check your credentials and try again.\r\n            </div>\r\n        </div>\r\n        <div class="col-md-6">\r\n            <form class="form" role="form" ng-submit="vm.login($event)">\r\n                <div class="form-group">\r\n                    <label for="username">Login</label>\r\n                    <input type="text" class="form-control" id="username" placeholder="Your username" ng-model="vm.username">\r\n                </div>\r\n                <div class="form-group">\r\n                    <label for="password">Password</label>\r\n                    <input type="password" class="form-control" id="password" placeholder="Your password"\r\n                           ng-model="vm.password">\r\n                </div>\r\n               <!-- <div class="form-group">\r\n                    <label for="rememberMe">\r\n                        <input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" >\r\n                        <span>Remember me</span>\r\n                    </label>\r\n                </div>-->\r\n                <!--<div class="form-group">\r\n                    <div class="checkbox clip-check check-primary">\r\n                        <input type="checkbox" id="agree" ng-model="vm.accept" required>\r\n                        <label for="agree">\r\n                            I accept <a class="alert-link" href="https://www.datasparc.com/terms-of-use/" target="_blank">the Terms of Service</a>,\r\n                            <a class="alert-link" href="https://www.datasparc.com/Datasparc-DBHawk-EULA.pdf" target="_blank">DBHawk EULA</a>\r\n                            and have read <a class="alert-link" href="https://www.datasparc.com/privacy-policy/" target="_blank">   Services Privacy Policy</a>.\r\n                        </label>\r\n                    </div>\r\n                </div>-->\r\n                <div ng-include="\'app/components/copyright/terms.html\'"></div>\r\n                <button type="submit" class="btn btn-primary">Sign in</button>\r\n\r\n            </form>\r\n            <p></p>\r\n\r\n        </div>\r\n        <div class="col-md-6">\r\n            <br/>\r\n            <div class="alert alert-primary">\r\n                <a class="alert-link" href="" ng-click="vm.requestResetPassword()">Did you forget your password?</a>\r\n            </div>\r\n            <div class="alert alert-primary">\r\n                You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a>\r\n            </div>\r\n           <!-- <jh-social ng-provider="google"></jh-social>\r\n            <jh-social ng-provider="facebook"></jh-social>\r\n            <jh-social ng-provider="twitter"></jh-social>-->\r\n            <!-- jhipster-needle-add-social-button -->\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n<!--<div vc-recaptcha\r\n     key="vm.reCaptchaPublicKey" size="vm.reCaptchaSize" ng-model="vm.recaptchaResponse"></div>-->\r\n');
$templateCache.put('app/components/login/signin.html','<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">\r\n<!-- start: LOGIN -->\r\n<div class="dbh-conteiner dbh-auth-conteiner">\r\n    <div class="">\r\n        <div class="row justify-content-center dbh-mobie-logo-wrap"><a href="https://www.datasparc.com/"> <img src="content/images/datasparc-logo.png" class="logo"></a> </div>\r\n        <div class="row">\r\n            <div class="row pb-5">\r\n                <div class="row dbh-logo-wrap">\r\n                    <a href="https://www.datasparc.com/"> \r\n                        <img src="content/images/datasparc-logo.png" class="logo">\r\n                    </a> \r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class="row d-flex flex-row-reverse">\r\n            <div class="col-lg-6 dbh-image-block">\r\n                <div class="row"></div>\r\n                <div class="row align-content mt-5">\r\n                    <div class="row justify-content-center dbh-image-wrap">\r\n                        <div class="dbh-f-image-wrap col-sm-2 mini-logo my-auto pr-1">\r\n                            <img src="content/images/trazado-300.png" class="">\r\n                        </div>\r\n                        <div class="dbh-f-block col-sm-10">\r\n                            <p class="dbh-f-title">Hybrid Tool for All Databases</p>\r\n                            <p class="dbh-f-desc">DBHawk provides secure access to on-premise and cloud databases. DBHawk supports a wide array of SQL and NoSQL databases.</p>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class="row align-content">\r\n                    <div class="row justify-content-center dbh-image-wrap">\r\n                        <div class="dbh-f-image-wrap col-sm-2 mini-logo my-auto  pr-1">\r\n                            <img src="content/images/trazado-288.png" class="">\r\n                        </div>\r\n                        <div class="dbh-f-block col-sm-10">\r\n                            <p class="dbh-f-title">Zero Trust Data Access</p>\r\n                            <p class="dbh-f-desc">Users only receive access to the data they need without exposing database username and password.</p>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class="row align-content">\r\n                    <div class="row justify-content-center dbh-image-wrap">\r\n                        <div class="dbh-f-image-wrap col-sm-2 mini-logo my-auto pr-1">\r\n                            <img src="content/images/trazado-271.png" class="">\r\n                        </div>\r\n                        <div class="dbh-f-block col-sm-10">\r\n                            <p class="dbh-f-title">DBHawk - All In One Solution</p>\r\n                            <p class="dbh-f-desc">Data Security, Database management, Data governance and data analytics</p>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class="col-lg-6 dbh-pr-5 pr-2">\r\n                <div class="card py-4 dbh-form-wrap">\r\n                    <div class="mb-4 px-3 pt-2 dbh-form-title">\r\n                        <h1 class="mb-2 mt-2 dbh-h1">Sign in to your account</h1>\r\n                    </div>\r\n                    <div class="alert alert-danger" ng-show="vm.authenticationError">\r\n                        <strong>Failed to sign in!</strong> Please check your credentials and try again.\r\n                    </div>\r\n                    <form class="form"  name="form" role="form" ng-submit="vm.login($event)">\r\n                        <div class="row px-3"> <label class="mb-1">\r\n                            </label> <input class="mb-3 dbh-input" type="text" name="email" ng-model="vm.username" placeholder="Email*" required>\r\n                        </div>\r\n                        <div class="row px-3 mb-3">\r\n                            <input class="dbh-input" type="password" placeholder="Password*" ng-model="vm.password" required>\r\n                        </div>\r\n                        <div class="row pl-3 mb-4 justify-content-end">\r\n                            <div class="pr-3">\r\n                                <a href="#" ui-sref="requestReset" class="ml-auto mb-0 text-sm">Forgot Password?</a>\r\n                            </div>\r\n                        </div>\r\n                        <div class="row px-3 mt-4 justify-content-end"> <button type="submit" ng-disabled="form.$invalid" class="dbh-button login-btn register-anm">Sign In</button> </div>\r\n                        <div class="row mb-4 px-3"> <span class="dbh-signin-wrap">Don\'t have an account yet? <a ui-sref="register" class="dbh-link">Sign Up</a></span> </div>\r\n\r\n                        <div vc-recaptcha key="vm.reCaptchaPublicKey" size="vm.reCaptchaSize" ng-model="vm.recaptchaResponse"></div>\r\n                    </form>\r\n                    <div class="row my-4 px-3 justify-content-center flex-column">\r\n                        <div class="copyright">\r\n                            Copyright <a href="https://www.datasparc.com/" target="_blank">Datasparc Inc</a>. All rights reserved\r\n                            | <a href="https://www.datasparc.com/terms-of-use/" target="_blank">Terms of Use</a> |\r\n                            <a href="https://www.datasparc.com/privacy-policy/" target="_blank">Privacy Policy</a>\r\n                        </div>\r\n                        <div class="dbh-app-version">Version: 2.0.0</div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<!-- end: LOGIN -->\r\n');
$templateCache.put('app/entities/company-dbh/companiesdbh.html','<div>\r\n    <h2>Companies</h2>\r\n    <jhi-alert></jhi-alert>\r\n    <div class="container-fluid">\r\n        <div class="row">\r\n            <div class="col-xs-4 no-padding-left">\r\n                <button class="btn btn-primary" ui-sref="company-dbh.new" >\r\n                    <span class="glyphicon glyphicon-plus"></span>\r\n                    <span >\r\n                        Create new Company\r\n                    </span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <br/>\r\n    <div class="table-responsive">\r\n        <table class="jh-table table table-striped">\r\n            <thead>\r\n                <tr>\r\n                    <th><span>ID</span></th>\r\n                    <th><span>Company Name</span></th>\r\n                    <th><span>Company Email</span></th>\r\n                    <th><span>Created Ip</span></th>\r\n                    <th><span>Last Ip</span></th>\r\n                    <th><span>Database Name</span></th>\r\n                    <th><span>First Name</span></th>\r\n                    <th><span>Last Name</span></th>\r\n                    <th><span>Job Function</span></th>\r\n                    <th><span>Locale</span></th>\r\n                    <th><span>Phone</span></th>\r\n                    <th><span>Message</span></th>\r\n                    <th><span>Completed</span></th>\r\n                    <th><span>User Id</span></th>\r\n                    <th></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-repeat="company in vm.companies track by company.id">\r\n                    <td><a ui-sref="company-dbh-detail({id:company.id})">{{company.id}}</a></td>\r\n                    <td>{{company.companyName}}</td>\r\n                    <td>{{company.companyEmail}}</td>\r\n                    <td>{{company.createdIp}}</td>\r\n                    <td>{{company.lastIp}}</td>\r\n                    <td>{{company.databaseName}}</td>\r\n                    <td>{{company.firstName}}</td>\r\n                    <td>{{company.lastName}}</td>\r\n                    <td>{{company.jobFunction}}</td>\r\n                    <td>{{company.locale}}</td>\r\n                    <td>{{company.phone}}</td>\r\n                    <td>{{company.message}}</td>\r\n                    <td>{{company.completed}}</td>\r\n                    <td>{{company.userId}}</td>\r\n                    <td class="text-right">\r\n                        <div class="btn-group flex-btn-group-container">\r\n                            <button type="submit"\r\n                                    ui-sref="company-dbh-detail({id:company.id})"\r\n                                    class="btn btn-info btn-sm">\r\n                                <span class="glyphicon glyphicon-eye-open"></span>\r\n                                <span class="hidden-sm-down"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="company-dbh.edit({id:company.id})"\r\n                                    class="btn btn-primary btn-sm">\r\n                                <span class="glyphicon glyphicon-pencil"></span>\r\n                                <span class="hidden-sm-down"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="company-dbh.delete({id:company.id})"\r\n                                    class="btn btn-danger btn-sm">\r\n                                <span class="glyphicon glyphicon-remove-circle"></span>\r\n                                <span class="hidden-sm-down"></span>\r\n                            </button>\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('app/entities/company-dbh/company-dbh-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.company.id)">\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title">Confirm delete operation</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <p>Are you sure you want to delete this Company?</p>\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger">\r\n            <span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span>\r\n        </button>\r\n    </div>\r\n</form>\r\n');
$templateCache.put('app/entities/company-dbh/company-dbh-detail.html','\r\n<div>\r\n    <h2><span>Company</span> {{vm.company.id}}</h2>\r\n    <hr>\r\n    <jhi-alert-error></jhi-alert-error>\r\n    <dl class="dl-horizontal jh-entity-details">\r\n        <dt><span>Company Name</span></dt>\r\n        <dd>\r\n            <span>{{vm.company.companyName}}</span>\r\n        </dd>\r\n        <dt><span>Company Email</span></dt>\r\n        <dd>\r\n            <span>{{vm.company.companyEmail}}</span>\r\n        </dd>\r\n        <dt><span>Created Ip</span></dt>\r\n        <dd>\r\n            <span>{{vm.company.createdIp}}</span>\r\n        </dd>\r\n        <dt><span>Last Ip</span></dt>\r\n        <dd>\r\n            <span>{{vm.company.lastIp}}</span>\r\n        </dd>\r\n        <dt><span>Database Name</span></dt>\r\n        <dd>\r\n            <span>{{vm.company.databaseName}}</span>\r\n        </dd>\r\n        <dt><span>First Name</span></dt>\r\n        <dd>\r\n            <span>{{vm.company.firstName}}</span>\r\n        </dd>\r\n        <dt><span>Last Name</span></dt>\r\n        <dd>\r\n            <span>{{vm.company.lastName}}</span>\r\n        </dd>\r\n        <dt><span>Job Function</span></dt>\r\n        <dd>\r\n            <span>{{vm.company.jobFunction}}</span>\r\n        </dd>\r\n        <dt><span>Locale</span></dt>\r\n        <dd>\r\n            <span>{{vm.company.locale}}</span>\r\n        </dd>\r\n        <dt><span>Phone</span></dt>\r\n        <dd>\r\n            <span>{{vm.company.phone}}</span>\r\n        </dd>\r\n        <dt><span>Message</span></dt>\r\n        <dd>\r\n            <span>{{vm.company.message}}</span>\r\n        </dd>\r\n        <dt><span>Completed</span></dt>\r\n        <dd>\r\n            <span>{{vm.company.completed}}</span>\r\n        </dd>\r\n        <dt><span>User Id</span></dt>\r\n        <dd>\r\n            <span>{{vm.company.userId}}</span>\r\n        </dd>\r\n    </dl>\r\n\r\n    <button type="submit"\r\n            ui-sref="{{ vm.previousState }}"\r\n            class="btn btn-info">\r\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span>\r\n    </button>\r\n\r\n    <button type="button" ui-sref="company-dbh-detail.edit({id:vm.company.id})" class="btn btn-primary">\r\n        <span class="glyphicon glyphicon-pencil"></span>\r\n        <span class="hidden-sm-down"> Edit</span>\r\n    </button>\r\n</div>\r\n');
$templateCache.put('app/entities/company-dbh/company-dbh-dialog.html','\r\n<form name="editForm" role="form" novalidate ng-submit="vm.save()">\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myCompanyLabel">Create or edit a Company</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <div class="form-group" ng-show="vm.company.id">\r\n            <label for="id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="vm.company.id" readonly />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_companyName">Company Name</label>\r\n            <input type="text" class="form-control" name="companyName" id="field_companyName"\r\n                    ng-model="vm.company.companyName"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_companyEmail">Company Email</label>\r\n            <input type="text" class="form-control" name="companyEmail" id="field_companyEmail"\r\n                    ng-model="vm.company.companyEmail"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_createdIp">Created Ip</label>\r\n            <input type="text" class="form-control" name="createdIp" id="field_createdIp"\r\n                    ng-model="vm.company.createdIp"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_lastIp">Last Ip</label>\r\n            <input type="text" class="form-control" name="lastIp" id="field_lastIp"\r\n                    ng-model="vm.company.lastIp"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_databaseName">Database Name</label>\r\n            <input type="text" class="form-control" name="databaseName" id="field_databaseName"\r\n                    ng-model="vm.company.databaseName"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_firstName">First Name</label>\r\n            <input type="text" class="form-control" name="firstName" id="field_firstName"\r\n                    ng-model="vm.company.firstName"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_lastName">Last Name</label>\r\n            <input type="text" class="form-control" name="lastName" id="field_lastName"\r\n                    ng-model="vm.company.lastName"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_jobFunction">Job Function</label>\r\n            <input type="text" class="form-control" name="jobFunction" id="field_jobFunction"\r\n                    ng-model="vm.company.jobFunction"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_locale">Locale</label>\r\n            <input type="text" class="form-control" name="locale" id="field_locale"\r\n                    ng-model="vm.company.locale"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_phone">Phone</label>\r\n            <input type="text" class="form-control" name="phone" id="field_phone"\r\n                    ng-model="vm.company.phone"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_message">Message</label>\r\n            <input type="text" class="form-control" name="message" id="field_message"\r\n                    ng-model="vm.company.message"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_completed">Completed</label>\r\n                <input type="checkbox" name="completed" id="field_completed"\r\n                          ng-model="vm.company.completed"/>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_userId">User Id</label>\r\n            <input type="number" class="form-control" name="userId" id="field_userId"\r\n                    ng-model="vm.company.userId"\r\n                    />\r\n        </div>\r\n\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>\r\n        </button>\r\n    </div>\r\n</form>\r\n');
$templateCache.put('app/entities/contact-us/contact-us-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.contactUs.id)">\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title">Confirm delete operation</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <p>Are you sure you want to delete this Contact Us?</p>\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger">\r\n            <span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span>\r\n        </button>\r\n    </div>\r\n</form>\r\n');
$templateCache.put('app/entities/contact-us/contact-us-detail.html','\r\n<div>\r\n    <h2><span>Contact Us</span> {{vm.contactUs.id}}</h2>\r\n    <hr>\r\n    <jhi-alert-error></jhi-alert-error>\r\n    <dl class="dl-horizontal jh-entity-details">\r\n        <dt><span>Contact Name</span></dt>\r\n        <dd>\r\n            <span>{{vm.contactUs.contactName}}</span>\r\n        </dd>\r\n        <dt><span>Contact Email</span></dt>\r\n        <dd>\r\n            <span>{{vm.contactUs.contactEmail}}</span>\r\n        </dd>\r\n        <dt><span>Phone</span></dt>\r\n        <dd>\r\n            <span>{{vm.contactUs.phone}}</span>\r\n        </dd>\r\n        <dt><span>Dbs</span></dt>\r\n        <dd>\r\n            <span>{{vm.contactUs.dbs}}</span>\r\n        </dd>\r\n        <dt><span>Company Name</span></dt>\r\n        <dd>\r\n            <span>{{vm.contactUs.companyName}}</span>\r\n        </dd>\r\n        <dt><span>Job Pos</span></dt>\r\n        <dd>\r\n            <span>{{vm.contactUs.jobPos}}</span>\r\n        </dd>\r\n        <dt><span>Instance Id</span></dt>\r\n        <dd>\r\n            <span>{{vm.contactUs.instanceId}}</span>\r\n        </dd>\r\n        <dt><span>Subject</span></dt>\r\n        <dd>\r\n            <span>{{vm.contactUs.subject}}</span>\r\n        </dd>\r\n        <dt><span>Messages</span></dt>\r\n        <dd>\r\n            <span>{{vm.contactUs.messages}}</span>\r\n        </dd>\r\n        <dt><span>User Id</span></dt>\r\n        <dd>\r\n            <span>{{vm.contactUs.userId}}</span>\r\n        </dd>\r\n    </dl>\r\n\r\n    <button type="submit"\r\n            ui-sref="{{ vm.previousState }}"\r\n            class="btn btn-info">\r\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span>\r\n    </button>\r\n\r\n    <button type="button" ui-sref="contact-us-detail.edit({id:vm.contactUs.id})" class="btn btn-primary">\r\n        <span class="glyphicon glyphicon-pencil"></span>\r\n        <span class="hidden-sm-down"> Edit</span>\r\n    </button>\r\n</div>\r\n');
$templateCache.put('app/entities/contact-us/contact-us-dialog.html','\r\n<form name="editForm" role="form" novalidate ng-submit="vm.save()">\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myContactUsLabel">Create or edit a Contact Us</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <div class="form-group" ng-show="vm.contactUs.id">\r\n            <label for="id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="vm.contactUs.id" readonly />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_contactName">Contact Name</label>\r\n            <input type="text" class="form-control" name="contactName" id="field_contactName"\r\n                    ng-model="vm.contactUs.contactName"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_contactEmail">Contact Email</label>\r\n            <input type="text" class="form-control" name="contactEmail" id="field_contactEmail"\r\n                    ng-model="vm.contactUs.contactEmail"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_phone">Phone</label>\r\n            <input type="text" class="form-control" name="phone" id="field_phone"\r\n                    ng-model="vm.contactUs.phone"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_dbs">Dbs</label>\r\n            <input type="text" class="form-control" name="dbs" id="field_dbs"\r\n                    ng-model="vm.contactUs.dbs"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_companyName">Company Name</label>\r\n            <input type="text" class="form-control" name="companyName" id="field_companyName"\r\n                    ng-model="vm.contactUs.companyName"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_jobPos">Job Pos</label>\r\n            <input type="text" class="form-control" name="jobPos" id="field_jobPos"\r\n                    ng-model="vm.contactUs.jobPos"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_instanceId">Instance Id</label>\r\n            <input type="text" class="form-control" name="instanceId" id="field_instanceId"\r\n                    ng-model="vm.contactUs.instanceId"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_subject">Subject</label>\r\n            <input type="text" class="form-control" name="subject" id="field_subject"\r\n                    ng-model="vm.contactUs.subject"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_messages">Messages</label>\r\n            <input type="text" class="form-control" name="messages" id="field_messages"\r\n                    ng-model="vm.contactUs.messages"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_userId">User Id</label>\r\n            <input type="number" class="form-control" name="userId" id="field_userId"\r\n                    ng-model="vm.contactUs.userId"\r\n                    />\r\n        </div>\r\n\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>\r\n        </button>\r\n    </div>\r\n</form>\r\n');
$templateCache.put('app/entities/contact-us/contactuses.html','<div>\r\n    <h2>Contactuses</h2>\r\n    <jhi-alert></jhi-alert>\r\n    <div class="container-fluid">\r\n        <div class="row">\r\n            <div class="col-xs-4 no-padding-left">\r\n                <button class="btn btn-primary" ui-sref="contact-us.new" >\r\n                    <span class="glyphicon glyphicon-plus"></span>\r\n                    <span >\r\n                        Create new Contact Us\r\n                    </span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <br/>\r\n    <div class="table-responsive">\r\n        <table class="jh-table table table-striped">\r\n            <thead>\r\n                <tr>\r\n                    <th><span>ID</span></th>\r\n                    <th><span>Contact Name</span></th>\r\n                    <th><span>Contact Email</span></th>\r\n                    <th><span>Phone</span></th>\r\n                    <th><span>Dbs</span></th>\r\n                    <th><span>Company Name</span></th>\r\n                    <th><span>Job Pos</span></th>\r\n                    <th><span>Instance Id</span></th>\r\n                    <th><span>Subject</span></th>\r\n                    <th><span>Messages</span></th>\r\n                    <th><span>User Id</span></th>\r\n                    <th></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-repeat="contactUs in vm.contactuses track by contactUs.id">\r\n                    <td><a ui-sref="contact-us-detail({id:contactUs.id})">{{contactUs.id}}</a></td>\r\n                    <td>{{contactUs.contactName}}</td>\r\n                    <td>{{contactUs.contactEmail}}</td>\r\n                    <td>{{contactUs.phone}}</td>\r\n                    <td>{{contactUs.dbs}}</td>\r\n                    <td>{{contactUs.companyName}}</td>\r\n                    <td>{{contactUs.jobPos}}</td>\r\n                    <td>{{contactUs.instanceId}}</td>\r\n                    <td>{{contactUs.subject}}</td>\r\n                    <td>{{contactUs.messages}}</td>\r\n                    <td>{{contactUs.userId}}</td>\r\n                    <td class="text-right">\r\n                        <div class="btn-group flex-btn-group-container">\r\n                            <button type="submit"\r\n                                    ui-sref="contact-us-detail({id:contactUs.id})"\r\n                                    class="btn btn-info btn-sm">\r\n                                <span class="glyphicon glyphicon-eye-open"></span>\r\n                                <span class="hidden-sm-down"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="contact-us.edit({id:contactUs.id})"\r\n                                    class="btn btn-primary btn-sm">\r\n                                <span class="glyphicon glyphicon-pencil"></span>\r\n                                <span class="hidden-sm-down"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="contact-us.delete({id:contactUs.id})"\r\n                                    class="btn btn-danger btn-sm">\r\n                                <span class="glyphicon glyphicon-remove-circle"></span>\r\n                                <span class="hidden-sm-down"></span>\r\n                            </button>\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('app/entities/ipaddress/ipaddress-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.entity.instanceId, vm.entity.ipAddress)">\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title">Confirm delete operation</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <p>Are you sure you want to delete this Ip Address?</p>\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger">\r\n            <span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span>\r\n        </button>\r\n    </div>\r\n</form>\r\n');
$templateCache.put('app/entities/ipaddress/ipaddress-dialog.html','<form name="form" role="form" novalidate ng-submit="vm.save()" show-validation>\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myPeeringLabel">Add Ip Address</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <div class="alert alert-danger" ng-show="vm.error">\r\n            <strong>Ip Address failed!</strong> Check input values and try again.\r\n        </div>\r\n\r\n        <div class="form-group">\r\n            <select id="ipAddressOptions" name="ipAddressOptions" class="form-control" style="width: 110px"\r\n                    ng-change="vm.change()" ng-model="vm.ipAddressOption"\r\n                    ng-options="option for option in vm.ipAddressOptions">\r\n            </select>\r\n        </div>\r\n\r\n        <div class="form-group">\r\n            <label class="control-label" for="ipAddress">Ip Address</label>\r\n            <input type="text" class="form-control" name="ipAddress" id="ipAddress"\r\n                    ng-model="vm.ipAddress" placeholder="" ng-minlength=7 required/>\r\n            <div ng-show="form.ipAddress.$dirty && form.ipAddress.$invalid">\r\n                <p class="help-block"\r\n                   ng-show="form.ipAddress.$error.required">\r\n                    Ip Address is required.\r\n                </p>\r\n                <p class="help-block"\r\n                   ng-show="form.ipAddress.$error.minlength">\r\n                    Ip Address is required to be at least 7 characters.\r\n                </p>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="form.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>\r\n        </button>\r\n    </div>\r\n</form>\r\n');
$templateCache.put('app/entities/instance-dbh/full-access-form.html','<div class="container-fluid container-fullw mlr-0" xmlns="http://www.w3.org/1999/html">\r\n\t<div class="row">\r\n\t\t<div class="container-fluid container-fullw bg-white mlr-0" ng-switch on="isSelected(instance)" ng-repeat="instance in vm.instances track by instance.id  ">\r\n\t\t\t<div class="row">\r\n\t\t\t\t<div class="col-sm-12">\r\n\t\t\t\t\t<h4 class="text-center">Request A Full Personalized Access</h4>\r\n\t\t\t\t\t<div class="red-divider"></div>\r\n\t\t\t\t\t<div class="col-md-4 col-md-offset-4 pt-30 plr-0">\r\n\t\t\t\t\t\t<form name="form" role="form" novalidate ng-submit="vm.contact(instance.instanceId)" show-validation>\r\n\t\t\t\t\t\t\t<jhi-alert></jhi-alert>\r\n                            <div class="alert alert-danger" ng-show="vm.errorCompanyExists">\r\n                                <strong>Company or domain is already in use!</strong>\r\n                            </div>\r\n\t\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t\t<label for="name">\r\n\t\t\t\t\t\t\t\t\t   Your Name*\r\n\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t   <input type="text" class="form-control" id="name" name="contactName" placeholder="Your Name"\r\n\t\t\t\t\t\t\t\t\t\tuib-tooltip="Name is required" tooltip-is-open="form.contactName.$dirty && form.contactName.$invalid"\r\n\t\t\t\t\t\t\t\t\t\ttooltip-trigger="none" tooltip-placement="auto right" style=""\r\n\t\t\t\t\t\t\t\t\t\tng-model="vm.contactParam.contactName" ng-minlength=2 ng-maxlength=100 required>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t   <label class="control-label">\r\n\t\t\t\t\t\t\t\t\t  Job Function*\r\n\t\t\t\t\t\t\t\t   </label>\r\n\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="vm.job.selected" class="custom-ui-select-style" theme="bootstrap"\r\n\t\t\t\t\t\t\t\t\t\t\t   required title="Choose a job function" ng-disabled="vm.disabled">\r\n\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="Please select">{{$select.selected.name}}</ui-select-match>\r\n\t\t\t\t\t\t\t\t\t\t<ui-select-choices repeat="job in vm.jobs" class="" >\r\n\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="job.name"></span>\r\n\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\r\n\t\t\t\t\t\t\t\t\t\t</ui-select>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t\t<label for="tel">\r\n\t\t\t\t\t\t\t\t\t   Contact Number*\r\n\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t\t\t  <input type="text" class="form-control" id="tel" name="phone" ng-model="vm.contactParam.phone" placeholder="6782214185"\r\n\t\t\t\t\t\t\t\t\t\t   uib-tooltip="Invalid Phone Number" tooltip-is-open="form.phone.$invalid && form.phone.$dirty"\r\n\t\t\t\t\t\t\t\t\t\t   tooltip-trigger="none" tooltip-placement="auto right" ng-intl-tel-input required\r\n\t\t\t\t\t\t\t\t\t\t   ng-pattern="/^\\+?\\d{9,10}$/">\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t   <label class="control-label">\r\n\t\t\t\t\t\t\t\t\t  Company Name*\r\n\t\t\t\t\t\t\t\t   </label>\r\n\t\t\t\t\t\t\t\t   <input type="text" placeholder="Company Name" class="form-control" ng-required="true" id="company_name" name="company_name" ng-model="vm.contactParam.company_name" ng-keyup="vm.processDomain()">\r\n\t\t\t\t\t\t\t\t</div>\r\n                            <div class="form-group" ng-show="form.company_name.$dirty && !form.company_name.$invalid">\r\n                                <label class="control-label" >Your DBHawk URL:</label>\r\n                                <label class="control-label" ><b>https://{{vm.contactParam.domain}}.dbhawk.com/dbhawk</b></label>\r\n                            </div>\r\n\t\t\t\t\t\t\t   <div class="form-group">\r\n\t\t\t\t\t\t\t\t   <label class="control-label">\r\n\t\t\t\t\t\t\t\t\t   Business Email (Requests with <span class="ital-class">non-Business Email</span> will be ignored) *\r\n\t\t\t\t\t\t\t\t   </label>\r\n\t\t\t\t\t\t\t\t   <input type="email" class="form-control ng-pristine ng-valid ng-not-empty ng-valid-email ng-valid-required ng-touched" id="em" name="em" ng-model="vm.contactParam.email" uib-tooltip="Invalid Email" tooltip-is-open="form.em.$invalid &amp;&amp; form.em.$dirty" tooltip-trigger="none" tooltip-placement="auto right" required="" aria-invalid="false">\r\n\t\t\t\t\t\t\t   </div>\r\n\t\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t   <label class="control-label">\r\n\t\t\t\t\t\t\t\t\t   Database *\r\n\t\t\t\t\t\t\t\t   </label>\r\n                                    <div class="row">\r\n                                        <div class="col-xs-4">\r\n                                            <div ng-repeat="db in vm.database track by $index" >\r\n                                                <div class="checkbox clip-check check-primary" ng-show="$index%3==0">\r\n                                                    <input type="checkbox" id="{{db.name}}" ng-model="db.checked"/></input>\r\n                                                    <label for="{{db.name}}">{{db.name}} </label>\r\n                                                </div>\r\n                                            </div>\r\n                                        </div>\r\n                                        <div class="col-xs-4">\r\n                                            <div ng-repeat="db in vm.database track by $index" >\r\n                                                <div class="checkbox clip-check check-primary" ng-show="$index%3==1">\r\n                                                    <input type="checkbox" id="{{db.name+1}}" ng-model="db.checked"/></input>\r\n                                                    <label for="{{db.name+1}}">{{db.name}} </label>\r\n                                                </div>\r\n                                            </div>\r\n                                        </div>\r\n                                        <div class="col-xs-4">\r\n                                            <div ng-repeat="db in vm.database track by $index" >\r\n                                                <div class="checkbox clip-check check-primary" ng-show="$index%3==2">\r\n                                                    <input type="checkbox" id="{{db.name+2}}" ng-model="db.checked"/></input>\r\n                                                    <label for="{{db.name+2}}">{{db.name}} </label>\r\n                                                </div>\r\n                                            </div>\r\n                                        </div>\r\n                                    </div>\r\n\r\n\t\t\t\t\t\t\t   </div>\r\n\t\t\t\t\t\t\t   <div class="form-group">\r\n\t\t\t\t\t\t\t\t\t<label class="control-label" for="message">Use Case *</label>\r\n\t\t\t\t\t\t\t\t\t<textarea class="form-control textarea" id="message" name="use_case" placeholder="Use Case" ng-model="vm.contactParam.use_case" ng-checked="vm.contactParam.use_case"\r\n\t\t\t\t\t\t\t\t\t\tng-minlength=2 ng-maxlength=750 required cols="5" rows="3"></textarea>\r\n\t\t\t\t\t\t\t\t</div>\r\n\r\n                            <div class="form-group">\r\n                                <div class="checkbox clip-check check-primary" >\r\n                                    <input type="checkbox" id="allow1"  ng-model="vm.contactParam.installInstanceAgreement" /></input>\r\n                                    <label for="allow1"> Allow Datasparc sales representative to contact me.</label>\r\n                                </div>\r\n                            </div>\r\n\t\t\t\t\t\t\t   <div class="form-actions">\r\n\t\t\t\t\t\t\t\t\t<button type="submit" class="btn btn-wide btn-primary pull-right" ng-disabled="form.$invalid || !vm.contactParam.installInstanceAgreement" disabled="disabled">\r\n\t\t\t\t\t\t\t\t\t\tRequest A Full Personalized Access <i class="fa fa-arrow-circle-right"></i>\r\n\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t   </div>\r\n\t\t\t\t\t\t\t</form>\r\n\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n\r\n<footer data-ng-include=" \'app/components/copyright/copyright.html\' "></footer>\r\n\r\n');
$templateCache.put('app/entities/instance-dbh/instance-dbh-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.instance.id)">\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title">Confirm delete operation</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <p>Are you sure you want to delete this Instance?</p>\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger">\r\n            <span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span>\r\n        </button>\r\n    </div>\r\n</form>\r\n');
$templateCache.put('app/entities/instance-dbh/instance-dbh-detail.html','\r\n<div>\r\n    <h2><span>Instance</span> {{vm.instance.id}}</h2>\r\n    <hr>\r\n    <jhi-alert-error></jhi-alert-error>\r\n    <dl class="dl-horizontal jh-entity-details">\r\n        <dt><span>Instance Id</span></dt>\r\n        <dd>\r\n            <span>{{vm.instance.instanceId}}</span>\r\n        </dd>\r\n        <dt><span>Name</span></dt>\r\n        <dd>\r\n            <span>{{vm.instance.name}}</span>\r\n        </dd>\r\n        <dt><span>Active</span></dt>\r\n        <dd>\r\n            <span>{{vm.instance.active}}</span>\r\n        </dd>\r\n        <dt><span>Cidr Block</span></dt>\r\n        <dd>\r\n            <span>{{vm.instance.cidrBlock}}</span>\r\n        </dd>\r\n        <dt><span>Dbhawk Url</span></dt>\r\n        <dd>\r\n            <span>{{vm.instance.dbhawkUrl}}</span>\r\n        </dd>\r\n        <dt><span>Public Dns</span></dt>\r\n        <dd>\r\n            <span>{{vm.instance.publicDns}}</span>\r\n        </dd>\r\n        <dt><span>Region</span></dt>\r\n        <dd>\r\n            <span>{{vm.instance.region}}</span>\r\n        </dd>\r\n        <dt><span>Security Grp</span></dt>\r\n        <dd>\r\n            <span>{{vm.instance.securityGrp}}</span>\r\n        </dd>\r\n        <dt><span>Status</span></dt>\r\n        <dd>\r\n            <span>{{vm.instance.status}}</span>\r\n        </dd>\r\n        <dt><span>Subnet Id</span></dt>\r\n        <dd>\r\n            <span>{{vm.instance.subnetId}}</span>\r\n        </dd>\r\n        <dt><span>Tag</span></dt>\r\n        <dd>\r\n            <span>{{vm.instance.tag}}</span>\r\n        </dd>\r\n        <dt><span>User Id</span></dt>\r\n        <dd>\r\n            <span>{{vm.instance.userId}}</span>\r\n        </dd>\r\n        <dt><span>Vpc</span></dt>\r\n        <dd>\r\n            <a ui-sref="vpc-dbh-detail({id:vm.instance.vpcId})">{{vm.instance.vpcId}}</a>\r\n        </dd>\r\n    </dl>\r\n\r\n    <button type="submit"\r\n            ui-sref="{{ vm.previousState }}"\r\n            class="btn btn-info">\r\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span>\r\n    </button>\r\n\r\n    <button type="button" ui-sref="instance-dbh-detail.edit({id:vm.instance.id})" class="btn btn-primary">\r\n        <span class="glyphicon glyphicon-pencil"></span>\r\n        <span class="hidden-sm-down"> Edit</span>\r\n    </button>\r\n</div>\r\n');
$templateCache.put('app/entities/instance-dbh/instance-dbh-dialog.html','\r\n<form name="editForm" role="form" novalidate ng-submit="vm.save()">\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myInstanceLabel">Create  an Instance</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_cidrBlock">Cidr Block</label>\r\n            <input type="text" class="form-control" name="cidrBlock" id="field_cidrBlock"\r\n                    ng-model="vm.instance.cidrBlock"/>\r\n        </div>\r\n\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_region">Region</label>\r\n            <select class="form-control" id="field_region" name="region" ng-model="vm.instance.region">\r\n                <option value="us-east-1">US East (N. Virginia)</option>\r\n                <option value="us-east-2">US East (Ohio)</option>\r\n                <option value="us-west-1">US West (N. California)</option>\r\n                <option value="us-west-2">US West (Oregon)</option>\r\n\r\n                <option value="eu-central-1">EU (Frankfurt)</option>\r\n                <option value="eu-west-1">EU (Ireland)</option>\r\n                <option value="eu-west-2">EU (London)</option>\r\n            </select>\r\n\r\n        </div>\r\n\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-cloud"></span>&nbsp;<span>Launch</span>\r\n        </button>\r\n    </div>\r\n</form>\r\n');
$templateCache.put('app/entities/instance-dbh/instancesdbh-list.html','<div ng-show="vm.onlyDemo">\r\n<section id="page-title" class="padding-top-15 padding-bottom-15" ng-switch on="isSelected(instance)" ng-repeat="instance in vm.instances track by instance.id ">\r\n    <div class="row">\r\n        <h1 class="mainTitle">{{instance.name}}</h1>\r\n\r\n    </div>\r\n</section>\r\n\r\n\r\n\r\n<div class="container-fluid container-fullw"   ng-switch on="isSelected(instance)" ng-repeat="instance in vm.instances track by instance.id  ">\r\n    <div class="row">\r\n        <div class="col-sm-12">\r\n\r\n            <div class="tab_container">\r\n\r\n                <input id="tab11" type="radio" name="tabs1" ng-model=\'mValue\'  value=\'details\'>\r\n                <label for="tab11"><i class="fa fa-check-circle-o"></i><span>Limited Access</span></label>\r\n\r\n                <input id="tab21" type="radio" name="tabs1" ng-model=\'mValue\' value=\'users\'>\r\n                <label for="tab21"><i class="fa fa-plus-circle"></i><span>Full Access</span></label>\r\n\r\n\r\n                <section id="content11" class="tab-content">\r\n\r\n                    <div ng-include="\'app/entities/instance-dbh/maintab/limited.html\'"></div>\r\n\r\n                </section>\r\n                <section id="content21" class="tab-content">\r\n\r\n                    <div ng-include="\'app/entities/instance-dbh/maintab/full.html\'"></div>\r\n                </section>\r\n            </div>\r\n\r\n          <!--  <uib-tabset class="tabbable">\r\n                <uib-tab heading="Limited Access">\r\n\r\n                </uib-tab>\r\n                <uib-tab heading="Full Access">\r\n\r\n                </uib-tab>\r\n            </uib-tabset>-->\r\n        </div>\r\n    </div>\r\n</div>\r\n</div>\r\n\r\n<div ng-show="!vm.onlyDemo">\r\n<div class="container-fluid container-fullw" style="padding-top: 0px;" ng-switch on="isSelected(instance)" ng-repeat="instance in vm.instances track by instance.id  ">\r\n    <div class="row">\r\n        <div class="col-sm-12">\r\n                    <div class="container-fluid container-fullw" style="padding-top: 0px; padding-bottom: 0px">\r\n                        <div class="row">\r\n                            <div class="col-sm-12">\r\n                                <div class="panel panel-white" style="padding-top: 0;" ng-show="vm.instanceStatus == null && vm.showInstancePanel">\r\n                                    <div class="panel-body" style="padding: 0px;">\r\n                                        <div class="col-sm-12">\r\n                                            <div>\r\n                                                <div class="progress-wrapper">\r\n                                                    <div class="progress-svg" ng-style="getStyle()"><b>{{instance.license.daysRemain}} Days</b> <br/> Remaining\r\n                                                    </div>\r\n                                                    <round-progress\r\n                                                        max="instance.trialDays"\r\n                                                        current="vm.dynamicValue"\r\n                                                        color="#FE6209"\r\n                                                        bgcolor="#007AFF"\r\n                                                        radius="100"\r\n                                                        stroke="20"\r\n                                                        semi="false"\r\n                                                        rounded="true"\r\n                                                        clockwise="true"\r\n                                                        responsive="false"\r\n                                                        duration="800"\r\n                                                        animation="easeInOutQuart"\r\n                                                        animation-delay="10"></round-progress>\r\n                                                </div>\r\n\r\n                                            </div>\r\n                                        </div>\r\n                                        <div class="col-sm-12 text-center" style="margin-top: -30px">\r\n                                            <a type="button" class="btn btn-wide btn-primary btn-lg mt-40" ng-show="instance.license.daysRemain>0" ng-href="{{instance.urlOpen}}" ng-disabled="!instance.license.daysRemain>0" target="_blank">\r\n                                                <i class="fa fa-cloud"></i> Access My DBHawk\r\n                                            </a>\r\n                                        </div>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n\r\n            <div class="container-fluid container-fullw bg-white" style="padding-top: 0;">\r\n            <div class="tab_container" ng-show="vm.instanceStatus == null && vm.showInstancePanel">\r\n                <input id="tab1" type="radio" name="tabs" ng-model=\'mValue\'  value=\'details\'>\r\n                <label for="tab1"><i class="fa fa-code"></i><span>DBHawk Details</span></label>\r\n\r\n                <input id="tab2" type="radio" name="tabs" ng-model=\'mValue\' value=\'users\'>\r\n                <label for="tab2"><i class="fa fa-user"></i><span>Users</span></label>\r\n\r\n                <input id="tab4" type="radio" name="tabs" ng-model=\'mValue\' value=\'addresses\'>\r\n                <label for="tab4"><i class="fa fa-shield"></i><span>IP Restrictions</span></label>\r\n\r\n                <input id="tab3" type="radio" name="tabs" ng-model=\'mValue\' value=\'peering\'>\r\n                <label for="tab3"><i class="fa fa-mixcloud"></i><span>VPC Peering</span></label>\r\n\r\n\r\n\r\n                <section id="content1" class="tab-content">\r\n                    <h5>Instance Details</h5>\r\n                    <div class="red-divider" style="margin:0px;"></div>\r\n                    <p></p>\r\n                    <div ng-include="\'app/entities/instance-dbh/tabs/details.html\'"></div>\r\n\r\n                </section>\r\n\r\n                <section id="content2" class="tab-content">\r\n                    <h5>DBHawk Users</h5>\r\n                    <div class="red-divider" style="margin:0px;"></div>\r\n                    <p></p>\r\n                    <div ng-include="\'app/entities/instance-dbh/tabs/users.html\'"></div>\r\n\r\n                </section>\r\n\r\n                <section id="content3" class="tab-content" >\r\n                    <h5>VPC Peering List</h5>\r\n                    <div class="red-divider" style="margin:0px;"></div>\r\n                    <p></p>\r\n                    <div ng-include="\'app/entities/instance-dbh/tabs/peering.html\'"></div>\r\n\r\n                </section>\r\n\r\n                <section id="content4" class="tab-content" >\r\n                    <h5>IP Addresses White List</h5>\r\n                    <div class="red-divider" style="margin:0px;"></div>\r\n                    <p></p>\r\n                    <div ng-include="\'app/entities/instance-dbh/tabs/addresses.html\'"></div>\r\n\r\n                </section>\r\n            </div>\r\n                <div  class="panel panel-info panel-thankyouusing" ng-show="(vm.instanceStatus == \'n/a\' && !vm.showInstancePanel)">\r\n                    <div class="panel-heading text-center">\r\n                        Thank you for trying DBHawk\r\n                    </div>\r\n                </div>\r\n\r\n                <div  class="panel panel-info panel-thankyouusing" ng-show="(!vm.showInstancePanel && (vm.instanceStatus == \'stopped\' || vm.instanceStatus == \'initializing\'))">\r\n                    <div class="panel-heading text-center">\r\n                        Instance stopped due by inactivity. <a ui-sref="contact">Contact support </a> if you need to run it again.\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n                    <!--<div class="container-fluid container-fullw bg-white">\r\n                        <div class="nav-tabs row" role="tablist" ng-init="selectedTab = \'details\';">\r\n                            <div class="col-sm-3">\r\n                                <div class="panel panels  panel-white no-radius text-center" ng-class="{active: selectedTab == \'details\'}" >\r\n                                    <div class="panel-body" ng-click="selectedTab = \'details\';">\r\n                                        <span class="fa-stack fa-2x"> <i class="fa fa-square fa-stack-2x text-primary"></i> <i class="fa fa-code fa-stack-1x fa-inverse"></i> </span>\r\n                                        <h3>DBHawk Details</h3>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                            <div class="col-sm-3">\r\n                                <div class="panel panels panel-white no-radius text-center" ng-class="{active: selectedTab == \'users\'}">\r\n                                    <div class="panel-body" ng-click="selectedTab = \'users\';">\r\n                                        <span class="fa-stack fa-2x"> <i class="fa fa-square fa-stack-2x text-primary"></i> <i class="fa fa-users fa-stack-1x fa-inverse"></i> </span>\r\n                                        <h3>Users</h3>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                            <div class="col-sm-3">\r\n                                <div class="panel panels panel-white no-radius text-center" ng-class="{active: selectedTab == \'restrictions\'}">\r\n                                    <div class="panel-body" ng-click="selectedTab = \'restrictions\';">\r\n                                        <span class="fa-stack fa-2x"> <i class="fa fa-square fa-stack-2x text-primary"></i> <i class="fa fa-shield fa-stack-1x fa-inverse"></i> </span>\r\n                                        <h3>IP Restrictions</h3>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                            <div class="col-sm-3">\r\n                                <div class="panel panels panel-white no-radius text-center" ng-class="{active: selectedTab == \'peering\'}">\r\n                                    <div class="panel-body" ng-click="selectedTab = \'peering\';">\r\n                                        <span class="fa-stack fa-2x"> <i class="fa fa-square fa-stack-2x text-primary"></i> <i class="fa fa-cloud fa-stack-1x fa-inverse"></i> </span>\r\n                                        <h3>VPC Peering</h3>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>-->\r\n\r\n                 <!--   <div class="container-fluid container-fullw padding-bottom-10">\r\n                        <div class="tab-pane" ng-show="selectedTab == \'details\'">\r\n                            <div class="row">\r\n                                <div class="col-sm-12">\r\n                                    <div class="row">\r\n                                        <div class="col-md-5 col-lg-4">\r\n                                            <div class="panel panel-white no-radius">\r\n                                                <div class="panel-heading border-light">\r\n                                                    <h4 class="panel-title"> Instance Details\r\n                                                        <span class="red-line mt-10"></span></h4>\r\n                                                </div>\r\n                                                <div class="panel-body">\r\n                                                    <div class="row pb-10">\r\n                                                        <div class="col-sm-4">\r\n                                                            <h4 class="no-margin"><strong>CIDR:</strong></h4>\r\n                                                        </div>\r\n                                                        <div class="col-sm-4">\r\n                                                            <h4 class="no-margin">172.10.0.0/16</h4>\r\n                                                        </div>\r\n                                                    </div>\r\n                                                    <div class="row pb-10">\r\n                                                        <div class="col-sm-4">\r\n                                                            <h4 class="no-margin"><strong>Status:</strong></h4>\r\n                                                        </div>\r\n                                                        <div class="col-sm-4">\r\n                                                            <h4 class="no-margin">running ok</h4>\r\n                                                        </div>\r\n                                                    </div>\r\n                                                    <div class="row pb-10">\r\n                                                        <div class="col-sm-4">\r\n                                                            <h4 class="no-margin"><strong>Region:</strong></h4>\r\n                                                        </div>\r\n                                                        <div class="col-sm-4">\r\n                                                            <h4 class="no-margin">us-east-1</h4>\r\n                                                        </div>\r\n                                                    </div>\r\n                                                </div>\r\n                                            </div>\r\n                                        </div>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div class="tab-pane" ng-show="selectedTab == \'users\'">\r\n                            <div class="row">\r\n                                <div class="col-sm-12">\r\n                                    <div class="row">\r\n                                        <div class="col-md-12">\r\n                                            <div class="panel panel-white">\r\n                                                <div class="panel-heading border-light">\r\n                                                    <h4 class="panel-title">DBHawk Users\r\n                                                        <span class="red-line mt-10"></span></h4>\r\n                                                    <div class="right-btn">\r\n                                                        <button type="button" class="btn btn-wide btn-primary">\r\n                                                            <i class="fa fa-users"></i> Invite Users\r\n                                                        </button>\r\n                                                    </div>\r\n                                                </div>\r\n                                                <div class="panel-body">\r\n\r\n                                                </div>\r\n                                            </div>\r\n                                        </div>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div class="tab-pane" ng-show="selectedTab == \'restrictions\'">\r\n                            <div class="row">\r\n                                <div class="col-sm-12">\r\n                                    <div class="row">\r\n                                        <div class="col-md-12">\r\n                                            <div class="panel panel-white">\r\n                                                <div class="panel-heading border-light">\r\n                                                    <h4 class="panel-title">IP Addresses White List\r\n                                                        <span class="red-line mt-10"></span></h4>\r\n                                                    <div class="right-btn">\r\n                                                        <button type="button" class="btn btn-wide btn-primary">\r\n                                                            <i class="fa fa-plus"></i> Add IP Address\r\n                                                        </button>\r\n                                                    </div>\r\n                                                </div>\r\n                                                <div class="panel-body">\r\n\r\n                                                </div>\r\n                                            </div>\r\n                                        </div>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div class="tab-pane" ng-show="selectedTab == \'peering\'">\r\n                            <div class="row">\r\n                                <div class="col-sm-12">\r\n                                    <div class="row">\r\n                                        <div class="col-md-12">\r\n                                            <div class="panel panel-white">\r\n                                                <div class="panel-heading border-light">\r\n                                                    <h4 class="panel-title">VPC Peering List\r\n                                                        <span class="red-line mt-10"></span></h4>\r\n                                                    <div class="right-btn">\r\n                                                        <button type="button" class="btn btn-wide btn-primary">\r\n                                                            <i class="fa fa-plus"></i> Create VPC Peering\r\n                                                        </button>\r\n                                                    </div>\r\n                                                </div>\r\n                                                <div class="panel-body">\r\n\r\n                                                </div>\r\n                                            </div>\r\n                                        </div>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>-->\r\n        </div>\r\n    </div>\r\n</div>\r\n</div>\r\n\r\n\r\n\r\n<footer data-ng-include=" \'app/components/copyright/copyright.html\' "></footer>\r\n\r\n\r\n\r\n\r\n\r\n');
$templateCache.put('app/entities/instance-dbh/instancesdbh.html','<div class="container-fluid container-fullw mlr-0">\r\n\t<div class="row">\r\n\t\t<div class="container-fluid container-fullw bg-white mlr-0">\r\n\t\t\t<div class="row">\r\n\t\t\t\t<div class="col-sm-12">\r\n\t\t\t\t\t<div class="f1-steps">\r\n\t\t\t\t\t\t<div class="f1-progress">\r\n\t\t\t\t\t\t\t<div class="f1-progress-line" data-now-value="16.5" data-number-of-steps="3" style="width: 16.5%;"></div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class="f1-step active">\r\n\t\t\t\t\t\t\t<div class="f1-step-icon"><i class="fa fa-cogs" aria-hidden="true"></i></div>\r\n\t\t\t\t\t\t\t<p>Configuring DBHawk</p>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class="f1-step">\r\n\t\t\t\t\t\t\t<div class="f1-step-icon"><i class="fa fa-cloud-upload" aria-hidden="true"></i></div>\r\n\t\t\t\t\t\t\t<p>Installing DBHawk</p>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class="f1-step">\r\n\t\t\t\t\t\t\t<div class="f1-step-icon"><i class="fa fa-code" aria-hidden="true"></i></div>\r\n\t\t\t\t\t\t\t<p>Setup DBHawk</p>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class="col-md-5 col-md-offset-4 ptb-40 mob_plr-0 ml-30 mob-mb-15" >\r\n\t\t\t\t\t\t<wizard on-finish="vm.finishedWizard()">\r\n\t\t\t\t\t\t\t<wz-step  canenter="!vm.disabledConfig">\r\n\t\t\t\t\t\t\t\t<div class="text-center pb-15">\r\n\t\t\t\t\t\t\t\t\t<h3>Configuring DBHawk</h3>\r\n\t\t\t\t\t\t\t\t\t<div class="red-divider" ></div>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div class="alert alert-danger" ng-show="vm.errorLaunch">\r\n\t\t\t\t\t\t\t\t\t<strong>Cannot create DBHawk application.</strong> Please contact support for details.\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div >\r\n\t\t\t\t\t\t\t\t\t<p></p>\r\n\t\t\t\t\t\t\t\t\t<p class="text-primary text-center">The next step is the configuration. If you do not know the values, please go with the default values.</p>\r\n\t\t\t\t\t\t\t\t\t<div class="col-md-10 col-md-offset-1">\r\n\t\t\t\t\t\t\t\t\t\t<form name="editForm" role="form" novalidate ng-submit="vm.save()">\r\n\r\n\t\t\t\t\t\t\t\t\t\t\t<div >\r\n\t\t\t\t\t\t\t\t\t\t\t\t<!--  <jhi-alert-error></jhi-alert-error>-->\r\n\r\n\r\n\r\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="control-label" for="field_cidrBlock">CIDR Block:</label>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<select class="form-control" id="field_cidrBlock" name="cidrBlock" ng-model="vm.instance.cidrBlock" ng-required="true" required>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<option value="172.10.0.0/16">172.10.0.0/16</option>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<option value="10.111.0.0/16">10.111.0.0/16</option>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t\t\t\t\t\t\t<div ng-show="editForm.cidrBlock.$dirty && editForm.cidrBlock.$invalid">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="help-block" style="color:red"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t   ng-show="editForm.cidrBlock.$error.required">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tCIDR Block is required. Example: 172.10.0.0/16\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\r\n\r\n\t\t\t\t\t\t\t\t\t\t\t\t<p class="text-info">When you create a VPC, you must specify a range IPv4 addresses for VPC in form of Classless Inter-Domain Routing (CIDR) block\r\n\t\t\t\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<br/>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="control-label" for="field_region">AWS Region:</label>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<select class="form-control" id="field_region" name="region" ng-model="vm.region" ng-options="data.label for data in vm.regions track by data.name">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</select>\r\n\r\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t\t\t\t\t\t\t<p class="text-info">Choose the region where your AWS databases and other resources are running</p>\r\n\r\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="form-group" ng-show="vm.instance.userIp">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="checkbox clip-check check-primary">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input type="checkbox" name="accessOnlyToUserIp" id="accessOnlyToUserIp"  checked\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   ng-model="vm.instance.accessOnlyToUserIp"/>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label for="accessOnlyToUserIp">Allow access only from my IP Address </label>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t\t\t\t\t\t\t<p class="text-info">Select to make private access to your instance from your IP address ({{vm.instance.userIp}}) </p>\r\n\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t\t<div >\r\n\t\t\t\t\t\t\t\t\t\t\t\t<button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary pull-right">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="glyphicon glyphicon-cloud"></span>&nbsp;<span>Create DBHawk Application</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t</form>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</wz-step>\r\n\r\n\t\t\t\t\t\t\t<wz-step>\r\n\t\t\t\t\t\t\t\t<div class="text-center pb-15">\r\n\t\t\t\t\t\t\t\t\t<h3>Installing DBHawk</h3>\r\n\t\t\t\t\t\t\t\t\t<div class="red-divider"></div>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<p></p>\r\n\t\t\t\t\t\t\t\t<uib-progressbar class="progress-striped active" animate="true" value="timer" max="max" type="info">\r\n\t\t\t\t\t\t\t\t\t  <span style="color:white; white-space:nowrap; margin: 10px;">\r\n\t\t\t\t\t\t\t\t\t\t{{vm.loadingMessage}}\r\n\t\t\t\t\t\t\t\t\t  </span>\r\n\t\t\t\t\t\t\t\t</uib-progressbar>\r\n\t\t\t\t\t\t\t\t<div class="custom-process-icon"></div>\r\n\t\t\t\t\t\t\t</wz-step>\r\n\r\n\t\t\t\t\t\t\t<wz-step>\r\n\t\t\t\t\t\t\t\t<div class="text-center pb-15">\r\n\t\t\t\t\t\t\t\t\t<h3>Setup DBHawk</h3>\r\n\t\t\t\t\t\t\t\t\t<div class="red-divider"></div>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<p></p>\r\n\t\t\t\t\t\t\t\t<uib-progressbar class="progress-striped active" animate="true" value="timer" max="max" type="info">\r\n\t\t\t\t\t\t\t\t\t  <span style="color:white; white-space:nowrap; margin: 10px;">\r\n\t\t\t\t\t\t\t\t\t\t{{vm.loadingMessage}}\r\n\t\t\t\t\t\t\t\t\t  </span>\r\n\t\t\t\t\t\t\t\t</uib-progressbar>\r\n\t\t\t\t\t\t\t\t<div class="custom-process-icon"></div>\r\n\t\t\t\t\t\t\t</wz-step>\r\n\r\n\t\t\t\t\t\t</wizard>\r\n\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n\r\n<footer data-ng-include=" \'app/components/copyright/copyright.html\' "></footer>\r\n\r\n\r\n\r\n');
$templateCache.put('app/entities/instance-dbh/invite.html','\r\n<form name="editForm" role="form" novalidate ng-submit="vm.invite()">\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myInstanceLabel">Invite</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_cidrBlock">Email</label>\r\n            <input type="email" class="form-control" name="cidrBlock" id="field_cidrBlock" required\r\n                   ng-model="vm.account.email"/>\r\n        </div>\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled=" (editForm.$invalid || vm.isSaving)" class="btn btn-primary">\r\n            <span class="glyphicon "></span>&nbsp;<span>Invite User</span>\r\n        </button>\r\n    </div>\r\n</form>\r\n');
$templateCache.put('app/entities/instance-dbh/inviteAdmin.html','\r\n<form name="editForm" role="form" novalidate ng-submit="vm.inviteAdmin()">\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myInstanceLabel">In order to continue Confirm Password</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n\r\n        <div class="alert alert-danger" ng-show="vm.error">\r\n            <strong>Registration failed!</strong> Check password or try again later.\r\n        </div>\r\n\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_cidrBlock">Password</label>\r\n            <input type="password" class="form-control" name="cidrBlock" id="field_cidrBlock" required\r\n                   ng-model="vm.account.password"/>\r\n        </div>\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled=" (editForm.$invalid || vm.isSaving)" class="btn btn-primary">\r\n            <span class="glyphicon "></span>&nbsp;<span>Confirm Password</span>\r\n        </button>\r\n    </div>\r\n</form>\r\n');
$templateCache.put('app/entities/instance-dbh/launch-loader.html','\r\n    <div class="modal-body">\r\n\r\n        <div style="background: url(\'https://cdn.dribbble.com/users/3968/screenshots/2240185/integrations-animated.gif\') no-repeat; height: 600px">Loading</div>\r\n\r\n    </div>\r\n');
$templateCache.put('app/entities/instance-dbh/verify.html','<div class="container-fluid container-fullw mlr-0">\r\n\t<div class="row">\r\n\t\t<div class="container-fluid container-fullw bg-white mlr-0">\r\n\t\t\t<div class="row">\r\n\t\t\t\t<div class="col-sm-12">\r\n\t\t\t\t\t<h2 class="text-center">Verify you account</h2>\r\n\t\t\t\t\t<div class="red-divider"></div>\r\n\t\t\t\t\t<h5 class="verify-title text-center">Please, check your email and enter the verification code:</h5>\r\n\t\t\t\t\t<div class="col-md-4 col-md-offset-4 pt-30">\r\n\t\t\t\t\t\t<div class="alert alert-danger" ng-show="vm.invalidCodeActivationError">\r\n\t\t\t\t\t\t\t<strong>Your account cannot not be verified.</strong> Please check the verification code below.\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class="alert alert-danger" ng-show="vm.expiredCodeActivationError">\r\n\t\t\t\t\t\t\t<strong>Your code has been expired.</strong> Please <a\r\n\t\t\t\t\t\t\tstyle="color: #fff!important; font-size: 14px!important; font-family: \'Ubuntu\', sans-serif!important; text-decoration: underline!important"\r\n\t\t\t\t\t\t\tclass="nav-link" ui-sref="contact">contact Datasparc</a> for assistance.\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<jhi-alert></jhi-alert>\r\n\r\n\t\t\t\t\t\t<form name="form" role="form" novalidate ng-submit="vm.confirmKeyDemo()" show-validation>\r\n\t\t\t\t\t\t\t<div class="form-group">\r\n                                    <label class="control-label" for="activationKey">Verification Code</label>\r\n\t\t\t\t\t\t\t\t<input type="text" class="form-control" id="activationKey" name="activationKey" placeholder="Enter Verification Code Here"\r\n\t\t\t\t\t\t\t\t\t\t   ng-model="vm.activationKey" ng-minlength=6 ng-maxlength=6  maxlength="6" ng-required="true" required>\r\n\t\t\t\t\t\t\t\t<div ng-show="form.activationKey.$dirty && form.activationKey.$invalid">\r\n\t\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t\t   ng-show="form.activationKey.$error.required">\r\n\t\t\t\t\t\t\t\t\t\tVerification Code is required.\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t\t<p class="help-block"\r\n\t\t\t\t\t\t\t\t\t   ng-show="form.activationKey.$error.minlength">\r\n\t\t\t\t\t\t\t\t\t\tYour Verification Code is required to be  6 character.\r\n\t\t\t\t\t\t\t\t\t</p>\r\n\t\t\t\t\t\t\t\t</div>\r\n                                <p align="center" class="text-info">Verification code is valid for 10 minutes.</p>\r\n\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t<!--\t<div class="form-group">\r\n\t\t\t\t\t\t\t   <label class="control-label">\r\n\t\t\t\t\t\t\t\t  Job Function:*\r\n\t\t\t\t\t\t\t   </label>\r\n\t\t\t\t\t\t\t\t\t<ui-select ng-model="vm.job.selected" class="custom-ui-select-style" theme="bootstrap"\r\n\t\t\t\t\t\t\t\t\t\t   required title="Choose a job function" ng-disabled="vm.disabled">\r\n\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="Please select">{{$select.selected.name}}</ui-select-match>\r\n\t\t\t\t\t\t\t\t\t<ui-select-choices repeat="job in vm.jobs" class="" >\r\n\t\t\t\t\t\t\t\t\t\t<span ng-bind="job.name"></span>\r\n\t\t\t\t\t\t\t\t\t</ui-select-choices>\r\n\t\t\t\t\t\t\t\t\t</ui-select>\r\n\t\t\t\t\t\t    </div>-->\r\n\r\n\t\t\t\t\t\t<!--<div class="form-group">\r\n\t\t\t\t\t\t\t   <label class="control-label">\r\n\t\t\t\t\t\t\t\t   Database *\r\n\t\t\t\t\t\t\t   </label>\r\n\t\t\t\t\t\t\t\t\t   <div\r\n\t\t\t\t\t\t\t\t\t\tisteven-multi-select\r\n\t\t\t\t\t\t\t\t\t\tinput-model="vm.dbs"\r\n\t\t\t\t\t\t\t\t\t\toutput-model="vm.multipledb.selectedDbs"\r\n\t\t\t\t\t\t\t\t\t\tbutton-label="name"\r\n\t\t\t\t\t\t\t\t\t\titem-label="name case"\r\n\t\t\t\t\t\t\t\t\t\ttick-property="ticked"\r\n\t\t\t\t\t\t\t\t\t\ton-open="fOpen()"\r\n\t\t\t\t\t\t\t\t\t\ton-close="fClose()"\r\n\t\t\t\t\t\t\t\t\t\ton-item-click="fClick( data )"\r\n\t\t\t\t\t\t\t\t\t\tng-disabled = "false"\r\n\t\t\t\t\t\t\t\t\t></div>\r\n\t\t\t\t\t\t\t\t\t<input type="text" ng-model="vm.multipledb.selectedDbs" name="database" style="display:none" required />\r\n\t\t\t\t\t\t   </div>-->\r\n\r\n\t\t\t\t\t\t\t<button class="btn btn-primary btn-next pull-right" ng-disabled="form.$invalid" type="submit">\r\n\t\t\t\t\t\t\t\t<i class="fa fa-shield" aria-hidden="true"></i>\r\n\t\t\t\t\t\t\t\t<span >\r\n\t\t\t\t\t\t\t\t\t\t\t\tVerify and Continue\r\n\t\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t<!--  <input type="submit"  value="Continue" />-->\r\n\t\t\t\t\t</form>\r\n\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n\r\n<footer data-ng-include=" \'app/components/copyright/copyright.html\' "></footer>\r\n');
$templateCache.put('app/entities/region/region-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.region.id)">\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title">Confirm delete operation</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <p>Are you sure you want to delete this Region?</p>\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger">\r\n            <span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span>\r\n        </button>\r\n    </div>\r\n</form>\r\n');
$templateCache.put('app/entities/region/region-detail.html','\r\n<div>\r\n    <h2><span>Region</span> {{vm.region.id}}</h2>\r\n    <hr>\r\n    <jhi-alert-error></jhi-alert-error>\r\n    <dl class="dl-horizontal jh-entity-details">\r\n        <dt><span>Name</span></dt>\r\n        <dd>\r\n            <span>{{vm.region.name}}</span>\r\n        </dd>\r\n        <dt><span>Label</span></dt>\r\n        <dd>\r\n            <span>{{vm.region.label}}</span>\r\n        </dd>\r\n        <dt><span>Ami</span></dt>\r\n        <dd>\r\n            <span>{{vm.region.ami}}</span>\r\n        </dd>\r\n        <dt><span>Order Pos</span></dt>\r\n        <dd>\r\n            <span>{{vm.region.orderPos}}</span>\r\n        </dd>\r\n    </dl>\r\n\r\n    <button type="submit"\r\n            ui-sref="{{ vm.previousState }}"\r\n            class="btn btn-info">\r\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span>\r\n    </button>\r\n\r\n    <button type="button" ui-sref="region-detail.edit({id:vm.region.id})" class="btn btn-primary">\r\n        <span class="glyphicon glyphicon-pencil"></span>\r\n        <span class="hidden-sm-down"> Edit</span>\r\n    </button>\r\n</div>\r\n');
$templateCache.put('app/entities/region/region-dialog.html','\r\n<form name="editForm" role="form" novalidate ng-submit="vm.save()">\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myRegionLabel">Create or edit a Region</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <div class="form-group" ng-show="vm.region.id">\r\n            <label for="id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="vm.region.id" readonly />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_name">Name</label>\r\n            <input type="text" class="form-control" name="name" id="field_name"\r\n                    ng-model="vm.region.name"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_label">Label</label>\r\n            <input type="text" class="form-control" name="label" id="field_label"\r\n                    ng-model="vm.region.label"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_ami">Ami</label>\r\n            <input type="text" class="form-control" name="ami" id="field_ami"\r\n                    ng-model="vm.region.ami"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_orderPos">Order Pos</label>\r\n            <input type="number" class="form-control" name="orderPos" id="field_orderPos"\r\n                    ng-model="vm.region.orderPos"\r\n                    />\r\n        </div>\r\n\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>\r\n        </button>\r\n    </div>\r\n</form>\r\n');
$templateCache.put('app/entities/region/regions.html','<div>\r\n    <h2>Regions</h2>\r\n    <jhi-alert></jhi-alert>\r\n    <div class="container-fluid">\r\n        <div class="row">\r\n            <div class="col-xs-4 no-padding-left">\r\n                <button class="btn btn-primary" ui-sref="region.new" >\r\n                    <span class="glyphicon glyphicon-plus"></span>\r\n                    <span >\r\n                        Create new Region\r\n                    </span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <br/>\r\n    <div class="table-responsive">\r\n        <table class="jh-table table table-striped">\r\n            <thead>\r\n                <tr>\r\n                    <th><span>ID</span></th>\r\n                    <th><span>Name</span></th>\r\n                    <th><span>Label</span></th>\r\n                    <th><span>Ami</span></th>\r\n                    <th><span>Order Pos</span></th>\r\n                    <th></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-repeat="region in vm.regions track by region.id">\r\n                    <td><a ui-sref="region-detail({id:region.id})">{{region.id}}</a></td>\r\n                    <td>{{region.name}}</td>\r\n                    <td>{{region.label}}</td>\r\n                    <td>{{region.ami}}</td>\r\n                    <td>{{region.orderPos}}</td>\r\n                    <td class="text-right">\r\n                        <div class="btn-group flex-btn-group-container">\r\n                            <button type="submit"\r\n                                    ui-sref="region-detail({id:region.id})"\r\n                                    class="btn btn-info btn-sm">\r\n                                <span class="glyphicon glyphicon-eye-open"></span>\r\n                                <span class="hidden-sm-down"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="region.edit({id:region.id})"\r\n                                    class="btn btn-primary btn-sm">\r\n                                <span class="glyphicon glyphicon-pencil"></span>\r\n                                <span class="hidden-sm-down"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="region.delete({id:region.id})"\r\n                                    class="btn btn-danger btn-sm">\r\n                                <span class="glyphicon glyphicon-remove-circle"></span>\r\n                                <span class="hidden-sm-down"></span>\r\n                            </button>\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('app/entities/peering/peering-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.peering.peeringId)">\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title">Confirm delete operation</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <p>Are you sure you want to delete this Peering?</p>\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger">\r\n            <span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span>\r\n        </button>\r\n    </div>\r\n</form>\r\n');
$templateCache.put('app/entities/peering/peering-detail.html','\r\n<div>\r\n    <h2><span>Peering</span> {{vm.peering.id}}</h2>\r\n    <hr>\r\n    <jhi-alert-error></jhi-alert-error>\r\n    <dl class="dl-horizontal jh-entity-details">\r\n        <dt><span>Aws Account</span></dt>\r\n        <dd>\r\n            <span>{{vm.peering.awsAccount}}</span>\r\n        </dd>\r\n        <dt><span>Peer Vpc</span></dt>\r\n        <dd>\r\n            <span>{{vm.peering.peerVpc}}</span>\r\n        </dd>\r\n        <dt><span>Peer Region</span></dt>\r\n        <dd>\r\n            <span>{{vm.peering.peerRegion}}</span>\r\n        </dd>\r\n        <dt><span>Active</span></dt>\r\n        <dd>\r\n            <span>{{vm.peering.active}}</span>\r\n        </dd>\r\n        <dt><span>Created</span></dt>\r\n        <dd>\r\n            <span>{{vm.peering.created | date:\'medium\'}}</span>\r\n        </dd>\r\n        <dt><span>Status</span></dt>\r\n        <dd>\r\n            <span>{{vm.peering.status}}</span>\r\n        </dd>\r\n        <dt><span>Peering Id</span></dt>\r\n        <dd>\r\n            <span>{{vm.peering.peeringId}}</span>\r\n        </dd>\r\n        <dt><span>Vpc</span></dt>\r\n        <dd>\r\n            <a ui-sref="vpc-dbh-detail({id:vm.peering.vpcId})">{{vm.peering.vpcId}}</a>\r\n        </dd>\r\n    </dl>\r\n\r\n    <button type="submit"\r\n            ui-sref="{{ vm.previousState }}"\r\n            class="btn btn-info">\r\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span>\r\n    </button>\r\n\r\n    <button type="button" ui-sref="peering-detail.edit({id:vm.peering.id})" class="btn btn-primary">\r\n        <span class="glyphicon glyphicon-pencil"></span>\r\n        <span class="hidden-sm-down"> Edit</span>\r\n    </button>\r\n</div>\r\n');
$templateCache.put('app/entities/peering/peering-dialog.html','\r\n<form name="form" role="form" novalidate ng-submit="vm.save()" show-validation>\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="myPeeringLabel">Create a Peering</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <div class="alert alert-danger" ng-show="vm.error">\r\n            <strong>Peering failed!</strong> Check input values and try again.\r\n        </div>\r\n\r\n        <div class="form-group">\r\n            <label class="control-label" for="awsAccount">Aws Account</label>\r\n            <input type="text" class="form-control" name="awsAccount" id="awsAccount"\r\n                    ng-model="vm.peering.awsAccount" placeholder="8888888888888" ng-minlength=5 required\r\n                    />\r\n            <div ng-show="form.awsAccount.$dirty && form.awsAccount.$invalid">\r\n                <p class="help-block"\r\n                   ng-show="form.awsAccount.$error.required">\r\n                    Aws Account is required.\r\n                </p>\r\n                <p class="help-block"\r\n                   ng-show="form.awsAccount.$error.minlength">\r\n                    Aws Account is required to be at least 5 characters.\r\n                </p>\r\n            </div>\r\n        </div>\r\n\r\n        <div class="form-group">\r\n            <label class="control-label" for="peerVpc">Peer Vpc</label>\r\n            <input type="text" class="form-control" name="peerVpc" id="peerVpc"\r\n                    ng-model="vm.peering.peerVpc" placeholder="vpc-00000000" ng-minlength=5 required\r\n                    />\r\n            <div ng-show="form.peerVpc.$dirty && form.peerVpc.$invalid">\r\n                <p class="help-block"\r\n                   ng-show="form.peerVpc.$error.required">\r\n                    VPC is required.\r\n                </p>\r\n                <p class="help-block"\r\n                   ng-show="form.peerVpc.$error.minlength">\r\n                    VPC is required to be at least 5 characters.\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="cidr">Peer VPC CIDR Block</label>\r\n            <input type="text" class="form-control" name="cidr" id="cidr"\r\n                   ng-model="vm.peering.cidr" placeholder="172.30.0.0/16" ng-minlength=5 required\r\n            />\r\n            <div ng-show="form.cidr.$dirty && form.cidr.$invalid">\r\n                <p class="help-block"\r\n                   ng-show="form.cidr.$error.required">\r\n                    CIDR is required.\r\n                </p>\r\n                <p class="help-block"\r\n                   ng-show="form.cidr.$error.minlength">\r\n                    CIDR is required to be at least 5 characters.\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <!--<div class="form-group">\r\n            <label class="control-label" for="region">AWS Region:</label>\r\n            <select class="form-control" id="region" name="region"\r\n                    ng-model="vm.peering.region"\r\n                    ng-options="data.label for data in vm.regions track by data.name">\r\n            </select>\r\n        </div>-->\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="form.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>\r\n        </button>\r\n    </div>\r\n</form>\r\n');
$templateCache.put('app/entities/subscription-dbh/invoices.html','<h5>Invoices</h5>\r\n<table class="jh-table table table-striped"  >\r\n    <thead>\r\n    <tr >\r\n        <th ><span>Date</span></th>\r\n\r\n        <th ><span>Amount Due</span></th>\r\n\r\n        <th ><span>Paid</span></th>\r\n\r\n        <th ><span>Usage Start Period</span></th>\r\n\r\n        <th ><span>Invoice URL</span></th>\r\n    </tr>\r\n    </thead>\r\n    <tbody >\r\n\r\n    <tr ng-repeat="invoice in subscriptionDbh.invoices" style="text-align: center">\r\n        <td>{{invoice.date | date:\'medium\'}}</td>\r\n\r\n        <td> USD {{invoice.amountDue | number:2 }}</td>\r\n        <td>{{invoice.paid==true?\'Yes\':\'No\'}}</td>\r\n\r\n        <td>{{invoice.startDate | date:\'medium\'}}</td>\r\n\r\n        <td> <a href="" ng-click="vm.redirectToApp(invoice.url)">Open Invoice</a></td>\r\n    </tr>\r\n\r\n    </tbody>\r\n\r\n</table>\r\n');
$templateCache.put('app/entities/subscription-dbh/subscription-dbh-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.subscriptionDbh.uuid)">\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title">Confirm cancel operation</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <p>Are you sure you want to cancel this Subscription? It will be cancelled at the end of the current billing period</p>\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>No</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger">\r\n            <span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Cancel Subscription</span>\r\n        </button>\r\n    </div>\r\n</form>\r\n');
$templateCache.put('app/entities/subscription-dbh/subscription-dbh-detail.html','\r\n<div>\r\n    <h2><span>Subscription Dbh</span> {{vm.subscriptionDbh.id}}</h2>\r\n    <hr>\r\n    <jhi-alert-error></jhi-alert-error>\r\n    <dl class="dl-horizontal jh-entity-details">\r\n        <dt><span>Uuid</span></dt>\r\n        <dd>\r\n            <span>{{vm.subscriptionDbh.uuid}}</span>\r\n        </dd>\r\n        <dt><span>Instance Id</span></dt>\r\n        <dd>\r\n            <span>{{vm.subscriptionDbh.instanceId}}</span>\r\n        </dd>\r\n        <dt><span>Amount</span></dt>\r\n        <dd>\r\n            <span>{{vm.subscriptionDbh.amount}}</span>\r\n        </dd>\r\n        <dt><span>User Id</span></dt>\r\n        <dd>\r\n            <span>{{vm.subscriptionDbh.userId}}</span>\r\n        </dd>\r\n        <dt><span>Created</span></dt>\r\n        <dd>\r\n            <span>{{vm.subscriptionDbh.created | date:\'medium\'}}</span>\r\n        </dd>\r\n    </dl>\r\n\r\n    <button type="submit"\r\n            ui-sref="{{ vm.previousState }}"\r\n            class="btn btn-info">\r\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span>\r\n    </button>\r\n\r\n    <button type="button" ui-sref="subscription-dbh-detail.edit({id:vm.subscriptionDbh.id})" class="btn btn-primary">\r\n        <span class="glyphicon glyphicon-pencil"></span>\r\n        <span class="hidden-sm-down"> Edit</span>\r\n    </button>\r\n</div>\r\n');
$templateCache.put('app/entities/subscription-dbh/subscription-dbh-dialog.html','\r\n<form name="editForm" role="form" novalidate ng-submit="vm.save()">\r\n\r\n    <div class="modal-header">\r\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\r\n                ng-click="vm.clear()">&times;</button>\r\n        <h4 class="modal-title" id="mySubscriptionDbhLabel">Create or edit a Subscription Dbh</h4>\r\n    </div>\r\n    <div class="modal-body">\r\n        <jhi-alert-error></jhi-alert-error>\r\n        <div class="form-group" ng-show="vm.subscriptionDbh.id">\r\n            <label for="id">ID</label>\r\n            <input type="text" class="form-control" id="id" name="id"\r\n                    ng-model="vm.subscriptionDbh.id" readonly />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_uuid">Uuid</label>\r\n            <input type="text" class="form-control" name="uuid" id="field_uuid"\r\n                    ng-model="vm.subscriptionDbh.uuid"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_instanceId">Instance Id</label>\r\n            <input type="text" class="form-control" name="instanceId" id="field_instanceId"\r\n                    ng-model="vm.subscriptionDbh.instanceId"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_amount">Amount</label>\r\n            <input type="number" class="form-control" name="amount" id="field_amount"\r\n                    ng-model="vm.subscriptionDbh.amount"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_userId">User Id</label>\r\n            <input type="number" class="form-control" name="userId" id="field_userId"\r\n                    ng-model="vm.subscriptionDbh.userId"\r\n                    />\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="control-label" for="field_created">Created</label>\r\n                <div class="input-group">\r\n                    <input id="field_created" type="text" class="form-control" name="created" datetime-picker="{{dateformat}}" ng-model="vm.subscriptionDbh.created" is-open="vm.datePickerOpenStatus.created"\r\n                    />\r\n                    <span class="input-group-btn">\r\n                        <button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'created\')"><i class="glyphicon glyphicon-calendar"></i></button>\r\n                    </span>\r\n                </div>\r\n        </div>\r\n\r\n    </div>\r\n    <div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>\r\n        </button>\r\n        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\r\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>\r\n        </button>\r\n    </div>\r\n</form>\r\n');
$templateCache.put('app/entities/subscription-dbh/subscription-dbhs.html','<div id="inner_table_container">\r\n    <div class="row">\r\n        <h2>Subscriptions</h2>\r\n        <div class="red-divider" style="margin: 0" ></div>\r\n        <jhi-alert></jhi-alert>\r\n        <div class="container-fluid p-t-30">\r\n            <div class="row">\r\n            </div>\r\n        </div>\r\n        <br/>\r\n        <div class="table-responsive">\r\n            <table  ng-table="tableParams" class="jh-table table table-striped">\r\n                <tbody ng-switch on="vm.isSelected(subscriptionDbh)" ng-repeat="subscriptionDbh in vm.subscriptionDbhs track by subscriptionDbh.uuid">\r\n                <tr >\r\n                    <td ng-click="vm.toggleRow(subscriptionDbh)"><span ng-show="!vm.isSelected(subscriptionDbh)"\r\n                                                                       class="glyphicon glyphicon-chevron-right"></span> <span\r\n                        ng-show="vm.isSelected(subscriptionDbh)" class="glyphicon glyphicon-chevron-down"></span></td>\r\n                    <td data-title="\'ID\'" class="text-center" class="text-center" sortable="\'uuid\'">{{subscriptionDbh.uuid}}</td>\r\n                    <td data-title="\'DHawk Id\'" class="text-center" class="text-center" sortable="\'instanceId\'">{{subscriptionDbh.instanceId}}</td>\r\n                    <td data-title="\'Users\'" class="text-center" class="text-center" sortable="\'amount\'">{{subscriptionDbh.amount}}</td>\r\n                    <td data-title="\'Created\'"  class="text-center" header-class="\'text-center\'" sortable="\'created\'">{{subscriptionDbh.created| date:\'medium\'}}</td>\r\n                    <td data-title="\'Status\'" class="text-center" header-class="\'text-center\'" sortable="\'active\'">{{subscriptionDbh.active==true?\'Active\':\'Cancel Requested\'}}</td>\r\n                    <td  class="text-center">\r\n\r\n                        <button type="submit" ng-if="subscriptionDbh.active == true"\r\n                                ui-sref="subscription-dbh.delete({id:subscriptionDbh.uuid})"\r\n                                class="btn btn-danger btn-sm">\r\n                            <span class="glyphicon glyphicon-remove-circle"></span>\r\n                            <span class="hidden-sm-down">Cancel</span>\r\n                        </button>\r\n                    </td>\r\n\r\n                </tr>\r\n                <tr ng-switch-when="true">\r\n                    <td colspan="6">\r\n                        <div ng-include="\'app/entities/subscription-dbh/invoices.html\'"></div>\r\n                    </td>\r\n                </tr>\r\n                </tbody>\r\n            </table>\r\n        </div>\r\n    </div>\r\n    <!-- start: COPYRIGHT -->\r\n    <div ng-include="\'app/components/copyright/copyright.html\'"></div>\r\n    <!-- end: COPYRIGHT -->\r\n</div>\r\n');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak>\r\n    <div class="row">\r\n        <div class="col-md-4">\r\n            <span class=" img-responsive img-rounded"></span>\r\n        </div>\r\n        <div class="col-md-8">\r\n            <h1>Error Page!</h1>\r\n\r\n            <div class="alert alert-danger">You are not authorized to access this page.\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak>\r\n    <div class="row">\r\n        <div class="col-md-4">\r\n          <!--  <span class="hipster img-responsive img-rounded"></span>-->\r\n        </div>\r\n        <div class="col-md-8">\r\n            <h1>Error Page!</h1>\r\n\r\n            <div ng-show="errorMessage">\r\n                <div class="alert alert-danger">{{errorMessage}}\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('app/layouts/navbar/navbar.html','<header class="navbar navbar-static-top" ng-class="{\'dbh-header\':vm.isAuthenticated()}">\r\n    <div class="header-content">\r\n        <div class="navbar-header" ng-if="vm.isAuthenticated()">\r\n\r\n            <a class="navbar-brand " ui-sref="home">\r\n                <img src="content/images/db_hawk-logo.png" alt="Logo"/>\r\n            </a>\r\n            <a href="javascript:;" class="pull-right menu-toggler visible-xs-block" id="menu-toggler"\r\n               ng-click="vm.toggleNavbar()">\r\n                <span class="sr-only">Toggle navigation</span>\r\n                <i class="ti-view-grid"></i>\r\n            </a>\r\n        </div>\r\n\r\n        <toaster-container\r\n            toaster-options="{\'position-class\': \'toast-top-right\', \'time-out\': 3000, \'close-button\':true}"></toaster-container>\r\n        <div class="navbar-collapse collapse" uib-collapse="vm.isNavbarCollapsed" ng-init="vm.isNavbarCollapsed"\r\n             off-click="vm.isNavbarCollapsed" off-click-if=\'!vm.isNavbarCollapsed\' off-click-filter="#menu-toggler"\r\n             ng-if="vm.isAuthenticated()">\r\n\r\n            <!--<div class="company-name"><span class="">{{vm.companyName}}</span></div>-->\r\n            <ul class="nav navbar-right" ct-fullheight="window" data-ct-fullheight-exclusion="header"\r\n                data-ct-fullheight-if="isSmallDevice">\r\n                <li class="dropdown" ng-class="{\'open\':vm.$state.includes(\'home\')}">\r\n                    <a ui-sref="home" class="" ng-click="vm.isNavbarCollapsed=true">\r\n                        <i class="ti-home"></i> Home\r\n                    </a>\r\n                </li>\r\n                <li class="dropdown" ng-class="{\'open\':vm.$state.includes(\'contact\')}">\r\n                    <a ui-sref="contact" class="" ng-click="vm.isNavbarCollapsed=true">\r\n                        <i class="ti-email"></i> Contact\r\n                    </a>\r\n                </li>\r\n                <li class="dropdown" ng-class="{\'open\':vm.$state.includes(\'documentation\')}">\r\n                    <a ui-sref="documentation" class="" ng-click="vm.isNavbarCollapsed=true">\r\n                        <i class="ti-help-alt"></i> Documentation\r\n                    </a>\r\n                </li>\r\n                <li class="dropdown" dropdown uib-dropdown on-toggle="toggled(open)">\r\n                    <a href class="dropdown-toggle" dropdown-toggle uib-dropdown-toggle ng-mouseover="isOver=true"\r\n                       ng-mouseleave="isOver=false" ng-click="isOver=false">\r\n                        <i class="ti-user"></i>{{vm.userEmail}}\r\n                    </a>\r\n                    <span class="profile-name fadeInUpShort">{{vm.userEmail}}</span>\r\n                    <ul class="dropdown-menu dropdown-light fadeInUpShort" uib-dropdown-menu>\r\n                        <!--<li>\r\n                            <a ui-sref="my-profile" ng-click="vm.isNavbarCollapsed=true">\r\n                                <i class="ti-user"></i> My Profile\r\n                            </a>\r\n                        </li>-->\r\n                        <li>\r\n                            <a ui-sref="password" ng-click="vm.isNavbarCollapsed=true">\r\n                                <i class="ti-lock"></i> Password\r\n                            </a>\r\n                        </li>\r\n                        <li>\r\n                            <a ng-click="vm.logout()" ui-sref="login.signin">\r\n                                <i class="fa fa-sign-out" aria-hidden="true"></i> Sign Out\r\n                            </a>\r\n                        </li>\r\n                    </ul>\r\n                </li>\r\n                <!-- Admin Menu -->\r\n                <li dropdown has-authority="ROLE_ADMIN" uib-dropdown class="dropdown">\r\n                    <!-- <a class="nav-link dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu">\r\n                                      <span>\r\n                                          <span class="glyphicon glyphicon-tower"></span>\r\n                                          <span class="hidden-sm">Administration</span>\r\n                                          <b class="caret"></b>\r\n                                      </span>\r\n                     </a>-->\r\n                    <a href class="dropdown-toggle" dropdown-toggle uib-dropdown-toggle ng-mouseover="isOver=true"\r\n                       ng-mouseleave="isOver=false" ng-click="isOver=false">\r\n                        <i class="glyphicon glyphicon-tower"></i>Administration\r\n                    </a>\r\n                    <ul class="dropdown-menu" uib-dropdown-menu>\r\n                        <li ui-sref-active="active">\r\n                            <a ui-sref="instance-management" ng-click="vm.collapseNavbar()">\r\n                                <span class="glyphicon glyphicon-user"></span>&nbsp;\r\n                                <span>Instances</span>\r\n                            </a>\r\n                        </li>\r\n                        <li ui-sref-active="active">\r\n                            <a ui-sref="email-list" ng-click="vm.collapseNavbar()">\r\n                                <span class="glyphicon glyphicon-user"></span>&nbsp;\r\n                                <span>Email List</span>\r\n                            </a>\r\n                        </li>\r\n                        <li ui-sref-active="active">\r\n                            <a ui-sref="user-management" ng-click="vm.collapseNavbar()">\r\n                                <span class="glyphicon glyphicon-user"></span>&nbsp;\r\n                                <span>User management</span>\r\n                            </a>\r\n                        </li>\r\n                        <li ui-sref-active="active">\r\n                            <a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()">\r\n                                <span class="glyphicon glyphicon-dashboard"></span>&nbsp;\r\n                                <span>Metrics</span>\r\n                            </a>\r\n                        </li>\r\n                        <li ui-sref-active="active">\r\n                            <a ui-sref="jhi-health" ng-click="vm.collapseNavbar()">\r\n                                <span class="glyphicon glyphicon-heart"></span>&nbsp;\r\n                                <span>Health</span>\r\n                            </a>\r\n                        </li>\r\n                        <li ui-sref-active="active">\r\n                            <a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()">\r\n                                <span class="glyphicon glyphicon-list-alt"></span>&nbsp;\r\n                                <span>Configuration</span>\r\n                            </a>\r\n                        </li>\r\n                        <li ui-sref-active="active">\r\n                            <a ui-sref="audits" ng-click="vm.collapseNavbar()">\r\n                                <span class="glyphicon glyphicon-bell"></span>&nbsp;\r\n                                <span>Audits</span>\r\n                            </a>\r\n                        </li>\r\n                        <li ui-sref-active="active">\r\n                            <a ui-sref="logs" ng-click="vm.collapseNavbar()">\r\n                                <span class="glyphicon glyphicon-tasks"></span>&nbsp;\r\n                                <span>Logs</span>\r\n                            </a>\r\n                        </li>\r\n                        <li ng-show="vm.swaggerEnabled" ui-sref-active="active">\r\n                            <a ui-sref="docs" ng-click="vm.collapseNavbar()">\r\n                                <span class="glyphicon glyphicon-book"></span>&nbsp;\r\n                                <span>API</span>\r\n                            </a>\r\n                        </li>\r\n                        <!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here -->\r\n                    </ul>\r\n                </li>\r\n\r\n\r\n            </ul>\r\n            <!--<div class="user-info" ng-show="isOver">\r\n                <h5>{{vm.userEmail}}</h5>\r\n            </div>-->\r\n            <div class="close-handle visible-xs-block menu-toggler" ng-click="vm.isNavbarCollapsed=true">\r\n                <div class="arrow-left"></div>\r\n                <div class="arrow-right"></div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</header>\r\n');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div>\r\n    <div class="row">\r\n        <div class="col-md-4 col-md-offset-4">\r\n            <h1>Reset Password</h1>\r\n\r\n            <div class="alert alert-danger" ng-show="vm.keyMissing">\r\n                <strong>The password reset key is missing.</strong>\r\n            </div>\r\n\r\n            <div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing">\r\n                <p>Choose a new password</p>\r\n            </div>\r\n\r\n            <div class="alert alert-danger" ng-show="vm.error">\r\n                <p>Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p>\r\n            </div>\r\n\r\n            <div class="alert alert-danger" ng-show="vm.passwordValidationError">\r\n                <p>User email is not allowed in password.</p>\r\n            </div>\r\n\r\n            <div class="alert alert-success" ng-show="vm.success">\r\n                <p><strong>Your password has been reset.</strong> Please <strong><a  href="/cloud/#/signin" ng-click="vm.login()">Sign in</a></strong>.</p>\r\n            </div>\r\n\r\n\r\n\r\n            <div class="alert alert-danger" ng-show="vm.doNotMatch">\r\n                The password and its confirmation do not match!\r\n            </div>\r\n\r\n            <div ng-hide="vm.keyMissing">\r\n                <form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation>\r\n                    <div class="form-group">\r\n                        <label class="control-label" for="password">New password</label>\r\n                        <input type="password" class="form-control" id="password" name="password" placeholder="New password"\r\n                               ng-model="vm.resetAccount.password" ng-minlength=8 ng-maxlength=50 required ng-pattern="vm.getPasswordPattern()">\r\n                        <div ng-show="form.password.$dirty && form.password.$invalid">\r\n                            <p class="help-block"\r\n                               ng-show="form.password.$error.required">\r\n                                Your password is required.\r\n                            </p>\r\n                            <p class="help-block"\r\n                               ng-show="form.password.$error">\r\n                                Your password is required to be at least 8 characters, one uppercase letter,\r\n                                one lowercase letter and one number. Prevents email from appearing in the password.\r\n                            </p>\r\n                            <p class="help-block"\r\n                               ng-show="form.password.$error.maxlength">\r\n                                Your password cannot be longer than 50 characters.\r\n                            </p>\r\n                        </div>\r\n                        <password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar>\r\n                    </div>\r\n\r\n                    <div class="form-group">\r\n                        <label class="control-label" for="confirmPassword">New password confirmation</label>\r\n                        <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password"\r\n                               ng-model="vm.confirmPassword" ng-minlength=8 ng-maxlength=50 required>\r\n                        <div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid">\r\n                            <p class="help-block"\r\n                               ng-show="form.confirmPassword.$error.required">\r\n                                Your password confirmation is required.\r\n                            </p>\r\n                            <p class="help-block"\r\n                               ng-show="form.confirmPassword.$error.minlength">\r\n                                Your password confirmation is required to be at least 4 characters.\r\n                            </p>\r\n                            <p class="help-block"\r\n                               ng-show="form.confirmPassword.$error.maxlength">\r\n                                Your password confirmation cannot be longer than 50 characters.\r\n                            </p>\r\n                        </div>\r\n                    </div>\r\n                    <button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset Password</button>\r\n                </form>\r\n            </div>\r\n\r\n        </div>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('app/account/reset/request/reset.request.html','<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">\r\n<!-- start: FORGOT -->\r\n<div class="dbh-conteiner">\r\n    <div class="">\r\n        <div class="row justify-content-center dbh-mobie-logo-wrap"><a href="https://www.datasparc.com/"> <img src="content/images/datasparc-logo.png" class="logo"></a> </div>\r\n\r\n        <div class="row d-flex flex-row-reverse">\r\n            <div class="col-lg-7 dbh-image-block">\r\n                <div class="row justify-content-center dbh-image-wrap"> <img src="content/images/Home-Illustration OPTION-1.png" class="image"> </div>\r\n            </div>\r\n            <div class="col-lg-5 dbh-pr-5">\r\n                <div class="pb-5">\r\n                    <div class="row dbh-logo-wrap"><a href="https://www.datasparc.com/"> <img src="content/images/datasparc-logo.png" class="logo"></a> </div>\r\n                </div>\r\n                <div class="card py-4 dbh-form-wrap">\r\n                    <div class="mb-4 px-3 dbh-form-title">\r\n                        <h1 class="mb-0 mt-2">Forgot Password?</h1>\r\n                    </div>\r\n                    <div class="alert alert-success" ng-show="vm.success === \'OK\'">\r\n                        <p>An email is on its way to you. Follow the instructions to reset your password.</p>\r\n                    </div>\r\n                    <div class="alert alert-danger" ng-show="vm.errorEmailNotExists">\r\n                        <p>We could not find your email. Try another?</p>\r\n                    </div>\r\n                    <form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation>\r\n                        <div class="row px-3 mb-4"> <label class="mb-1">\r\n                                <h6 class="mb-0 dbh-forgot-pas-label">Enter your email address below and we\'ll send you a link to reset your password.</h6>\r\n                            </label> <input class="dbh-input" type="email" name="email" ng-model="vm.resetAccount.email" ng-minlength=5 ng-maxlength=100 required placeholder="Email">\r\n                            <div ng-show="form.email.$dirty && form.email.$invalid">\r\n                                <p class="help-block"\r\n                                   ng-show="form.email.$error.required">\r\n                                    Your email is required.\r\n                                </p>\r\n                                <p class="help-block"\r\n                                   ng-show="form.email.$error.email">\r\n                                    Your email is invalid.\r\n                                </p>\r\n                                <p class="help-block"\r\n                                   ng-show="form.email.$error.minlength">\r\n                                    Your email is required to be at least 5 characters.\r\n                                </p>\r\n                                <p class="help-block"\r\n                                   ng-show="form.email.$error.maxlength">\r\n                                    Your email cannot be longer than 100 characters.\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n                        <div class="d-flex mb-5 mt-4 justify-content-between">\r\n                            <a ui-sref="signin" class="dbh-button reset-login-btn register-anm">Sign In</a>\r\n                            <button type="submit" ng-disabled="form.$invalid" class="dbh-button reset-btn register-anm">Reset</button>\r\n                        </div>\r\n\r\n                        <div class="row my-4 px-3 justify-content-center flex-column">\r\n                            <div class="copyright">\r\n                                Copyright <a href="https://www.datasparc.com/" target="_blank">Datasparc Inc</a>. All rights reserved\r\n                                | <a href="https://www.datasparc.com/terms-of-use/" target="_blank">Terms of Use</a> |\r\n                                <a href="https://www.datasparc.com/privacy-policy/" target="_blank">Privacy Policy</a>\r\n                            </div>\r\n                            <div class="app-version">Version: 2.0.0</div>\r\n                        </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class="dbh-footer mt-5">\r\n            <div class="row d-flex">\r\n                <div class="col-lg-4 d-flex dbh-pr-5">\r\n                    <div class="dbh-f-image-wrap">\r\n                        <img src="content/images/trazado-271.png" class="">\r\n                    </div>\r\n                    <div class="dbh-f-block pl-3">\r\n                        <p class="dbh-f-title">DBHawk - All In One Solution</p>\r\n                        <p class="dbh-f-desc">Data Security, Database management, Data governance and data analytics</p>\r\n                    </div>\r\n                </div>\r\n                <div class="col-lg-4 d-flex dbh-pr-5">\r\n                    <div class="dbh-f-image-wrap">\r\n                        <img src="content/images/trazado-288.png" class="">\r\n                    </div>\r\n                    <div class="dbh-f-block pl-3">\r\n                        <p class="dbh-f-title">Zero Trust Data Access</p>\r\n                        <p class="dbh-f-desc">Users only receive access to the data they need without exposing database username and password.</p>\r\n                    </div>\r\n                </div>\r\n                <div class="col-lg-4 d-flex dbh-pr-5">\r\n                    <div class="dbh-f-image-wrap">\r\n                        <img src="content/images/trazado-300.png" class="">\r\n                    </div>\r\n                    <div class="dbh-f-block pl-3">\r\n                        <p class="dbh-f-title">Hybrid Tool for All Databases</p>\r\n                        <p class="dbh-f-desc">DBHawk provides secure access to on-premise and cloud databases. DBHawk supports a wide array of SQL and NoSQL databases.</p>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <!-- end: FORGOT BOX -->\r\n    </div>\r\n</div>\r\n<!-- end: FORGOT -->\r\n\r\n');
$templateCache.put('app/account/social/directive/social.html','<form action="{{ providerURL }}" method="POST">\r\n    <button type="submit" class="btn btn-block jh-btn-social jh-btn-{{ provider }}">\r\n        <span>Sign in with {{ label }}</span>\r\n    </button>\r\n    <input name="scope" type="hidden" value="{{\xA0providerSetting }}"/>\r\n    <input name="_csrf" type="hidden" value="{{\xA0csrf }}"/>\r\n</form>\r\n');
$templateCache.put('app/entities/instance-dbh/maintab/full.html','<div class="container-fluid container-fullw bg-white">\r\n    <div class="">\r\n        <div class="row">\r\n            <div class="col-sm-12 col-md-6 full-access-block">\r\n\r\n\r\n\r\n                <div  class="panel panel-info" ng-show="vm.sentRequest && vm.allowDemoOnly">\r\n                    <div class = "panel-heading">\r\n                     A Full Personalized Access Request has been Submitted. If you have submitted valid required information, Datasparc representative will contact you to enable\r\n                    full DBHawk access.\r\n                    </div>\r\n                </div>\r\n\r\n                <button type="button" ui-sref="instances.full_access" class="btn btn-wide btn-primary access-btn" ng-show="!vm.sentRequest && vm.allowDemoOnly">\r\n                    Request A Full Personalized Access\r\n                </button>\r\n\r\n                <button ng-show="!vm.allowDemoOnly"\r\n                        ng-click="vm.launchPersInstance()"\r\n                        class="btn btn-wide btn-primary access-btn">\r\n                    <span class="hidden-sm-down">Launch Personalized Instance</span>\r\n                </button>\r\n\r\n            </div>\r\n            <div class="col-sm-12 col-md-6 ptb-70 b-left">\r\n                <div class="col-sm-11 col-sm-offset-1">\r\n                    <h4 class="mb-1">With Full Access, I can:</h4>\r\n                    <div class="red-divider" style="margin:0px;"></div>\r\n                    <br>\r\n                    <div class="col-md-12 plr-0">\r\n                        <div class="row display-flex">\r\n                            <div class="col-md-1 pr-0">\r\n                                <img src="content/images/blue-dot.png" width="22">\r\n                            </div>\r\n                            <div class="col-md-11 pl-0">\r\n                                <span class="f-14">All Limited Access features</span>\r\n                            </div>\r\n                        </div>\r\n                        <div class="row display-flex">\r\n                            <div class="col-md-1 pr-0">\r\n                                <img src="content/images/blue-dot.png" width="22">\r\n                            </div>\r\n                            <div class="col-md-11 pl-0">\r\n                                <span class="f-14"><a ui-sref="documentation.id({id: \'item-1-10\'})">Create various SQL & NoSQL Data Sources</a></span>\r\n                            </div>\r\n                        </div>\r\n                        <div class="row display-flex">\r\n                            <div class="col-md-1 pr-0">\r\n                                <img src="content/images/blue-dot.png" width="22">\r\n                            </div>\r\n                            <div class="col-md-11 pl-0">\r\n                                <span class="f-14"><a ui-sref="documentation.id({id: \'item-1-11\'})">Setup Users & User Groups</a></span>\r\n                            </div>\r\n                        </div>\r\n                        <div class="row display-flex">\r\n                            <div class="col-md-1 pr-0">\r\n                                <img src="content/images/blue-dot.png" width="22">\r\n                            </div>\r\n                            <div class="col-md-11 pl-0">\r\n                                <span class="f-14"><a ui-sref="documentation.id({id: \'item-1-12\'})">Test DBHawk Object Access Control Policy to Restrict objects access</a></span>\r\n                            </div>\r\n                        </div>\r\n\t\t\t\t\t\t<!--\r\n                        <div class="row display-flex">\r\n                            <div class="col-md-1 pr-0">\r\n                                <img src="content/images/blue-dot.png" width="22">\r\n                            </div>\r\n                            <div class="col-md-11 pl-0">\r\n                                <span class="f-14">Test DBHawk data masking feature with ACL</span>\r\n                            </div>\r\n                        </div> -->\r\n                        <div class="row display-flex">\r\n                            <div class="col-md-1 pr-0">\r\n                                <img src="content/images/blue-dot.png" width="22">\r\n                            </div>\r\n                            <div class="col-md-11 pl-0">\r\n                                <span class="f-14"><a ui-sref="documentation.id({id: \'item-1-13\'})">Test DBHawk auditing feature to see users activities</a></span>\r\n                            </div>\r\n                        </div>\r\n                        <div class="row display-flex">\r\n                            <div class="col-md-1 pr-0">\r\n                                <img src="content/images/blue-dot.png" width="22">\r\n                            </div>\r\n                            <div class="col-md-11 pl-0">\r\n                                <span class="f-14">Connect with my databases & Access my data</span>\r\n                            </div>\r\n                        </div>\r\n                        <div class="row display-flex">\r\n                            <div class="col-md-1 pr-0">\r\n                                <img src="content/images/blue-dot.png" width="22">\r\n                            </div>\r\n                            <div class="col-md-11 pl-0">\r\n                                <span class="f-14">Full access to sample databases including Oracle, SQL Server, MySQL, Postgres, Redshift, MongoDB, Hive, Greenplum, Teradata</span>\r\n                            </div>\r\n                        </div>\r\n                        <div class="row display-flex">\r\n                            <div class="col-md-1 pr-0">\r\n                                <img src="content/images/blue-dot.png" width="22">\r\n                            </div>\r\n                            <div class="col-md-11 pl-0">\r\n                                <span class="f-14"><a ui-sref="documentation.id({id: \'item-1-14\'})">Integration For User management and SSO with SAML/OKTA/LDAP/ADFS</a></span>\r\n                            </div>\r\n                        </div>\r\n                        <div class="row display-flex">\r\n                            <div class="col-md-1 pr-0">\r\n                                <img src="content/images/blue-dot.png" width="22">\r\n                            </div>\r\n                            <div class="col-md-11 pl-0">\r\n                                <span class="f-14"><a ui-sref="documentation.id({id: \'item-1-16\'})">Test SQL job scheduler</a></span>\r\n                            </div>\r\n                        </div>\r\n                        <div class="row display-flex">\r\n                            <div class="col-md-1 pr-0">\r\n                                <img src="content/images/blue-dot.png" width="22">\r\n                            </div>\r\n                            <div class="col-md-11 pl-0">\r\n                                <span class="f-14"><a ui-sref="documentation.id({id: \'item-1-17\'})">Build charts, dashboards, reports, data snippets</a></span>\r\n                            </div>\r\n                        </div>\r\n\r\n\r\n                        <!--\r\n                         <div class="row display-flex">\r\n                            <div class="col-md-1 pr-0">\r\n                                <img src="content/images/blue-dot.png" width="22">\r\n                            </div>\r\n                            <div class="col-md-11 pl-0">\r\n                                <span class="f-14">Test DBHawk API Feature</span>\r\n                            </div>\r\n                        </div>  -->\r\n\r\n\r\n\r\n\r\n\r\n\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('app/entities/instance-dbh/maintab/limited.html','<div class="container-fluid container-fullw">\r\n    <div class="row flex-rows">\r\n        <div class="col-sm-12 col-md-6">\r\n            <div class="col-sm-12">\r\n                <div>\r\n                <div class="progress-wrapper">\r\n\r\n                    <div class="progress-svg" ng-style="getStyle()"><b>{{instance.license.daysRemain}} Days</b> <br/> Remaining\r\n                     </div>\r\n                <round-progress\r\n                    max="instance.trialDays"\r\n                    current="vm.dynamicValue"\r\n                    color="#FE6209"\r\n                    bgcolor="#007AFF"\r\n                    radius="100"\r\n                    stroke="20"\r\n                    semi="false"\r\n                    rounded="true"\r\n                    clockwise="true"\r\n                    responsive="false"\r\n                    duration="800"\r\n                    animation="easeInOutQuart"\r\n                    animation-delay="10"></round-progress>\r\n                </div>\r\n                </div>\r\n\r\n            </div>\r\n            <div class="col-sm-12 text-center">\r\n                <a type="button" class="btn btn-wide btn-primary btn-lg mt-40" ng-show="instance.license.daysRemain>0" ng-href="{{instance.urlOpen}}" ng-disabled="!instance.license.daysRemain>0" target="_blank">\r\n                    <i class="fa fa-cloud"></i> Access DBHawk\r\n                </a>\r\n            </div>\r\n        </div>\r\n        <div class="col-sm-12 col-md-6 ptb-70 b-left">\r\n            <div class="col-sm-11 col-sm-offset-1 plr-0">\r\n                <h4 class="mb-1">With Limited Access, I can: </h4>\r\n                <div class="red-divider" style="margin:0px;"></div>\r\n                <br>\r\n                <div class="col-md-12 plr-0">\r\n                    <div class="row display-flex">\r\n                        <div class="col-md-1 pr-0">\r\n                            <img src="content/images/blue-dot.png" width="22">\r\n                        </div>\r\n                        <div class="col-md-11 pl-0">\r\n                            <span class="f-14"><a ui-sref="documentation.id({id: \'item-1-1\'})">Connect to DBHawk as a regular user and Change Theme</a></span>\r\n                        </div>\r\n                    </div>\r\n                    <div class="row display-flex">\r\n                        <div class="col-md-1 pr-0">\r\n                            <img src="content/images/blue-dot.png" width="22">\r\n                        </div>\r\n                        <div class="col-md-11 pl-0">\r\n                            <span class="f-14"><a ui-sref="documentation.id({id: \'item-1-2\'})">Connect to MySQL, Postgres, MongoDB, MSSQL-Azure, Oracle,<br> Cassandra, Teradata sample databases</a></span>\r\n                        </div>\r\n                    </div>\r\n                    <div class="row display-flex">\r\n                        <div class="col-md-1 pr-0">\r\n                            <img src="content/images/blue-dot.png" width="22">\r\n                        </div>\r\n                        <div class="col-md-11 pl-0">\r\n                            <span class="f-14"><a ui-sref="documentation.id({id: \'item-1-3\'})">Browse database objects</a></span>\r\n                        </div>\r\n                    </div>\r\n                    <div class="row display-flex">\r\n                        <div class="col-md-1 pr-0">\r\n                            <img src="content/images/blue-dot.png" width="22">\r\n                        </div>\r\n                        <div class="col-md-11 pl-0">\r\n                            <span class="f-14"><a ui-sref="documentation.id({id: \'item-1-4\'})">View Table\'s data</a></span>\r\n                        </div>\r\n                    </div>\r\n                    <div class="row display-flex">\r\n                        <div class="col-md-1 pr-0">\r\n                            <img src="content/images/blue-dot.png" width="22">\r\n                        </div>\r\n                        <div class="col-md-11 pl-0">\r\n                            <span class="f-14"><a ui-sref="documentation.id({id: \'item-1-5\'})">Filter data</a></span>\r\n                        </div>\r\n                    </div>\r\n                    <div class="row display-flex">\r\n                        <div class="col-md-1 pr-0">\r\n                            <img src="content/images/blue-dot.png" width="22">\r\n                        </div>\r\n                        <div class="col-md-11 pl-0">\r\n                            <span class="f-14"><a ui-sref="documentation.id({id: \'item-1-6\'})">Export data in CSV, XLSX, HTML</a></span>\r\n                        </div>\r\n                    </div>\r\n                    <div class="row display-flex">\r\n                        <div class="col-md-1 pr-0">\r\n                            <img src="content/images/blue-dot.png" width="22">\r\n                        </div>\r\n                        <div class="col-md-11 pl-0">\r\n                            <span class="f-14"><a ui-sref="documentation.id({id: \'item-1-7\'})">Import Data</a></span>\r\n                        </div>\r\n                    </div>\r\n                    <div class="row display-flex">\r\n                        <div class="col-md-1 pr-0">\r\n                            <img src="content/images/blue-dot.png" width="22">\r\n                        </div>\r\n                        <div class="col-md-11 pl-0">\r\n                            <span class="f-14"><a ui-sref="documentation.id({id: \'item-1-8\'})">Use DBHawk Query Builder to build SQL Queries</a></span>\r\n                        </div>\r\n                    </div>\r\n                    <div class="row display-flex">\r\n                        <div class="col-md-1 pr-0">\r\n                            <img src="content/images/blue-dot.png" width="22">\r\n                        </div>\r\n                        <div class="col-md-11 pl-0">\r\n                            <span class="f-14"><a ui-sref="documentation.id({id: \'item-1-9\'})">Use DBHawk SQL Editor to write SQL Queries</a></span>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n');
$templateCache.put('app/entities/instance-dbh/tabs/addresses.html','\r\n<button class="btn btn-primary" ui-sref="instances.ipaddress({instanceId: instance.instanceId})" >\r\n    <span class="glyphicon glyphicon-plus"></span>\r\n    <span>Add IP Address</span>\r\n</button>\r\n<p></p>\r\n<table class="table table-striped"  >\r\n\r\n    <tr ng-repeat="ipAddress in ipAddresses">\r\n        <td data-title="\'IP Address\'" sortable="\'\'" class="text-center" header-class="\'text-left\'">{{ipAddress}}</td>\r\n        <td class="text-right">\r\n            <div class="btn-group flex-btn-group-container">\r\n                <button type="submit"\r\n                        ui-sref="instances.ipaddressdelete({instanceId: instance.instanceId, ipAddress: ipAddress})"\r\n                        class="btn btn-danger btn-sm">\r\n                    <span class="glyphicon glyphicon-remove-circle"></span>\r\n                    <span class="hidden-sm-down"></span>\r\n                    Delete\r\n                </button>\r\n            </div>\r\n        </td>\r\n    </tr>\r\n\r\n</table>\r\n\r\n');
$templateCache.put('app/entities/instance-dbh/tabs/details.html','<strong>CIDR: </strong>{{instance.cidrBlock}}<br/>\r\n<strong>Status: </strong>{{instance.status}}<br>\r\n<strong>Region: </strong>{{instance.region}}\r\n');
$templateCache.put('app/entities/instance-dbh/tabs/full-access.html','<div class="row display-flex">\r\n\t<div class="col-md-1 pr-0">\r\n\t\t<img src="content/images/active.png" width="27">\r\n\t</div>\r\n\t<div class="col-md-11 pl-0">\r\n\t\t<span class="f-16">All Limited Access features</span>\r\n\t</div>\r\n</div>\r\n<div class="admin-feature">\r\n\t<img  src="content/images/icon-plus.png" class="ml-120" width="32">\r\n</div>\r\n<div class="row display-flex">\r\n\t<div class="col-md-1 pr-0">\r\n\t\t<img src="content/images/active.png" width="27">\r\n\t</div>\r\n\t<div class="col-md-11 pl-0">\r\n\t\t<span class="f-16">Create various SQL & NoSQL Data Sources</span>\r\n\t</div>\r\n</div>\r\n<div class="row display-flex">\r\n\t<div class="col-md-1 pr-0">\r\n\t\t<img src="content/images/active.png" width="27">\r\n\t</div>\r\n\t<div class="col-md-11 pl-0">\r\n\t\t<span class="f-16">Setup Users & User Groups</span>\r\n\t</div>\r\n</div>\r\n<div class="row display-flex">\r\n\t<div class="col-md-1 pr-0">\r\n\t\t<img src="content/images/active.png" width="27">\r\n\t</div>\r\n\t<div class="col-md-11 pl-0">\r\n\t\t<span class="f-16">Test DBHawk Object Access Control Policy to Restrict objects access</span>\r\n\t</div>\r\n</div>\r\n<div class="row display-flex">\r\n\t<div class="col-md-1 pr-0">\r\n\t\t<img src="content/images/active.png" width="27">\r\n\t</div>\r\n\t<div class="col-md-11 pl-0">\r\n\t\t<span class="f-16">Test DBHawk data masking feature with ACL</span>\r\n\t</div>\r\n</div>\r\n<div class="row display-flex">\r\n\t<div class="col-md-1 pr-0">\r\n\t\t<img src="content/images/active.png" width="27">\r\n\t</div>\r\n\t<div class="col-md-11 pl-0">\r\n\t\t<span class="f-16">Test DBHawk auditing feature to see users activities</span>\r\n\t</div>\r\n</div>\r\n<div class="row display-flex">\r\n\t<div class="col-md-1 pr-0">\r\n\t\t<img src="content/images/active.png" width="27">\r\n\t</div>\r\n\t<div class="col-md-11 pl-0">\r\n\t\t<span class="f-16">Connect with my databases & Access my data</span>\r\n\t</div>\r\n</div>\r\n<div class="row display-flex">\r\n\t<div class="col-md-1 pr-0">\r\n\t\t<img src="content/images/active.png" width="27">\r\n\t</div>\r\n\t<div class="col-md-11 pl-0">\r\n\t\t<span class="f-16">Full access to sample databases including Oracle, SQL Server, MySQL, Postgres, Redshift, MongoDB, Hive, Greenplum, Teradata</span>\r\n\t</div>\r\n</div>\r\n<div class="row display-flex">\r\n\t<div class="col-md-1 pr-0">\r\n\t\t<img src="content/images/active.png" width="27">\r\n\t</div>\r\n\t<div class="col-md-11 pl-0">\r\n\t\t<span class="f-16">Integration For User management and SSO with SAML/OKTA/LDAP/ADFS</span>\r\n\t</div>\r\n</div>\r\n<div class="row display-flex">\r\n\t<div class="col-md-1 pr-0">\r\n\t\t<img src="content/images/active.png" width="27">\r\n\t</div>\r\n\t<div class="col-md-11 pl-0">\r\n\t\t<span class="f-16">Build charts, dashboards, reports, data snippets</span>\r\n\t</div>\r\n</div>\r\n<div class="row display-flex">\r\n\t<div class="col-md-1 pr-0">\r\n\t\t<img src="content/images/active.png" width="27">\r\n\t</div>\r\n\t<div class="col-md-11 pl-0">\r\n\t\t<span class="f-16">Test SQL job scheduler</span>\r\n\t</div>\r\n</div>\r\n<div class="row display-flex">\r\n\t<div class="col-md-1 pr-0">\r\n\t\t<img src="content/images/active.png" width="27">\r\n\t</div>\r\n\t<div class="col-md-11 pl-0">\r\n\t\t<span class="f-16">Test DBHawk API Feature</span>\r\n\t</div>\r\n</div>\r\n\r\n');
$templateCache.put('app/entities/instance-dbh/tabs/peering.html','\r\n<button class="btn btn-primary" ui-sref="instances.peering1({instanceId: instance.instanceId})" >\r\n    <span class="glyphicon glyphicon-plus"></span>\r\n    <span >\r\n                       Create VPC Peering\r\n                    </span>\r\n</button>\r\n<p></p>\r\n<table ng-table="tablePeeringParams" class="table table-striped"  >\r\n\r\n    <tr ng-repeat="peering in peerings ">\r\n        <td data-title="\'Peering ID\'" sortable="\'peeringId\'" class="text-center" header-class="\'text-left\'">{{peering.peeringId}}</td>\r\n        <td data-title="\'Peer Aws Account\'" sortable="\'awsAccount\'" class="text-center" header-class="\'text-left\'">{{peering.awsAccount}}</td>\r\n        <td data-title="\'Peer VPC\'" sortable="\'peerVpc\'" class="text-center" header-class="\'text-left\'">{{peering.peerVpc}}</td>\r\n        <td data-title="\'Status\'" sortable="\'status\'" class="text-center" header-class="\'text-left\'">{{peering.status}}</td>\r\n        <td class="text-right">\r\n            <div class="btn-group flex-btn-group-container" ng-if="peering.status!=\'deleted\'">\r\n                <button type="submit"\r\n                        ui-sref="instances.peeringdelete({id:peering.peeringId})"\r\n                        class="btn btn-danger btn-sm">\r\n                    <span class="glyphicon glyphicon-remove-circle"></span>\r\n                    <span class="hidden-sm-down"></span>\r\n                </button>\r\n            </div>\r\n        </td>\r\n    </tr>\r\n</table>\r\n\r\n');
$templateCache.put('app/entities/instance-dbh/tabs/subscriptions.html','<div class="table-responsive">\r\n    <table  ng-table="tableParams" class="jh-table table table-striped">\r\n        <tbody ng-switch on="vm.isSelected(subscriptionDbh)" ng-repeat="subscriptionDbh in vm.subscriptionDbhs track by subscriptionDbh.uuid">\r\n        <tr >\r\n            <td ng-click="vm.toggleRow(subscriptionDbh)"><span ng-show="!vm.isSelected(subscriptionDbh)"\r\n                                                               class="glyphicon glyphicon-chevron-right"></span> <span\r\n                ng-show="vm.isSelected(subscriptionDbh)" class="glyphicon glyphicon-chevron-down"></span></td>\r\n            <td data-title="\'ID\'" class="text-center" class="text-center" sortable="\'uuid\'">{{subscriptionDbh.uuid}}</td>\r\n            <td data-title="\'DHawk Id\'" class="text-center" class="text-center" sortable="\'instanceId\'">{{subscriptionDbh.instanceId}}</td>\r\n            <td data-title="\'Users\'" class="text-center" class="text-center" sortable="\'amount\'">{{subscriptionDbh.amount}}</td>\r\n            <td data-title="\'Created\'"  class="text-center" header-class="\'text-center\'" sortable="\'created\'">{{subscriptionDbh.created| date:\'medium\'}}</td>\r\n            <td data-title="\'Status\'" class="text-center" header-class="\'text-center\'" sortable="\'active\'">{{subscriptionDbh.active==true?\'Active\':\'Cancel Requested\'}}</td>\r\n            <td  class="text-center">\r\n\r\n                <button type="submit" ng-if="subscriptionDbh.active == true"\r\n                        ui-sref="subscription-dbh.delete({id:subscriptionDbh.uuid})"\r\n                        class="btn btn-danger btn-sm">\r\n                    <span class="glyphicon glyphicon-remove-circle"></span>\r\n                    <span class="hidden-sm-down">Cancel</span>\r\n                </button>\r\n            </td>\r\n\r\n        </tr>\r\n        <tr ng-switch-when="true">\r\n            <td colspan="6">\r\n                <div ng-include="\'app/entities/subscription-dbh/invoices.html\'"></div>\r\n            </td>\r\n        </tr>\r\n        </tbody>\r\n    </table>\r\n</div>\r\n');
$templateCache.put('app/entities/instance-dbh/tabs/users.html','\r\n<button ng-show="vm.showInviteUsersBtn"\r\n        ng-disabled="!vm.showInstancePanel"\r\n        ui-sref="instances.invite({company: vm.account.lastName, instance:instance.instanceId})"\r\n        class="btn btn-primary" >\r\n    <span class="glyphicon glyphicon-plus"></span>\r\n    <span class="hidden-sm-down">Invite Users</span>\r\n</button>\r\n<p></p>\r\n\r\n<label for="accept" class="accept-label" style="background: none">\r\n    <input type="checkbox" id="accept" ng-model="vm.showAllStatuses" >\r\n    Include in-active and deleted\r\n</label>\r\n<table ng-table="tableParams" class="table table-striped">\r\n    <tr ng-repeat="user in allUsers| filter: usersFilter">\r\n        <td data-title="\'ID\'" sortable="\'id\'">{{user.id}}</td>\r\n        <td data-title="\'Name\'" sortable="\'login\'">{{user.login}}</td>\r\n        <td data-title="\'Status\'" sortable="\'status\'">{{user.status}}</td>\r\n    </tr>\r\n</table>\r\n');
$templateCache.put('app/entities/instance-dbh/payment/card-form.html','<div id="inner_table_container">\r\n    <div class="row p-b-30">\r\n\r\n        <h1>New Subscription</h1>\r\n        <div class="red-divider" ></div>\r\n        <div class="col-xs-6 col-xs-offset-3 p-t-30">\r\n            <div class="alert alert-danger" ng-show="vm.error">\r\n                <strong>Payment failed!</strong>  Please try again later.\r\n            </div>\r\n\r\n            <div class="alert alert-danger" ng-show="vm.errorUsers">\r\n                <strong>Payment failed!</strong>  You are buying license with less number of users than current active users.\r\n                Please choose correct number of users or delete unwanted user/s from DBHawk\r\n            </div>\r\n\r\n            <div class="alert alert-danger" ng-show="cardError">\r\n                <strong>Card error!</strong> {{cardError}}.\r\n            </div>\r\n            <form id="payment-form" name="form" role="form" novalidate show-validation >\r\n\r\n                <div class="row p-0">\r\n                    <div class="col-xs-6 ">\r\n                        <div class="form-group">\r\n\r\n                            <label for="cname" data-tid="elements_examples.form.name_label">Contact Name</label>\r\n                            <input class="form-control" id="cname" name="cname" ng-model="vm.payment.name" ng-maxlength="50"\r\n                                   type="text" placeholder="Jane Doe" required="" ng-required="true" autocomplete="name">\r\n                            <div ng-show="form.cname.$dirty && form.cname.$invalid">\r\n                                <p class="help-block"\r\n                                   ng-show="form.cname.$error.required">\r\n                                    Your Contact Name is required.\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div class="col-xs-6 ">\r\n                        <div class="form-group">\r\n                            <label for="email" data-tid="elements_examples.form.email_label">Email</label>\r\n                            <input class="form-control" id="email" name="email"  ng-model="vm.payment.email"\r\n                                   type="email" placeholder="janedoe@gmail.com" required="" ng-required="true" ng-maxlength="50">\r\n                            <div ng-show="form.email.$dirty && form.email.$invalid">\r\n                                <p class="help-block"\r\n                                   ng-show="form.email.$error.required">\r\n                                    Your Email is required.\r\n                                </p>\r\n                                <p class="help-block"\r\n                                   ng-show="form.email.$error.email">\r\n                                    Your email is invalid.\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n\r\n                <div class="row p-0">\r\n                    <div class="col-xs-6 ">\r\n                        <div class="form-group">\r\n                            <label  >Postal code</label>\r\n                            <input id="postal-code" name="postal_code" type="text" class="form-control" ng-model="vm.payment.zip" placeholder="90210" ng-minlength="4" ng-maxlength="9" required ng-required="true"/>\r\n                        </div>\r\n                    </div>\r\n                    <div class="col-xs-6 ">\r\n                        <div class="form-group">\r\n                            <label for="example1-phone" data-tid="elements_examples.form.phone_label">Phone</label>\r\n                            <input class="form-control" id="example1-phone"  ng-model="vm.payment.phone"\r\n                                   type="tel" placeholder="(941) 555-0123"  autocomplete="tel" ng-maxlength="50">\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n\r\n                <div class="form-group">\r\n                    <label for="amount" >Count of Users</label>\r\n                    <input class="form-control" id="amount" name="amount" ng-model="vm.payment.amount" ng-pattern="/^-?[0-9][^\\.]*$/"\r\n                           type="number" placeholder="10" required="" ng-required="true" min="1" max="10">\r\n                    <div ng-show="form.amount.$dirty && form.amount.$invalid">\r\n                        <p class="help-block"\r\n                           ng-show="form.amount.$error.required">\r\n                            Count is required.\r\n                        </p>\r\n                        <p class="help-block"\r\n                           ng-show="form.amount.$error.min">\r\n                            Min value is 1\r\n                        </p>\r\n                        <p class="help-block"\r\n                           ng-show="form.amount.$error.max">\r\n                            Max value is 10\r\n                        </p>\r\n                        <p class="help-block"\r\n                           ng-show="form.amount.$error.pattern">\r\n                            Invalid Value\r\n                        </p>\r\n                    </div>\r\n                </div>\r\n\r\n\r\n\r\n                <h5>Payment Card Details</h5>\r\n\r\n                <div class="card-img">\r\n                    <img src="content/images/credit-card-icons-png.png"  alt="Card">\r\n                    <a href="https://stripe.com/" target="_blank"><img src="content/images/powered_by_stripe.png"  alt="Card"></a>\r\n\r\n                </div>\r\n                <div class="clearfix"></div>\r\n\r\n\r\n\r\n                <div class="row p-0">\r\n                    <div class="col-xs-6 ">\r\n                        <div class="form-group">\r\n                            <label  data-tid="elements_examples.form.phone_label">Card Number</label>\r\n                            <div id="card-number-element" class="field"></div>\r\n                        </div>\r\n                    </div>\r\n                    <div class="col-xs-6 ">\r\n                        <div class="row p-0">\r\n                            <div class="col-xs-6 ">\r\n                                <div class="form-group">\r\n                                    <label  data-tid="elements_examples.form.phone_label">Expiry Date</label>\r\n                                    <div id="card-expiry-element" class="field"></div>\r\n                                </div>\r\n                            </div>\r\n                            <div class="col-xs-6 ">\r\n                                <div class="form-group">\r\n                                    <label  data-tid="elements_examples.form.phone_label">CVC</label>\r\n                                    <div id="card-cvc-element" class="field"></div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n\r\n\r\n\r\n\r\n                <p>\r\n                    Subscription cost: <strong> &dollar; {{vm.payment.amount==1?vm.userPriceOne:(vm.userPrice * vm.payment.amount)}}/Month</strong>\r\n\r\n                </p>\r\n\r\n                <div class="outcome">\r\n\r\n                </div>\r\n\r\n                <button type="submit" ng-disabled="form.$invalid || vm.isSaving"\r\n                        class="btn btn-success">\r\n                    <span class="hidden-sm-down">Buy Subscription</span>\r\n                </button>\r\n            </form>\r\n        </div>\r\n    </div>\r\n    <!-- start: COPYRIGHT -->\r\n    <div ng-include="\'app/components/copyright/copyright.html\'"></div>\r\n    <!-- end: COPYRIGHT -->\r\n</div>\r\n');}]);})();